/* tslint:disable */
/* eslint-disable */
/**
 * API Mamarotte
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface APISuccessAbonnementCalendrierSchema
 */
export interface APISuccessAbonnementCalendrierSchema {
    /**
     * 
     * @type {number}
     * @memberof APISuccessAbonnementCalendrierSchema
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessAbonnementCalendrierSchema
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessAbonnementCalendrierSchema
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessAbonnementCalendrierSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {AbonnementCalendrierSchema}
     * @memberof APISuccessAbonnementCalendrierSchema
     */
    'data'?: AbonnementCalendrierSchema | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessAbonnementCalendrierSchema
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessAbsenceSchemaLite
 */
export interface APISuccessAbsenceSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessAbsenceSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessAbsenceSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessAbsenceSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessAbsenceSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {AbsenceSchemaLite}
     * @memberof APISuccessAbsenceSchemaLite
     */
    'data'?: AbsenceSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessAbsenceSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessActionSchemaLite
 */
export interface APISuccessActionSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessActionSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessActionSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessActionSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessActionSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {ActionSchemaLite}
     * @memberof APISuccessActionSchemaLite
     */
    'data'?: ActionSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessActionSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessAdhesionSchemaLite
 */
export interface APISuccessAdhesionSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessAdhesionSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessAdhesionSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessAdhesionSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessAdhesionSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {AdhesionSchemaLite}
     * @memberof APISuccessAdhesionSchemaLite
     */
    'data'?: AdhesionSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessAdhesionSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessBool
 */
export interface APISuccessBool {
    /**
     * 
     * @type {number}
     * @memberof APISuccessBool
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessBool
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessBool
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessBool
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessBool
     */
    'data'?: boolean | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessBool
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessCastingEvenementSchemaLite
 */
export interface APISuccessCastingEvenementSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessCastingEvenementSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessCastingEvenementSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessCastingEvenementSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessCastingEvenementSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {CastingEvenementSchemaLite}
     * @memberof APISuccessCastingEvenementSchemaLite
     */
    'data'?: CastingEvenementSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessCastingEvenementSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessCastingSchemaLite
 */
export interface APISuccessCastingSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessCastingSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessCastingSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessCastingSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessCastingSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {CastingSchemaLite}
     * @memberof APISuccessCastingSchemaLite
     */
    'data'?: CastingSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessCastingSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessCommentaireSchemaLite
 */
export interface APISuccessCommentaireSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessCommentaireSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessCommentaireSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessCommentaireSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessCommentaireSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {CommentaireSchemaLite}
     * @memberof APISuccessCommentaireSchemaLite
     */
    'data'?: CommentaireSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessCommentaireSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessCompagnieSchema
 */
export interface APISuccessCompagnieSchema {
    /**
     * 
     * @type {number}
     * @memberof APISuccessCompagnieSchema
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessCompagnieSchema
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessCompagnieSchema
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessCompagnieSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {CompagnieSchema}
     * @memberof APISuccessCompagnieSchema
     */
    'data'?: CompagnieSchema | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessCompagnieSchema
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessCompagnieSchemaLite
 */
export interface APISuccessCompagnieSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessCompagnieSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessCompagnieSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessCompagnieSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessCompagnieSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {CompagnieSchemaLite}
     * @memberof APISuccessCompagnieSchemaLite
     */
    'data'?: CompagnieSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessCompagnieSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessDebriefSchema
 */
export interface APISuccessDebriefSchema {
    /**
     * 
     * @type {number}
     * @memberof APISuccessDebriefSchema
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessDebriefSchema
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessDebriefSchema
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessDebriefSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {DebriefSchema}
     * @memberof APISuccessDebriefSchema
     */
    'data'?: DebriefSchema | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessDebriefSchema
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessDebriefSchemaLite
 */
export interface APISuccessDebriefSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessDebriefSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessDebriefSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessDebriefSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessDebriefSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {DebriefSchemaLite}
     * @memberof APISuccessDebriefSchemaLite
     */
    'data'?: DebriefSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessDebriefSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessEvenementSchemaLite
 */
export interface APISuccessEvenementSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessEvenementSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessEvenementSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessEvenementSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessEvenementSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {EvenementSchemaLite}
     * @memberof APISuccessEvenementSchemaLite
     */
    'data'?: EvenementSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessEvenementSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessInt
 */
export interface APISuccessInt {
    /**
     * 
     * @type {number}
     * @memberof APISuccessInt
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessInt
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessInt
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessInt
     */
    'message'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APISuccessInt
     */
    'data'?: number | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessInt
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListAbsenceSchemaLite
 */
export interface APISuccessListAbsenceSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListAbsenceSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListAbsenceSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListAbsenceSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListAbsenceSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<AbsenceSchemaLite>}
     * @memberof APISuccessListAbsenceSchemaLite
     */
    'data'?: Array<AbsenceSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListAbsenceSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListActionSchemaLite
 */
export interface APISuccessListActionSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListActionSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListActionSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListActionSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListActionSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<ActionSchemaLite>}
     * @memberof APISuccessListActionSchemaLite
     */
    'data'?: Array<ActionSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListActionSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListAdherentInvitableSchema
 */
export interface APISuccessListAdherentInvitableSchema {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListAdherentInvitableSchema
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListAdherentInvitableSchema
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListAdherentInvitableSchema
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListAdherentInvitableSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<AdherentInvitableSchema>}
     * @memberof APISuccessListAdherentInvitableSchema
     */
    'data'?: Array<AdherentInvitableSchema> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListAdherentInvitableSchema
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListAdhesionSchemaLite
 */
export interface APISuccessListAdhesionSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListAdhesionSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListAdhesionSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListAdhesionSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListAdhesionSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<AdhesionSchemaLite>}
     * @memberof APISuccessListAdhesionSchemaLite
     */
    'data'?: Array<AdhesionSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListAdhesionSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListCastingEvenementSchemaLite
 */
export interface APISuccessListCastingEvenementSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListCastingEvenementSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListCastingEvenementSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListCastingEvenementSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListCastingEvenementSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<CastingEvenementSchemaLite>}
     * @memberof APISuccessListCastingEvenementSchemaLite
     */
    'data'?: Array<CastingEvenementSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListCastingEvenementSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListCastingSchemaLite
 */
export interface APISuccessListCastingSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListCastingSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListCastingSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListCastingSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListCastingSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<CastingSchemaLite>}
     * @memberof APISuccessListCastingSchemaLite
     */
    'data'?: Array<CastingSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListCastingSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListCommentaireSchemaLite
 */
export interface APISuccessListCommentaireSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListCommentaireSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListCommentaireSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListCommentaireSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListCommentaireSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<CommentaireSchemaLite>}
     * @memberof APISuccessListCommentaireSchemaLite
     */
    'data'?: Array<CommentaireSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListCommentaireSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListCompagnieSchemaLite
 */
export interface APISuccessListCompagnieSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListCompagnieSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListCompagnieSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListCompagnieSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListCompagnieSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<CompagnieSchemaLite>}
     * @memberof APISuccessListCompagnieSchemaLite
     */
    'data'?: Array<CompagnieSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListCompagnieSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListDebriefSchemaLite
 */
export interface APISuccessListDebriefSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListDebriefSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListDebriefSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListDebriefSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListDebriefSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<DebriefSchemaLite>}
     * @memberof APISuccessListDebriefSchemaLite
     */
    'data'?: Array<DebriefSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListDebriefSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListEvenementAgendaSchema
 */
export interface APISuccessListEvenementAgendaSchema {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListEvenementAgendaSchema
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListEvenementAgendaSchema
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListEvenementAgendaSchema
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListEvenementAgendaSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<EvenementAgendaSchema>}
     * @memberof APISuccessListEvenementAgendaSchema
     */
    'data'?: Array<EvenementAgendaSchema> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListEvenementAgendaSchema
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListEvenementSchemaLite
 */
export interface APISuccessListEvenementSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListEvenementSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListEvenementSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListEvenementSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListEvenementSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<EvenementSchemaLite>}
     * @memberof APISuccessListEvenementSchemaLite
     */
    'data'?: Array<EvenementSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListEvenementSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListMembreSchemaLite
 */
export interface APISuccessListMembreSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListMembreSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListMembreSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListMembreSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListMembreSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<MembreSchemaLite>}
     * @memberof APISuccessListMembreSchemaLite
     */
    'data'?: Array<MembreSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListMembreSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListNotificationSchemaLite
 */
export interface APISuccessListNotificationSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListNotificationSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListNotificationSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListNotificationSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListNotificationSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<NotificationSchemaLite>}
     * @memberof APISuccessListNotificationSchemaLite
     */
    'data'?: Array<NotificationSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListNotificationSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListPartageSchemaLite
 */
export interface APISuccessListPartageSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListPartageSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListPartageSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListPartageSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListPartageSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<PartageSchemaLite>}
     * @memberof APISuccessListPartageSchemaLite
     */
    'data'?: Array<PartageSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListPartageSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListPersonneSchemaLite
 */
export interface APISuccessListPersonneSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListPersonneSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListPersonneSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListPersonneSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListPersonneSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<PersonneSchemaLite>}
     * @memberof APISuccessListPersonneSchemaLite
     */
    'data'?: Array<PersonneSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListPersonneSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListPieceAdaptationSchema
 */
export interface APISuccessListPieceAdaptationSchema {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListPieceAdaptationSchema
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListPieceAdaptationSchema
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListPieceAdaptationSchema
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListPieceAdaptationSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<PieceAdaptationSchema>}
     * @memberof APISuccessListPieceAdaptationSchema
     */
    'data'?: Array<PieceAdaptationSchema> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListPieceAdaptationSchema
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListPieceSchemaLite
 */
export interface APISuccessListPieceSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListPieceSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListPieceSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListPieceSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListPieceSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<PieceSchemaLite>}
     * @memberof APISuccessListPieceSchemaLite
     */
    'data'?: Array<PieceSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListPieceSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListProductionSchemaLite
 */
export interface APISuccessListProductionSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListProductionSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListProductionSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListProductionSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListProductionSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<ProductionSchemaLite>}
     * @memberof APISuccessListProductionSchemaLite
     */
    'data'?: Array<ProductionSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListProductionSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListRepereSchemaLite
 */
export interface APISuccessListRepereSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListRepereSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListRepereSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListRepereSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListRepereSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<RepereSchemaLite>}
     * @memberof APISuccessListRepereSchemaLite
     */
    'data'?: Array<RepereSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListRepereSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListRoleSchemaLite
 */
export interface APISuccessListRoleSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListRoleSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListRoleSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListRoleSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListRoleSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<RoleSchemaLite>}
     * @memberof APISuccessListRoleSchemaLite
     */
    'data'?: Array<RoleSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListRoleSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListSceneSchemaLite
 */
export interface APISuccessListSceneSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListSceneSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListSceneSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListSceneSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListSceneSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<SceneSchemaLite>}
     * @memberof APISuccessListSceneSchemaLite
     */
    'data'?: Array<SceneSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListSceneSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListSceneTravaillableSchema
 */
export interface APISuccessListSceneTravaillableSchema {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListSceneTravaillableSchema
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListSceneTravaillableSchema
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListSceneTravaillableSchema
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListSceneTravaillableSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<SceneTravaillableSchema>}
     * @memberof APISuccessListSceneTravaillableSchema
     */
    'data'?: Array<SceneTravaillableSchema> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListSceneTravaillableSchema
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessListTroupeSchemaLite
 */
export interface APISuccessListTroupeSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessListTroupeSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessListTroupeSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListTroupeSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessListTroupeSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<TroupeSchemaLite>}
     * @memberof APISuccessListTroupeSchemaLite
     */
    'data'?: Array<TroupeSchemaLite> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessListTroupeSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessMembreSchema
 */
export interface APISuccessMembreSchema {
    /**
     * 
     * @type {number}
     * @memberof APISuccessMembreSchema
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessMembreSchema
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessMembreSchema
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessMembreSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {MembreSchema}
     * @memberof APISuccessMembreSchema
     */
    'data'?: MembreSchema | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessMembreSchema
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessMembreSchemaLite
 */
export interface APISuccessMembreSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessMembreSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessMembreSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessMembreSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessMembreSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {MembreSchemaLite}
     * @memberof APISuccessMembreSchemaLite
     */
    'data'?: MembreSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessMembreSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessMoiSchema
 */
export interface APISuccessMoiSchema {
    /**
     * 
     * @type {number}
     * @memberof APISuccessMoiSchema
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessMoiSchema
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessMoiSchema
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessMoiSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {MoiSchema}
     * @memberof APISuccessMoiSchema
     */
    'data'?: MoiSchema | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessMoiSchema
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessNoneType
 */
export interface APISuccessNoneType {
    /**
     * 
     * @type {number}
     * @memberof APISuccessNoneType
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessNoneType
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessNoneType
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessNoneType
     */
    'message'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof APISuccessNoneType
     */
    'data'?: any | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessNoneType
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessNotificationSchemaLite
 */
export interface APISuccessNotificationSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessNotificationSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessNotificationSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessNotificationSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessNotificationSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {NotificationSchemaLite}
     * @memberof APISuccessNotificationSchemaLite
     */
    'data'?: NotificationSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessNotificationSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessParsedDocument
 */
export interface APISuccessParsedDocument {
    /**
     * 
     * @type {number}
     * @memberof APISuccessParsedDocument
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessParsedDocument
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessParsedDocument
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessParsedDocument
     */
    'message'?: string | null;
    /**
     * 
     * @type {ParsedDocument}
     * @memberof APISuccessParsedDocument
     */
    'data'?: ParsedDocument | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessParsedDocument
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessPartageSchemaLite
 */
export interface APISuccessPartageSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessPartageSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessPartageSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessPartageSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessPartageSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {PartageSchemaLite}
     * @memberof APISuccessPartageSchemaLite
     */
    'data'?: PartageSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessPartageSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessPieceSchema
 */
export interface APISuccessPieceSchema {
    /**
     * 
     * @type {number}
     * @memberof APISuccessPieceSchema
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessPieceSchema
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessPieceSchema
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessPieceSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {PieceSchema}
     * @memberof APISuccessPieceSchema
     */
    'data'?: PieceSchema | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessPieceSchema
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessPieceSchemaLite
 */
export interface APISuccessPieceSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessPieceSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessPieceSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessPieceSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessPieceSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {PieceSchemaLite}
     * @memberof APISuccessPieceSchemaLite
     */
    'data'?: PieceSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessPieceSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessPieceStatistiquesSchema
 */
export interface APISuccessPieceStatistiquesSchema {
    /**
     * 
     * @type {number}
     * @memberof APISuccessPieceStatistiquesSchema
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessPieceStatistiquesSchema
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessPieceStatistiquesSchema
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessPieceStatistiquesSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {PieceStatistiquesSchema}
     * @memberof APISuccessPieceStatistiquesSchema
     */
    'data'?: PieceStatistiquesSchema | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessPieceStatistiquesSchema
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessPreferencesMailSchema
 */
export interface APISuccessPreferencesMailSchema {
    /**
     * 
     * @type {number}
     * @memberof APISuccessPreferencesMailSchema
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessPreferencesMailSchema
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessPreferencesMailSchema
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessPreferencesMailSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {PreferencesMailSchema}
     * @memberof APISuccessPreferencesMailSchema
     */
    'data'?: PreferencesMailSchema | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessPreferencesMailSchema
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessProductionSchema
 */
export interface APISuccessProductionSchema {
    /**
     * 
     * @type {number}
     * @memberof APISuccessProductionSchema
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessProductionSchema
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessProductionSchema
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessProductionSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {ProductionSchema}
     * @memberof APISuccessProductionSchema
     */
    'data'?: ProductionSchema | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessProductionSchema
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessProductionSchemaLite
 */
export interface APISuccessProductionSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessProductionSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessProductionSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessProductionSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessProductionSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {ProductionSchemaLite}
     * @memberof APISuccessProductionSchemaLite
     */
    'data'?: ProductionSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessProductionSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessRegleRecurrenceSchemaLite
 */
export interface APISuccessRegleRecurrenceSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessRegleRecurrenceSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessRegleRecurrenceSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessRegleRecurrenceSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessRegleRecurrenceSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {RegleRecurrenceSchemaLite}
     * @memberof APISuccessRegleRecurrenceSchemaLite
     */
    'data'?: RegleRecurrenceSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessRegleRecurrenceSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessRoleSchemaLite
 */
export interface APISuccessRoleSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessRoleSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessRoleSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessRoleSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessRoleSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {RoleSchemaLite}
     * @memberof APISuccessRoleSchemaLite
     */
    'data'?: RoleSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessRoleSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessSceneSchemaLite
 */
export interface APISuccessSceneSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessSceneSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessSceneSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessSceneSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessSceneSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {SceneSchemaLite}
     * @memberof APISuccessSceneSchemaLite
     */
    'data'?: SceneSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessSceneSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessSuppressionCompteApercuSchema
 */
export interface APISuccessSuppressionCompteApercuSchema {
    /**
     * 
     * @type {number}
     * @memberof APISuccessSuppressionCompteApercuSchema
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessSuppressionCompteApercuSchema
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessSuppressionCompteApercuSchema
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessSuppressionCompteApercuSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {SuppressionCompteApercuSchema}
     * @memberof APISuccessSuppressionCompteApercuSchema
     */
    'data'?: SuppressionCompteApercuSchema | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessSuppressionCompteApercuSchema
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessTroupeSchema
 */
export interface APISuccessTroupeSchema {
    /**
     * 
     * @type {number}
     * @memberof APISuccessTroupeSchema
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessTroupeSchema
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessTroupeSchema
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessTroupeSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {TroupeSchema}
     * @memberof APISuccessTroupeSchema
     */
    'data'?: TroupeSchema | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessTroupeSchema
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessTroupeSchemaLite
 */
export interface APISuccessTroupeSchemaLite {
    /**
     * 
     * @type {number}
     * @memberof APISuccessTroupeSchemaLite
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessTroupeSchemaLite
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessTroupeSchemaLite
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessTroupeSchemaLite
     */
    'message'?: string | null;
    /**
     * 
     * @type {TroupeSchemaLite}
     * @memberof APISuccessTroupeSchemaLite
     */
    'data'?: TroupeSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessTroupeSchemaLite
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface APISuccessUnionRegleRecurrenceSchemaLiteNoneType
 */
export interface APISuccessUnionRegleRecurrenceSchemaLiteNoneType {
    /**
     * 
     * @type {number}
     * @memberof APISuccessUnionRegleRecurrenceSchemaLiteNoneType
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof APISuccessUnionRegleRecurrenceSchemaLiteNoneType
     */
    'success'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof APISuccessUnionRegleRecurrenceSchemaLiteNoneType
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof APISuccessUnionRegleRecurrenceSchemaLiteNoneType
     */
    'message'?: string | null;
    /**
     * 
     * @type {RegleRecurrenceSchemaLite}
     * @memberof APISuccessUnionRegleRecurrenceSchemaLiteNoneType
     */
    'data'?: RegleRecurrenceSchemaLite | null;
    /**
     * 
     * @type {Pagination}
     * @memberof APISuccessUnionRegleRecurrenceSchemaLiteNoneType
     */
    'pagination': Pagination | null;
}
/**
 * 
 * @export
 * @interface AbonnementCalendrierSchema
 */
export interface AbonnementCalendrierSchema {
    /**
     * 
     * @type {string}
     * @memberof AbonnementCalendrierSchema
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface AbsenceFormCreate
 */
export interface AbsenceFormCreate {
    /**
     * 
     * @type {string}
     * @memberof AbsenceFormCreate
     */
    'commentaire': string | null;
}
/**
 * 
 * @export
 * @interface AbsenceFormUpdate
 */
export interface AbsenceFormUpdate {
    /**
     * 
     * @type {string}
     * @memberof AbsenceFormUpdate
     */
    'commentaire': string | null;
}
/**
 * 
 * @export
 * @interface AbsenceSchemaLite
 */
export interface AbsenceSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof AbsenceSchemaLite
     */
    'evenement_id': string;
    /**
     * 
     * @type {string}
     * @memberof AbsenceSchemaLite
     */
    'membre_id': string;
    /**
     * 
     * @type {string}
     * @memberof AbsenceSchemaLite
     */
    'commentaire': string | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceSchemaLite
     */
    'declared_at': string;
    /**
     * 
     * @type {EvenementSchemaLite}
     * @memberof AbsenceSchemaLite
     */
    'evenement': EvenementSchemaLite;
    /**
     * 
     * @type {MembreSchemaLite}
     * @memberof AbsenceSchemaLite
     */
    'membre': MembreSchemaLite;
}
/**
 * 
 * @export
 * @interface ActionFormCreate
 */
export interface ActionFormCreate {
    /**
     * 
     * @type {string}
     * @memberof ActionFormCreate
     */
    'scene_id': string;
    /**
     * 
     * @type {ActionType}
     * @memberof ActionFormCreate
     */
    'type': ActionType;
    /**
     * 
     * @type {number}
     * @memberof ActionFormCreate
     */
    'ordre': number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ActionFormCreate
     */
    'data': { [key: string]: any; };
}


/**
 * 
 * @export
 * @interface ActionFormUpdate
 */
export interface ActionFormUpdate {
    /**
     * 
     * @type {ActionType}
     * @memberof ActionFormUpdate
     */
    'type': ActionType;
    /**
     * 
     * @type {number}
     * @memberof ActionFormUpdate
     */
    'ordre': number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ActionFormUpdate
     */
    'data': { [key: string]: any; };
}


/**
 * Scène d\'arrivée, de la même pièce, et rang qu\'y prend l\'action (au-delà de la fin : la dernière).
 * @export
 * @interface ActionPositionForm
 */
export interface ActionPositionForm {
    /**
     * 
     * @type {string}
     * @memberof ActionPositionForm
     */
    'scene_id': string;
    /**
     * 
     * @type {number}
     * @memberof ActionPositionForm
     */
    'ordre': number;
}
/**
 * 
 * @export
 * @interface ActionRoleForm
 */
export interface ActionRoleForm {
    /**
     * 
     * @type {string}
     * @memberof ActionRoleForm
     */
    'role_id': string;
    /**
     * 
     * @type {string}
     * @memberof ActionRoleForm
     */
    'personnage'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionRoleSchemaLite
 */
export interface ActionRoleSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof ActionRoleSchemaLite
     */
    'action_id': string;
    /**
     * 
     * @type {string}
     * @memberof ActionRoleSchemaLite
     */
    'role_id': string;
    /**
     * 
     * @type {string}
     * @memberof ActionRoleSchemaLite
     */
    'personnage': string | null;
    /**
     * 
     * @type {RoleSchemaLite}
     * @memberof ActionRoleSchemaLite
     */
    'role': RoleSchemaLite;
}
/**
 * 
 * @export
 * @interface ActionRolesUpdate
 */
export interface ActionRolesUpdate {
    /**
     * 
     * @type {Array<ActionRoleForm>}
     * @memberof ActionRolesUpdate
     */
    'roles': Array<ActionRoleForm>;
}
/**
 * 
 * @export
 * @interface ActionSchemaLite
 */
export interface ActionSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof ActionSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ActionSchemaLite
     */
    'scene_id': string;
    /**
     * 
     * @type {ActionType}
     * @memberof ActionSchemaLite
     */
    'type': ActionType;
    /**
     * 
     * @type {number}
     * @memberof ActionSchemaLite
     */
    'ordre': number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ActionSchemaLite
     */
    'data': { [key: string]: any; };
    /**
     * 
     * @type {Array<ActionRoleSchemaLite>}
     * @memberof ActionSchemaLite
     */
    'action_roles': Array<ActionRoleSchemaLite>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ActionType = {
    Replique: 'REPLIQUE',
    Didascalie: 'DIDASCALIE',
    Transition: 'TRANSITION',
    Musique: 'MUSIQUE'
} as const;

export type ActionType = typeof ActionType[keyof typeof ActionType];


/**
 * 
 * @export
 * @interface AdherentInvitableSchema
 */
export interface AdherentInvitableSchema {
    /**
     * 
     * @type {string}
     * @memberof AdherentInvitableSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdherentInvitableSchema
     */
    'nom': string;
    /**
     * 
     * @type {string}
     * @memberof AdherentInvitableSchema
     */
    'joined_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdherentInvitableSchema
     */
    'avatar_version': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdherentInvitableSchema
     */
    'habitue'?: boolean;
    /**
     * Faux tant qu\'une personne invitée n\'a pas créé son compte.
     * @type {boolean}
     * @memberof AdherentInvitableSchema
     */
    'inscrite': boolean;
}
/**
 * 
 * @export
 * @interface AdhesionFormCreate
 */
export interface AdhesionFormCreate {
    /**
     * 
     * @type {string}
     * @memberof AdhesionFormCreate
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdhesionFormCreate
     */
    'can_edit'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdhesionFormCreate
     */
    'troupe_ids'?: Array<string>;
}
/**
 * Champs absents : inchangés.
 * @export
 * @interface AdhesionFormUpdate
 */
export interface AdhesionFormUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof AdhesionFormUpdate
     */
    'can_edit'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdhesionFormUpdate
     */
    'troupe_ids'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface AdhesionSchemaLite
 */
export interface AdhesionSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof AdhesionSchemaLite
     */
    'compagnie_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdhesionSchemaLite
     */
    'personne_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdhesionSchemaLite
     */
    'can_edit': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdhesionSchemaLite
     */
    'troupe_ids': Array<string>;
    /**
     * 
     * @type {PersonneSchemaLite}
     * @memberof AdhesionSchemaLite
     */
    'personne': PersonneSchemaLite;
    /**
     * 
     * @type {string}
     * @memberof AdhesionSchemaLite
     */
    'email': string | null;
}
/**
 * 
 * @export
 * @interface BlocageSchema
 */
export interface BlocageSchema {
    /**
     * 
     * @type {BlocageSuppressionCompte}
     * @memberof BlocageSchema
     */
    'type': BlocageSuppressionCompte;
    /**
     * 
     * @type {string}
     * @memberof BlocageSchema
     */
    'nom': string;
}


/**
 * Ce qui empêche une personne de supprimer son compte : elle le porte pour d\'autres.
 * @export
 * @enum {string}
 */

export const BlocageSuppressionCompte = {
    DernierGestionnaire: 'DERNIER_GESTIONNAIRE',
    DernierResponsable: 'DERNIER_RESPONSABLE',
    PieceMontee: 'PIECE_MONTEE',
    CompagnieAvecProductions: 'COMPAGNIE_AVEC_PRODUCTIONS'
} as const;

export type BlocageSuppressionCompte = typeof BlocageSuppressionCompte[keyof typeof BlocageSuppressionCompte];


/**
 * 
 * @export
 * @interface CastingEvenementFormCreate
 */
export interface CastingEvenementFormCreate {
    /**
     * 
     * @type {string}
     * @memberof CastingEvenementFormCreate
     */
    'casting_id': string;
    /**
     * 
     * @type {string}
     * @memberof CastingEvenementFormCreate
     */
    'evenement_id': string;
}
/**
 * 
 * @export
 * @interface CastingEvenementSchemaLite
 */
export interface CastingEvenementSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof CastingEvenementSchemaLite
     */
    'casting_id': string;
    /**
     * 
     * @type {string}
     * @memberof CastingEvenementSchemaLite
     */
    'evenement_id': string;
    /**
     * 
     * @type {CastingSchemaLite}
     * @memberof CastingEvenementSchemaLite
     */
    'casting': CastingSchemaLite;
    /**
     * 
     * @type {EvenementSchemaLite}
     * @memberof CastingEvenementSchemaLite
     */
    'evenement': EvenementSchemaLite;
}
/**
 * 
 * @export
 * @interface CastingFormCreate
 */
export interface CastingFormCreate {
    /**
     * 
     * @type {string}
     * @memberof CastingFormCreate
     */
    'role_id': string;
    /**
     * 
     * @type {string}
     * @memberof CastingFormCreate
     */
    'membre_id': string;
    /**
     * 
     * @type {string}
     * @memberof CastingFormCreate
     */
    'evenement_id'?: string | null;
}
/**
 * 
 * @export
 * @interface CastingSchemaLite
 */
export interface CastingSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof CastingSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CastingSchemaLite
     */
    'membre_id': string;
    /**
     * 
     * @type {string}
     * @memberof CastingSchemaLite
     */
    'role_id': string;
    /**
     * 
     * @type {MembreSchemaLite}
     * @memberof CastingSchemaLite
     */
    'membre': MembreSchemaLite;
    /**
     * 
     * @type {RoleSchemaLite}
     * @memberof CastingSchemaLite
     */
    'role': RoleSchemaLite;
}
/**
 * 
 * @export
 * @interface CollaborateurSchema
 */
export interface CollaborateurSchema {
    /**
     * 
     * @type {string}
     * @memberof CollaborateurSchema
     */
    'personne_id': string;
    /**
     * 
     * @type {string}
     * @memberof CollaborateurSchema
     */
    'nom': string;
}
/**
 * 
 * @export
 * @interface CommentaireFormCreate
 */
export interface CommentaireFormCreate {
    /**
     * 
     * @type {string}
     * @memberof CommentaireFormCreate
     */
    'scene_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentaireFormCreate
     */
    'action_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentaireFormCreate
     */
    'contenu': string;
}
/**
 * 
 * @export
 * @interface CommentaireFormUpdate
 */
export interface CommentaireFormUpdate {
    /**
     * 
     * @type {string}
     * @memberof CommentaireFormUpdate
     */
    'contenu': string;
}
/**
 * 
 * @export
 * @interface CommentaireSchemaLite
 */
export interface CommentaireSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof CommentaireSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CommentaireSchemaLite
     */
    'scene_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentaireSchemaLite
     */
    'action_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentaireSchemaLite
     */
    'auteur_id': string;
    /**
     * 
     * @type {string}
     * @memberof CommentaireSchemaLite
     */
    'contenu': string;
    /**
     * 
     * @type {string}
     * @memberof CommentaireSchemaLite
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof CommentaireSchemaLite
     */
    'updated_at': string;
    /**
     * 
     * @type {ActionSchemaLite}
     * @memberof CommentaireSchemaLite
     */
    'action': ActionSchemaLite | null;
}
/**
 * 
 * @export
 * @interface CompagnieFormCreate
 */
export interface CompagnieFormCreate {
    /**
     * 
     * @type {string}
     * @memberof CompagnieFormCreate
     */
    'nom': string;
    /**
     * 
     * @type {string}
     * @memberof CompagnieFormCreate
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface CompagnieFormUpdate
 */
export interface CompagnieFormUpdate {
    /**
     * 
     * @type {string}
     * @memberof CompagnieFormUpdate
     */
    'nom': string;
    /**
     * 
     * @type {string}
     * @memberof CompagnieFormUpdate
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface CompagnieSchema
 */
export interface CompagnieSchema {
    /**
     * 
     * @type {string}
     * @memberof CompagnieSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CompagnieSchema
     */
    'nom': string;
    /**
     * 
     * @type {string}
     * @memberof CompagnieSchema
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof CompagnieSchema
     */
    'logo_version'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompagnieSchema
     */
    'can_edit'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompagnieSchema
     */
    'adherent'?: boolean | null;
    /**
     * 
     * @type {Array<TroupeSchemaLite>}
     * @memberof CompagnieSchema
     */
    'troupes': Array<TroupeSchemaLite>;
}
/**
 * 
 * @export
 * @interface CompagnieSchemaLite
 */
export interface CompagnieSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof CompagnieSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CompagnieSchemaLite
     */
    'nom': string;
    /**
     * 
     * @type {string}
     * @memberof CompagnieSchemaLite
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof CompagnieSchemaLite
     */
    'logo_version'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompagnieSchemaLite
     */
    'can_edit'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompagnieSchemaLite
     */
    'adherent'?: boolean | null;
}
/**
 * Côtés de scène usuels d\'une entrée ou d\'une sortie, vu de la salle : cour à droite, jardin à gauche. Tout autre côté (lointain, public, porte du fond…) est un libellé libre, propre au décor.
 * @export
 * @enum {string}
 */

export const Cote = {
    Cour: 'COUR',
    Jardin: 'JARDIN'
} as const;

export type Cote = typeof Cote[keyof typeof Cote];


/**
 * 
 * @export
 * @interface DebriefFormCreate
 */
export interface DebriefFormCreate {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DebriefFormCreate
     */
    'contenu': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface DebriefFormUpdate
 */
export interface DebriefFormUpdate {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DebriefFormUpdate
     */
    'contenu': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface DebriefSchema
 */
export interface DebriefSchema {
    /**
     * 
     * @type {string}
     * @memberof DebriefSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DebriefSchema
     */
    'auteur_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof DebriefSchema
     */
    'evenement_id': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DebriefSchema
     */
    'contenu': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof DebriefSchema
     */
    'created_at': string;
    /**
     * 
     * @type {MembreSchemaLite}
     * @memberof DebriefSchema
     */
    'auteur': MembreSchemaLite | null;
    /**
     * 
     * @type {EvenementSchemaLite}
     * @memberof DebriefSchema
     */
    'evenement': EvenementSchemaLite;
}
/**
 * 
 * @export
 * @interface DebriefSchemaLite
 */
export interface DebriefSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof DebriefSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DebriefSchemaLite
     */
    'auteur_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof DebriefSchemaLite
     */
    'evenement_id': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DebriefSchemaLite
     */
    'contenu': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof DebriefSchemaLite
     */
    'created_at': string;
    /**
     * 
     * @type {MembreSchemaLite}
     * @memberof DebriefSchemaLite
     */
    'auteur': MembreSchemaLite | null;
    /**
     * 
     * @type {EvenementSchemaLite}
     * @memberof DebriefSchemaLite
     */
    'evenement': EvenementSchemaLite;
}
/**
 * 
 * @export
 * @interface ElementSchema
 */
export interface ElementSchema {
    /**
     * 
     * @type {string}
     * @memberof ElementSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ElementSchema
     */
    'nom': string;
}
/**
 * Événement d\'une liste vue par une personne : `absent` dit si elle y a déclaré son absence ; `absents` nomme les autres absents, renseigné pour un gestionnaire seulement (agenda de l\'accueil).
 * @export
 * @interface EvenementAgendaSchema
 */
export interface EvenementAgendaSchema {
    /**
     * 
     * @type {string}
     * @memberof EvenementAgendaSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvenementAgendaSchema
     */
    'production_id': string;
    /**
     * 
     * @type {string}
     * @memberof EvenementAgendaSchema
     */
    'regle_recurrence_id': string | null;
    /**
     * 
     * @type {EvenementType}
     * @memberof EvenementAgendaSchema
     */
    'type': EvenementType;
    /**
     * 
     * @type {string}
     * @memberof EvenementAgendaSchema
     */
    'date_heure': string;
    /**
     * 
     * @type {string}
     * @memberof EvenementAgendaSchema
     */
    'lieu': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvenementAgendaSchema
     */
    'consignes': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvenementAgendaSchema
     */
    'heure_convocation': string | null;
    /**
     * 
     * @type {ProductionSchemaLite}
     * @memberof EvenementAgendaSchema
     */
    'production': ProductionSchemaLite;
    /**
     * 
     * @type {boolean}
     * @memberof EvenementAgendaSchema
     */
    'absent'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof EvenementAgendaSchema
     */
    'absents'?: Array<string>;
}


/**
 * 
 * @export
 * @interface EvenementFormCreate
 */
export interface EvenementFormCreate {
    /**
     * 
     * @type {string}
     * @memberof EvenementFormCreate
     */
    'production_id': string;
    /**
     * 
     * @type {EvenementType}
     * @memberof EvenementFormCreate
     */
    'type': EvenementType;
    /**
     * 
     * @type {string}
     * @memberof EvenementFormCreate
     */
    'date_heure': string;
    /**
     * 
     * @type {string}
     * @memberof EvenementFormCreate
     */
    'lieu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EvenementFormCreate
     */
    'consignes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EvenementFormCreate
     */
    'heure_convocation'?: string | null;
}


/**
 * Seuls les champs envoyés sont modifiés ; null efface (lieu, consignes, convocation), type et date sont requis.
 * @export
 * @interface EvenementFormUpdate
 */
export interface EvenementFormUpdate {
    /**
     * 
     * @type {EvenementType}
     * @memberof EvenementFormUpdate
     */
    'type'?: EvenementType | null;
    /**
     * 
     * @type {string}
     * @memberof EvenementFormUpdate
     */
    'date_heure'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EvenementFormUpdate
     */
    'lieu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EvenementFormUpdate
     */
    'consignes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EvenementFormUpdate
     */
    'heure_convocation'?: string | null;
}


/**
 * 
 * @export
 * @interface EvenementSchemaLite
 */
export interface EvenementSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof EvenementSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvenementSchemaLite
     */
    'production_id': string;
    /**
     * 
     * @type {string}
     * @memberof EvenementSchemaLite
     */
    'regle_recurrence_id': string | null;
    /**
     * 
     * @type {EvenementType}
     * @memberof EvenementSchemaLite
     */
    'type': EvenementType;
    /**
     * 
     * @type {string}
     * @memberof EvenementSchemaLite
     */
    'date_heure': string;
    /**
     * 
     * @type {string}
     * @memberof EvenementSchemaLite
     */
    'lieu': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvenementSchemaLite
     */
    'consignes': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvenementSchemaLite
     */
    'heure_convocation': string | null;
    /**
     * 
     * @type {ProductionSchemaLite}
     * @memberof EvenementSchemaLite
     */
    'production': ProductionSchemaLite;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const EvenementType = {
    Repetition: 'REPETITION',
    Representation: 'REPRESENTATION',
    Filage: 'FILAGE',
    Generale: 'GENERALE'
} as const;

export type EvenementType = typeof EvenementType[keyof typeof EvenementType];


/**
 * 
 * @export
 * @enum {string}
 */

export const FonctionType = {
    MetteurEnScene: 'METTEUR_EN_SCENE',
    Comedien: 'COMEDIEN',
    Technicien: 'TECHNICIEN'
} as const;

export type FonctionType = typeof FonctionType[keyof typeof FonctionType];


/**
 * 
 * @export
 * @enum {string}
 */

export const FrequenceRecurrence = {
    ToutesLesSemaines: 'TOUTES_LES_SEMAINES',
    UneSurDeux: 'UNE_SUR_DEUX'
} as const;

export type FrequenceRecurrence = typeof FrequenceRecurrence[keyof typeof FrequenceRecurrence];


/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * Décisions prises à l\'étape Révision, appliquées à l\'aperçu avant enregistrement.
 * @export
 * @interface ImportCorrectionsSchema
 */
export interface ImportCorrectionsSchema {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ImportCorrectionsSchema
     */
    'fusions'?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportCorrectionsSchema
     */
    'non_roles'?: Array<string>;
}
/**
 * Texte déjà présent sur la pièce, remplacé par l\'import.
 * @export
 * @interface ImportExistant
 */
export interface ImportExistant {
    /**
     * 
     * @type {number}
     * @memberof ImportExistant
     */
    'scenes': number;
    /**
     * 
     * @type {number}
     * @memberof ImportExistant
     */
    'commentaires': number;
    /**
     * 
     * @type {number}
     * @memberof ImportExistant
     */
    'medias'?: number;
    /**
     * 
     * @type {Array<ImportRoleExistant>}
     * @memberof ImportExistant
     */
    'roles': Array<ImportRoleExistant>;
}
/**
 * 
 * @export
 * @interface ImportRoleExistant
 */
export interface ImportRoleExistant {
    /**
     * 
     * @type {string}
     * @memberof ImportRoleExistant
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ImportRoleExistant
     */
    'nom': string;
    /**
     * 
     * @type {number}
     * @memberof ImportRoleExistant
     */
    'castings': number;
}
/**
 * 
 * @export
 * @interface Invitations
 */
export interface Invitations {
    /**
     * 
     * @type {Array<PendingMembre>}
     * @memberof Invitations
     */
    'membres': Array<PendingMembre>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const JourSemaine = {
    Lundi: 'lundi',
    Mardi: 'mardi',
    Mercredi: 'mercredi',
    Jeudi: 'jeudi',
    Vendredi: 'vendredi',
    Samedi: 'samedi',
    Dimanche: 'dimanche'
} as const;

export type JourSemaine = typeof JourSemaine[keyof typeof JourSemaine];


/**
 * Média d\'une action MUSIQUE ; en minuscules, c\'est aussi sa clé dans actions.data et son dossier.
 * @export
 * @enum {string}
 */

export const MediaKind = {
    Audio: 'AUDIO',
    Video: 'VIDEO',
    Partition: 'PARTITION'
} as const;

export type MediaKind = typeof MediaKind[keyof typeof MediaKind];


/**
 * 
 * @export
 * @interface MembreFormUpdate
 */
export interface MembreFormUpdate {
    /**
     * 
     * @type {FonctionType}
     * @memberof MembreFormUpdate
     */
    'fonction': FonctionType;
    /**
     * 
     * @type {boolean}
     * @memberof MembreFormUpdate
     */
    'can_edit': boolean;
}


/**
 * 
 * @export
 * @interface MembreSchema
 */
export interface MembreSchema {
    /**
     * 
     * @type {string}
     * @memberof MembreSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MembreSchema
     */
    'personne_id': string;
    /**
     * 
     * @type {string}
     * @memberof MembreSchema
     */
    'production_id': string;
    /**
     * 
     * @type {FonctionType}
     * @memberof MembreSchema
     */
    'fonction': FonctionType;
    /**
     * 
     * @type {boolean}
     * @memberof MembreSchema
     */
    'can_edit': boolean;
    /**
     * 
     * @type {PersonneSchemaLite}
     * @memberof MembreSchema
     */
    'personne': PersonneSchemaLite;
    /**
     * 
     * @type {ProductionSchemaLite}
     * @memberof MembreSchema
     */
    'production': ProductionSchemaLite;
    /**
     * 
     * @type {Array<CastingSchemaLite>}
     * @memberof MembreSchema
     */
    'castings': Array<CastingSchemaLite>;
    /**
     * 
     * @type {Array<DebriefSchemaLite>}
     * @memberof MembreSchema
     */
    'debriefs': Array<DebriefSchemaLite>;
    /**
     * 
     * @type {Array<CommentaireSchemaLite>}
     * @memberof MembreSchema
     */
    'commentaires': Array<CommentaireSchemaLite>;
    /**
     * 
     * @type {Array<NotificationSchemaLite>}
     * @memberof MembreSchema
     */
    'notifications': Array<NotificationSchemaLite>;
}


/**
 * 
 * @export
 * @interface MembreSchemaLite
 */
export interface MembreSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof MembreSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MembreSchemaLite
     */
    'personne_id': string;
    /**
     * 
     * @type {string}
     * @memberof MembreSchemaLite
     */
    'production_id': string;
    /**
     * 
     * @type {FonctionType}
     * @memberof MembreSchemaLite
     */
    'fonction': FonctionType;
    /**
     * 
     * @type {boolean}
     * @memberof MembreSchemaLite
     */
    'can_edit': boolean;
    /**
     * 
     * @type {PersonneSchemaLite}
     * @memberof MembreSchemaLite
     */
    'personne': PersonneSchemaLite;
    /**
     * 
     * @type {ProductionSchemaLite}
     * @memberof MembreSchemaLite
     */
    'production': ProductionSchemaLite;
}


/**
 * La personne connectée : la seule à recevoir son propre email.
 * @export
 * @interface MoiSchema
 */
export interface MoiSchema {
    /**
     * 
     * @type {string}
     * @memberof MoiSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MoiSchema
     */
    'nom': string;
    /**
     * 
     * @type {string}
     * @memberof MoiSchema
     */
    'joined_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof MoiSchema
     */
    'avatar_version': string | null;
    /**
     * 
     * @type {string}
     * @memberof MoiSchema
     */
    'email': string;
    /**
     * Faux tant qu\'une personne invitée n\'a pas créé son compte.
     * @type {boolean}
     * @memberof MoiSchema
     */
    'inscrite': boolean;
}
/**
 * 
 * @export
 * @interface NotificationSchemaLite
 */
export interface NotificationSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof NotificationSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationSchemaLite
     */
    'membre_id': string;
    /**
     * 
     * @type {NotificationType}
     * @memberof NotificationSchemaLite
     */
    'type': NotificationType;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSchemaLite
     */
    'lu': boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationSchemaLite
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationSchemaLite
     */
    'production_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationSchemaLite
     */
    'debrief_id': string | null;
    /**
     * 
     * @type {MembreSchemaLite}
     * @memberof NotificationSchemaLite
     */
    'membre': MembreSchemaLite;
    /**
     * 
     * @type {ProductionSchemaLite}
     * @memberof NotificationSchemaLite
     */
    'production': ProductionSchemaLite | null;
    /**
     * 
     * @type {DebriefSchemaLite}
     * @memberof NotificationSchemaLite
     */
    'debrief': DebriefSchemaLite | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationType = {
    Invitation: 'INVITATION',
    Debrief: 'DEBRIEF',
    EvenementDeplace: 'EVENEMENT_DEPLACE',
    EvenementAnnule: 'EVENEMENT_ANNULE',
    CompteSupprime: 'COMPTE_SUPPRIME'
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


/**
 * 
 * @export
 * @interface Pagination
 */
export interface Pagination {
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    'current_page': number;
    /**
     * 
     * @type {boolean}
     * @memberof Pagination
     */
    'has_next': boolean;
}
/**
 * 
 * @export
 * @interface ParsedAction
 */
export interface ParsedAction {
    /**
     * 
     * @type {ActionType}
     * @memberof ParsedAction
     */
    'type': ActionType;
    /**
     * 
     * @type {number}
     * @memberof ParsedAction
     */
    'ordre': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParsedAction
     */
    'roles': Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ParsedAction
     */
    'personnages'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ParsedAction
     */
    'data': { [key: string]: any; };
}


/**
 * 
 * @export
 * @interface ParsedDistributionEntry
 */
export interface ParsedDistributionEntry {
    /**
     * 
     * @type {string}
     * @memberof ParsedDistributionEntry
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof ParsedDistributionEntry
     */
    'comedien': string | null;
}
/**
 * 
 * @export
 * @interface ParsedDocument
 */
export interface ParsedDocument {
    /**
     * 
     * @type {Array<ParsedScene>}
     * @memberof ParsedDocument
     */
    'scenes': Array<ParsedScene>;
    /**
     * 
     * @type {Array<ParsedRole>}
     * @memberof ParsedDocument
     */
    'roles': Array<ParsedRole>;
    /**
     * 
     * @type {Array<ParsedDistributionEntry>}
     * @memberof ParsedDocument
     */
    'distribution'?: Array<ParsedDistributionEntry>;
    /**
     * 
     * @type {Array<ParserWarning>}
     * @memberof ParsedDocument
     */
    'warnings': Array<ParserWarning>;
    /**
     * 
     * @type {ImportExistant}
     * @memberof ParsedDocument
     */
    'existant'?: ImportExistant | null;
}
/**
 * 
 * @export
 * @interface ParsedRole
 */
export interface ParsedRole {
    /**
     * 
     * @type {string}
     * @memberof ParsedRole
     */
    'nom': string;
    /**
     * 
     * @type {boolean}
     * @memberof ParsedRole
     */
    'detected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ParsedRole
     */
    'role_existant_id'?: string | null;
}
/**
 * 
 * @export
 * @interface ParsedScene
 */
export interface ParsedScene {
    /**
     * 
     * @type {string}
     * @memberof ParsedScene
     */
    'titre': string;
    /**
     * 
     * @type {number}
     * @memberof ParsedScene
     */
    'numero': number | null;
    /**
     * 
     * @type {string}
     * @memberof ParsedScene
     */
    'acte': string | null;
    /**
     * 
     * @type {Array<ParsedAction>}
     * @memberof ParsedScene
     */
    'actions': Array<ParsedAction>;
}
/**
 * 
 * @export
 * @interface ParserWarning
 */
export interface ParserWarning {
    /**
     * 
     * @type {number}
     * @memberof ParserWarning
     */
    'page'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ParserWarning
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface PartageFormCreate
 */
export interface PartageFormCreate {
    /**
     * 
     * @type {string}
     * @memberof PartageFormCreate
     */
    'personne_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof PartageFormCreate
     */
    'can_edit'?: boolean;
}
/**
 * 
 * @export
 * @interface PartageFormUpdate
 */
export interface PartageFormUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof PartageFormUpdate
     */
    'can_edit': boolean;
}
/**
 * 
 * @export
 * @interface PartageSchemaLite
 */
export interface PartageSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof PartageSchemaLite
     */
    'piece_id': string;
    /**
     * 
     * @type {string}
     * @memberof PartageSchemaLite
     */
    'personne_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof PartageSchemaLite
     */
    'can_edit': boolean;
    /**
     * 
     * @type {PieceSchemaLite}
     * @memberof PartageSchemaLite
     */
    'piece': PieceSchemaLite;
    /**
     * 
     * @type {PersonneSchemaLite}
     * @memberof PartageSchemaLite
     */
    'personne': PersonneSchemaLite;
}
/**
 * 
 * @export
 * @interface PendingMembre
 */
export interface PendingMembre {
    /**
     * 
     * @type {string}
     * @memberof PendingMembre
     */
    'personne_id': string;
    /**
     * 
     * @type {FonctionType}
     * @memberof PendingMembre
     */
    'fonction': FonctionType;
    /**
     * 
     * @type {boolean}
     * @memberof PendingMembre
     */
    'can_edit'?: boolean;
}


/**
 * Une personne telle que les autres la voient : ni son email ni son sub Keycloak (minimisation RGPD).
 * @export
 * @interface PersonneSchemaLite
 */
export interface PersonneSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof PersonneSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PersonneSchemaLite
     */
    'nom': string;
    /**
     * 
     * @type {string}
     * @memberof PersonneSchemaLite
     */
    'joined_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonneSchemaLite
     */
    'avatar_version': string | null;
    /**
     * Faux tant qu\'une personne invitée n\'a pas créé son compte.
     * @type {boolean}
     * @memberof PersonneSchemaLite
     */
    'inscrite': boolean;
}
/**
 * 
 * @export
 * @interface PieceATransmettreSchema
 */
export interface PieceATransmettreSchema {
    /**
     * 
     * @type {string}
     * @memberof PieceATransmettreSchema
     */
    'piece_id': string;
    /**
     * 
     * @type {string}
     * @memberof PieceATransmettreSchema
     */
    'titre': string;
    /**
     * 
     * @type {Array<CollaborateurSchema>}
     * @memberof PieceATransmettreSchema
     */
    'collaborateurs': Array<CollaborateurSchema>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PieceAcces = {
    Proprietaire: 'proprietaire',
    Collaboration: 'collaboration',
    Lecture: 'lecture',
    Production: 'production'
} as const;

export type PieceAcces = typeof PieceAcces[keyof typeof PieceAcces];


/**
 * Une adaptation de la famille d\'une pièce, pour passer de l\'une à l\'autre.
 * @export
 * @interface PieceAdaptationSchema
 */
export interface PieceAdaptationSchema {
    /**
     * 
     * @type {string}
     * @memberof PieceAdaptationSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PieceAdaptationSchema
     */
    'titre': string;
    /**
     * 
     * @type {string}
     * @memberof PieceAdaptationSchema
     */
    'adaptation_pour': string | null;
    /**
     * 
     * @type {number}
     * @memberof PieceAdaptationSchema
     */
    'productions_count'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PieceAdaptationSchema
     */
    'montable'?: boolean;
}
/**
 * Nouvelle adaptation d\'une pièce : la compagnie ou l\'occasion pour laquelle elle est faite la nomme.
 * @export
 * @interface PieceFormAdaptation
 */
export interface PieceFormAdaptation {
    /**
     * 
     * @type {string}
     * @memberof PieceFormAdaptation
     */
    'adaptation_pour': string;
}
/**
 * 
 * @export
 * @interface PieceFormInformations
 */
export interface PieceFormInformations {
    /**
     * 
     * @type {string}
     * @memberof PieceFormInformations
     */
    'titre': string;
    /**
     * 
     * @type {string}
     * @memberof PieceFormInformations
     */
    'auteur': string;
    /**
     * 
     * @type {string}
     * @memberof PieceFormInformations
     */
    'adapte_par'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PieceFormInformations
     */
    'adaptation_pour'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PieceFormInformations
     */
    'resume'?: string | null;
}
/**
 * 
 * @export
 * @interface PieceSchema
 */
export interface PieceSchema {
    /**
     * 
     * @type {string}
     * @memberof PieceSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PieceSchema
     */
    'createur_id': string;
    /**
     * 
     * @type {string}
     * @memberof PieceSchema
     */
    'source_piece_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof PieceSchema
     */
    'titre': string;
    /**
     * 
     * @type {string}
     * @memberof PieceSchema
     */
    'auteur': string;
    /**
     * 
     * @type {string}
     * @memberof PieceSchema
     */
    'adapte_par': string | null;
    /**
     * 
     * @type {string}
     * @memberof PieceSchema
     */
    'adaptation_pour': string | null;
    /**
     * 
     * @type {string}
     * @memberof PieceSchema
     */
    'affiche': string | null;
    /**
     * 
     * @type {string}
     * @memberof PieceSchema
     */
    'resume': string | null;
    /**
     * 
     * @type {PieceAcces}
     * @memberof PieceSchema
     */
    'acces'?: PieceAcces | null;
    /**
     * 
     * @type {PersonneSchemaLite}
     * @memberof PieceSchema
     */
    'createur': PersonneSchemaLite;
    /**
     * 
     * @type {PieceSchemaLite}
     * @memberof PieceSchema
     */
    'source_piece': PieceSchemaLite | null;
    /**
     * 
     * @type {Array<SceneSchemaLite>}
     * @memberof PieceSchema
     */
    'scenes': Array<SceneSchemaLite>;
    /**
     * 
     * @type {Array<RoleSchemaLite>}
     * @memberof PieceSchema
     */
    'roles': Array<RoleSchemaLite>;
    /**
     * 
     * @type {Array<ProductionSchemaLite>}
     * @memberof PieceSchema
     */
    'productions': Array<ProductionSchemaLite>;
    /**
     * 
     * @type {Array<PartageSchemaLite>}
     * @memberof PieceSchema
     */
    'partages': Array<PartageSchemaLite>;
    /**
     * 
     * @type {number}
     * @memberof PieceSchema
     */
    'roles_count': number;
    /**
     * 
     * @type {number}
     * @memberof PieceSchema
     */
    'productions_count': number;
}


/**
 * 
 * @export
 * @interface PieceSchemaLite
 */
export interface PieceSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof PieceSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PieceSchemaLite
     */
    'createur_id': string;
    /**
     * 
     * @type {string}
     * @memberof PieceSchemaLite
     */
    'source_piece_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof PieceSchemaLite
     */
    'titre': string;
    /**
     * 
     * @type {string}
     * @memberof PieceSchemaLite
     */
    'auteur': string;
    /**
     * 
     * @type {string}
     * @memberof PieceSchemaLite
     */
    'adapte_par': string | null;
    /**
     * 
     * @type {string}
     * @memberof PieceSchemaLite
     */
    'adaptation_pour': string | null;
    /**
     * 
     * @type {string}
     * @memberof PieceSchemaLite
     */
    'affiche': string | null;
    /**
     * 
     * @type {string}
     * @memberof PieceSchemaLite
     */
    'resume': string | null;
    /**
     * 
     * @type {PieceAcces}
     * @memberof PieceSchemaLite
     */
    'acces'?: PieceAcces | null;
    /**
     * 
     * @type {PersonneSchemaLite}
     * @memberof PieceSchemaLite
     */
    'createur': PersonneSchemaLite;
    /**
     * 
     * @type {PieceSchemaLite}
     * @memberof PieceSchemaLite
     */
    'source_piece': PieceSchemaLite | null;
}


/**
 * Calculée à la demande depuis le texte ; seuls les mots des répliques comptent (ni didascalies ni chansons), sauf par rôle où les couplets chantés s\'ajoutent.
 * @export
 * @interface PieceStatistiquesSchema
 */
export interface PieceStatistiquesSchema {
    /**
     * 
     * @type {number}
     * @memberof PieceStatistiquesSchema
     */
    'nb_actes': number;
    /**
     * 
     * @type {number}
     * @memberof PieceStatistiquesSchema
     */
    'nb_scenes': number;
    /**
     * 
     * @type {number}
     * @memberof PieceStatistiquesSchema
     */
    'nb_repliques': number;
    /**
     * 
     * @type {number}
     * @memberof PieceStatistiquesSchema
     */
    'nb_mots': number;
    /**
     * 
     * @type {number}
     * @memberof PieceStatistiquesSchema
     */
    'duree_estimee_minutes': number;
    /**
     * 
     * @type {Array<RoleStatistiquesSchema>}
     * @memberof PieceStatistiquesSchema
     */
    'roles': Array<RoleStatistiquesSchema>;
}
/**
 * 
 * @export
 * @interface PieceSupprimeeSchema
 */
export interface PieceSupprimeeSchema {
    /**
     * 
     * @type {string}
     * @memberof PieceSupprimeeSchema
     */
    'piece_id': string;
    /**
     * 
     * @type {string}
     * @memberof PieceSupprimeeSchema
     */
    'titre': string;
    /**
     * 
     * @type {number}
     * @memberof PieceSupprimeeSchema
     */
    'nb_lecteurs': number;
}
/**
 * Champs absents : inchangés.
 * @export
 * @interface PreferencesMailFormUpdate
 */
export interface PreferencesMailFormUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof PreferencesMailFormUpdate
     */
    'mail_invitations'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PreferencesMailFormUpdate
     */
    'mail_rappels'?: boolean | null;
}
/**
 * 
 * @export
 * @interface PreferencesMailSchema
 */
export interface PreferencesMailSchema {
    /**
     * 
     * @type {boolean}
     * @memberof PreferencesMailSchema
     */
    'mail_invitations': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreferencesMailSchema
     */
    'mail_rappels': boolean;
}
/**
 * 
 * @export
 * @interface ProductionFormCreate
 */
export interface ProductionFormCreate {
    /**
     * 
     * @type {string}
     * @memberof ProductionFormCreate
     */
    'compagnie_id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductionFormCreate
     */
    'troupe_ids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductionFormCreate
     */
    'piece_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductionFormCreate
     */
    'fonction': string;
}
/**
 * 
 * @export
 * @interface ProductionFormUpdateInformations
 */
export interface ProductionFormUpdateInformations {
    /**
     * 
     * @type {StatutProduction}
     * @memberof ProductionFormUpdateInformations
     */
    'statut': StatutProduction;
}


/**
 * 
 * @export
 * @interface ProductionSchema
 */
export interface ProductionSchema {
    /**
     * 
     * @type {string}
     * @memberof ProductionSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSchema
     */
    'createur_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionSchema
     */
    'piece_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSchema
     */
    'affiche': string | null;
    /**
     * 
     * @type {StatutProduction}
     * @memberof ProductionSchema
     */
    'statut': StatutProduction;
    /**
     * 
     * @type {string}
     * @memberof ProductionSchema
     */
    'compagnie_id': string;
    /**
     * 
     * @type {PersonneSchemaLite}
     * @memberof ProductionSchema
     */
    'createur': PersonneSchemaLite | null;
    /**
     * 
     * @type {CompagnieSchemaLite}
     * @memberof ProductionSchema
     */
    'compagnie': CompagnieSchemaLite;
    /**
     * 
     * @type {Array<TroupeSchemaLite>}
     * @memberof ProductionSchema
     */
    'troupes': Array<TroupeSchemaLite>;
    /**
     * 
     * @type {PieceSchemaLite}
     * @memberof ProductionSchema
     */
    'piece': PieceSchemaLite;
    /**
     * 
     * @type {Array<MembreSchemaLite>}
     * @memberof ProductionSchema
     */
    'membres': Array<MembreSchemaLite>;
    /**
     * 
     * @type {Array<EvenementSchemaLite>}
     * @memberof ProductionSchema
     */
    'evenements': Array<EvenementSchemaLite>;
    /**
     * 
     * @type {Array<RegleRecurrenceSchemaLite>}
     * @memberof ProductionSchema
     */
    'regles_recurrence': Array<RegleRecurrenceSchemaLite>;
    /**
     * 
     * @type {number}
     * @memberof ProductionSchema
     */
    'evenements_count': number;
}


/**
 * 
 * @export
 * @interface ProductionSchemaLite
 */
export interface ProductionSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof ProductionSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSchemaLite
     */
    'createur_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionSchemaLite
     */
    'piece_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSchemaLite
     */
    'affiche': string | null;
    /**
     * 
     * @type {StatutProduction}
     * @memberof ProductionSchemaLite
     */
    'statut': StatutProduction;
    /**
     * 
     * @type {string}
     * @memberof ProductionSchemaLite
     */
    'compagnie_id': string;
    /**
     * 
     * @type {PersonneSchemaLite}
     * @memberof ProductionSchemaLite
     */
    'createur': PersonneSchemaLite | null;
    /**
     * 
     * @type {CompagnieSchemaLite}
     * @memberof ProductionSchemaLite
     */
    'compagnie': CompagnieSchemaLite;
    /**
     * 
     * @type {Array<TroupeSchemaLite>}
     * @memberof ProductionSchemaLite
     */
    'troupes': Array<TroupeSchemaLite>;
    /**
     * 
     * @type {PieceSchemaLite}
     * @memberof ProductionSchemaLite
     */
    'piece': PieceSchemaLite;
}


/**
 * 
 * @export
 * @interface RegleRecurrenceFormCreate
 */
export interface RegleRecurrenceFormCreate {
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceFormCreate
     */
    'production_id': string;
    /**
     * 
     * @type {JourSemaine}
     * @memberof RegleRecurrenceFormCreate
     */
    'jour': JourSemaine;
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceFormCreate
     */
    'heure': string;
    /**
     * 
     * @type {FrequenceRecurrence}
     * @memberof RegleRecurrenceFormCreate
     */
    'frequence': FrequenceRecurrence;
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceFormCreate
     */
    'date_debut': string;
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceFormCreate
     */
    'date_fin': string;
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceFormCreate
     */
    'lieu'?: string | null;
}


/**
 * 
 * @export
 * @interface RegleRecurrenceFormUpdate
 */
export interface RegleRecurrenceFormUpdate {
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceFormUpdate
     */
    'production_id': string;
    /**
     * 
     * @type {JourSemaine}
     * @memberof RegleRecurrenceFormUpdate
     */
    'jour': JourSemaine;
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceFormUpdate
     */
    'heure': string;
    /**
     * 
     * @type {FrequenceRecurrence}
     * @memberof RegleRecurrenceFormUpdate
     */
    'frequence': FrequenceRecurrence;
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceFormUpdate
     */
    'date_debut': string;
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceFormUpdate
     */
    'date_fin': string;
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceFormUpdate
     */
    'lieu'?: string | null;
}


/**
 * 
 * @export
 * @interface RegleRecurrenceSchemaLite
 */
export interface RegleRecurrenceSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceSchemaLite
     */
    'production_id': string;
    /**
     * 
     * @type {JourSemaine}
     * @memberof RegleRecurrenceSchemaLite
     */
    'jour': JourSemaine;
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceSchemaLite
     */
    'heure': string;
    /**
     * 
     * @type {FrequenceRecurrence}
     * @memberof RegleRecurrenceSchemaLite
     */
    'frequence': FrequenceRecurrence;
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceSchemaLite
     */
    'date_debut': string;
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceSchemaLite
     */
    'date_fin': string;
    /**
     * 
     * @type {string}
     * @memberof RegleRecurrenceSchemaLite
     */
    'lieu': string | null;
    /**
     * 
     * @type {ProductionSchemaLite}
     * @memberof RegleRecurrenceSchemaLite
     */
    'production': ProductionSchemaLite;
}


/**
 * État complet des repères d\'une action : un côté (Cour, Jardin ou libellé libre) pose le repère, None le retire.
 * @export
 * @interface RepereFormUpdate
 */
export interface RepereFormUpdate {
    /**
     * COUR, JARDIN ou un côté libre
     * @type {string}
     * @memberof RepereFormUpdate
     */
    'entree'?: string | null;
    /**
     * COUR, JARDIN ou un côté libre
     * @type {string}
     * @memberof RepereFormUpdate
     */
    'sortie'?: string | null;
}
/**
 * 
 * @export
 * @interface RepereSchemaLite
 */
export interface RepereSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof RepereSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RepereSchemaLite
     */
    'action_id': string;
    /**
     * 
     * @type {TypeRepere}
     * @memberof RepereSchemaLite
     */
    'type': TypeRepere;
    /**
     * COUR, JARDIN ou un côté libre
     * @type {string}
     * @memberof RepereSchemaLite
     */
    'cote': string;
    /**
     * 
     * @type {ActionSchemaLite}
     * @memberof RepereSchemaLite
     */
    'action': ActionSchemaLite;
}


/**
 * 
 * @export
 * @interface RoleFormCreate
 */
export interface RoleFormCreate {
    /**
     * 
     * @type {string}
     * @memberof RoleFormCreate
     */
    'piece_id': string;
    /**
     * 
     * @type {string}
     * @memberof RoleFormCreate
     */
    'nom_personnage': string;
    /**
     * 
     * @type {string}
     * @memberof RoleFormCreate
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleFormCreate
     */
    'groupe'?: boolean;
}
/**
 * 
 * @export
 * @interface RoleFormUpdate
 */
export interface RoleFormUpdate {
    /**
     * 
     * @type {string}
     * @memberof RoleFormUpdate
     */
    'nom_personnage': string;
    /**
     * 
     * @type {string}
     * @memberof RoleFormUpdate
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleFormUpdate
     */
    'groupe'?: boolean | null;
}
/**
 * Rôle d\'une scène que personne ne peut tenir : sans interprète, ou tous ses interprètes absents.
 * @export
 * @interface RoleManquantSchema
 */
export interface RoleManquantSchema {
    /**
     * 
     * @type {string}
     * @memberof RoleManquantSchema
     */
    'role_id': string;
    /**
     * 
     * @type {string}
     * @memberof RoleManquantSchema
     */
    'nom_personnage': string;
    /**
     * 
     * @type {boolean}
     * @memberof RoleManquantSchema
     */
    'non_distribue': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RoleManquantSchema
     */
    'absents': Array<string>;
}
/**
 * 
 * @export
 * @interface RoleSchemaLite
 */
export interface RoleSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof RoleSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RoleSchemaLite
     */
    'piece_id': string;
    /**
     * 
     * @type {string}
     * @memberof RoleSchemaLite
     */
    'nom_personnage': string;
    /**
     * 
     * @type {string}
     * @memberof RoleSchemaLite
     */
    'description': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleSchemaLite
     */
    'groupe': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RoleSchemaLite
     */
    'personnages': Array<string>;
}
/**
 * 
 * @export
 * @interface RoleStatistiquesSchema
 */
export interface RoleStatistiquesSchema {
    /**
     * 
     * @type {string}
     * @memberof RoleStatistiquesSchema
     */
    'role_id': string;
    /**
     * 
     * @type {string}
     * @memberof RoleStatistiquesSchema
     */
    'nom_personnage': string;
    /**
     * 
     * @type {number}
     * @memberof RoleStatistiquesSchema
     */
    'nb_repliques': number;
    /**
     * 
     * @type {number}
     * @memberof RoleStatistiquesSchema
     */
    'nb_mots': number;
}
/**
 * Une nouvelle scène prend la dernière position de la pièce.
 * @export
 * @interface SceneFormCreate
 */
export interface SceneFormCreate {
    /**
     * 
     * @type {string}
     * @memberof SceneFormCreate
     */
    'piece_id': string;
    /**
     * 
     * @type {string}
     * @memberof SceneFormCreate
     */
    'titre': string;
    /**
     * 
     * @type {number}
     * @memberof SceneFormCreate
     */
    'numero': number;
    /**
     * 
     * @type {number}
     * @memberof SceneFormCreate
     */
    'acte'?: number | null;
}
/**
 * Remplace titre, numéro et acte (None : scène hors acte) ; la position ne change pas.
 * @export
 * @interface SceneFormUpdate
 */
export interface SceneFormUpdate {
    /**
     * 
     * @type {string}
     * @memberof SceneFormUpdate
     */
    'titre': string;
    /**
     * 
     * @type {number}
     * @memberof SceneFormUpdate
     */
    'numero': number;
    /**
     * 
     * @type {number}
     * @memberof SceneFormUpdate
     */
    'acte'?: number | null;
}
/**
 * Toutes les actions de la scène, dans leur nouvel ordre.
 * @export
 * @interface SceneOrdreForm
 */
export interface SceneOrdreForm {
    /**
     * 
     * @type {Array<string>}
     * @memberof SceneOrdreForm
     */
    'action_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface SceneSchemaLite
 */
export interface SceneSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof SceneSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SceneSchemaLite
     */
    'piece_id': string;
    /**
     * 
     * @type {string}
     * @memberof SceneSchemaLite
     */
    'titre': string;
    /**
     * 
     * @type {number}
     * @memberof SceneSchemaLite
     */
    'numero': number;
    /**
     * 
     * @type {number}
     * @memberof SceneSchemaLite
     */
    'acte': number | null;
    /**
     * 
     * @type {number}
     * @memberof SceneSchemaLite
     */
    'ordre': number;
    /**
     * 
     * @type {PieceSchemaLite}
     * @memberof SceneSchemaLite
     */
    'piece': PieceSchemaLite;
}
/**
 * 
 * @export
 * @interface SceneTravaillableSchema
 */
export interface SceneTravaillableSchema {
    /**
     * 
     * @type {string}
     * @memberof SceneTravaillableSchema
     */
    'scene_id': string;
    /**
     * 
     * @type {number}
     * @memberof SceneTravaillableSchema
     */
    'acte': number | null;
    /**
     * 
     * @type {number}
     * @memberof SceneTravaillableSchema
     */
    'numero': number;
    /**
     * 
     * @type {string}
     * @memberof SceneTravaillableSchema
     */
    'titre': string;
    /**
     * 
     * @type {boolean}
     * @memberof SceneTravaillableSchema
     */
    'travaillable': boolean;
    /**
     * 
     * @type {Array<RoleManquantSchema>}
     * @memberof SceneTravaillableSchema
     */
    'manques': Array<RoleManquantSchema>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const StatutProduction = {
    EnPreparation: 'EN_PREPARATION',
    EnRepetition: 'EN_REPETITION',
    EnRepresentation: 'EN_REPRESENTATION',
    Terminee: 'TERMINEE'
} as const;

export type StatutProduction = typeof StatutProduction[keyof typeof StatutProduction];


/**
 * Ce que la suppression du compte bloquerait, transmettrait, emporterait et quitterait.
 * @export
 * @interface SuppressionCompteApercuSchema
 */
export interface SuppressionCompteApercuSchema {
    /**
     * 
     * @type {Array<BlocageSchema>}
     * @memberof SuppressionCompteApercuSchema
     */
    'blocages': Array<BlocageSchema>;
    /**
     * 
     * @type {Array<PieceATransmettreSchema>}
     * @memberof SuppressionCompteApercuSchema
     */
    'pieces_a_transmettre': Array<PieceATransmettreSchema>;
    /**
     * 
     * @type {Array<PieceSupprimeeSchema>}
     * @memberof SuppressionCompteApercuSchema
     */
    'pieces_supprimees': Array<PieceSupprimeeSchema>;
    /**
     * 
     * @type {Array<ElementSchema>}
     * @memberof SuppressionCompteApercuSchema
     */
    'productions_supprimees': Array<ElementSchema>;
    /**
     * 
     * @type {Array<ElementSchema>}
     * @memberof SuppressionCompteApercuSchema
     */
    'compagnies_supprimees': Array<ElementSchema>;
    /**
     * 
     * @type {Array<ElementSchema>}
     * @memberof SuppressionCompteApercuSchema
     */
    'productions_quittees': Array<ElementSchema>;
}
/**
 * 
 * @export
 * @interface SuppressionCompteForm
 */
export interface SuppressionCompteForm {
    /**
     * 
     * @type {Array<TransfertForm>}
     * @memberof SuppressionCompteForm
     */
    'transferts'?: Array<TransfertForm>;
}
/**
 * 
 * @export
 * @interface TransfertForm
 */
export interface TransfertForm {
    /**
     * 
     * @type {string}
     * @memberof TransfertForm
     */
    'piece_id': string;
    /**
     * 
     * @type {string}
     * @memberof TransfertForm
     */
    'personne_id': string;
}
/**
 * 
 * @export
 * @interface TroupeFormCreate
 */
export interface TroupeFormCreate {
    /**
     * 
     * @type {string}
     * @memberof TroupeFormCreate
     */
    'compagnie_id': string;
    /**
     * 
     * @type {string}
     * @memberof TroupeFormCreate
     */
    'nom': string;
    /**
     * 
     * @type {string}
     * @memberof TroupeFormCreate
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface TroupeFormUpdate
 */
export interface TroupeFormUpdate {
    /**
     * 
     * @type {string}
     * @memberof TroupeFormUpdate
     */
    'nom': string;
    /**
     * 
     * @type {string}
     * @memberof TroupeFormUpdate
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface TroupeSchema
 */
export interface TroupeSchema {
    /**
     * 
     * @type {string}
     * @memberof TroupeSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TroupeSchema
     */
    'createur_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof TroupeSchema
     */
    'compagnie_id': string;
    /**
     * 
     * @type {string}
     * @memberof TroupeSchema
     */
    'nom': string;
    /**
     * 
     * @type {string}
     * @memberof TroupeSchema
     */
    'description': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TroupeSchema
     */
    'archive': boolean;
    /**
     * 
     * @type {number}
     * @memberof TroupeSchema
     */
    'ordre': number;
    /**
     * 
     * @type {number}
     * @memberof TroupeSchema
     */
    'productions_count'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TroupeSchema
     */
    'peut_produire'?: boolean | null;
    /**
     * 
     * @type {PersonneSchemaLite}
     * @memberof TroupeSchema
     */
    'createur': PersonneSchemaLite | null;
    /**
     * 
     * @type {CompagnieSchemaLite}
     * @memberof TroupeSchema
     */
    'compagnie': CompagnieSchemaLite;
    /**
     * 
     * @type {Array<ProductionSchemaLite>}
     * @memberof TroupeSchema
     */
    'productions': Array<ProductionSchemaLite>;
}
/**
 * 
 * @export
 * @interface TroupeSchemaLite
 */
export interface TroupeSchemaLite {
    /**
     * 
     * @type {string}
     * @memberof TroupeSchemaLite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TroupeSchemaLite
     */
    'createur_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof TroupeSchemaLite
     */
    'compagnie_id': string;
    /**
     * 
     * @type {string}
     * @memberof TroupeSchemaLite
     */
    'nom': string;
    /**
     * 
     * @type {string}
     * @memberof TroupeSchemaLite
     */
    'description': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TroupeSchemaLite
     */
    'archive': boolean;
    /**
     * 
     * @type {number}
     * @memberof TroupeSchemaLite
     */
    'ordre': number;
    /**
     * 
     * @type {number}
     * @memberof TroupeSchemaLite
     */
    'productions_count'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TroupeSchemaLite
     */
    'peut_produire'?: boolean | null;
    /**
     * 
     * @type {PersonneSchemaLite}
     * @memberof TroupeSchemaLite
     */
    'createur': PersonneSchemaLite | null;
    /**
     * 
     * @type {CompagnieSchemaLite}
     * @memberof TroupeSchemaLite
     */
    'compagnie': CompagnieSchemaLite;
}
/**
 * Toutes les troupes de la compagnie, dans leur nouvel ordre.
 * @export
 * @interface TroupesOrdreForm
 */
export interface TroupesOrdreForm {
    /**
     * 
     * @type {Array<string>}
     * @memberof TroupesOrdreForm
     */
    'troupe_ids': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TypeRepere = {
    Entree: 'ENTREE',
    Sortie: 'SORTIE'
} as const;

export type TypeRepere = typeof TypeRepere[keyof typeof TypeRepere];


/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * ActionsApi - axios parameter creator
 * @export
 */
export const ActionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Ajouter Media
         * @param {string} actionId 
         * @param {MediaKind} kind 
         * @param {File} file 
         * @param {string | null} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ajouterMediaActionsActionIdMediasPost: async (actionId: string, kind: MediaKind, file: File, description?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('ajouterMediaActionsActionIdMediasPost', 'actionId', actionId)
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('ajouterMediaActionsActionIdMediasPost', 'kind', kind)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('ajouterMediaActionsActionIdMediasPost', 'file', file)
            const localVarPath = `/actions/{action_id}/medias`
                .replace(`{${"action_id"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (kind !== undefined) { 
                localVarFormParams.append('kind', kind as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Action
         * @param {ActionFormCreate} actionFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActionActionsPost: async (actionFormCreate: ActionFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionFormCreate' is not null or undefined
            assertParamExists('createActionActionsPost', 'actionFormCreate', actionFormCreate)
            const localVarPath = `/actions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Action
         * @param {string} actionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActionActionsActionIdDelete: async (actionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('deleteActionActionsActionIdDelete', 'actionId', actionId)
            const localVarPath = `/actions/{action_id}`
                .replace(`{${"action_id"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Déplace l\'action dans sa scène ou vers une autre de la pièce ; rend les actions des scènes touchées.
         * @summary Deplacer Action
         * @param {string} actionId 
         * @param {ActionPositionForm} actionPositionForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deplacerActionActionsActionIdPositionPut: async (actionId: string, actionPositionForm: ActionPositionForm, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('deplacerActionActionsActionIdPositionPut', 'actionId', actionId)
            // verify required parameter 'actionPositionForm' is not null or undefined
            assertParamExists('deplacerActionActionsActionIdPositionPut', 'actionPositionForm', actionPositionForm)
            const localVarPath = `/actions/{action_id}/position`
                .replace(`{${"action_id"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionPositionForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Tout le texte d\'une pièce en une requête, pour le lecteur et l\'éditeur.
         * @summary List Actions By Piece
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActionsByPieceActionsPiecePieceIdGet: async (pieceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('listActionsByPieceActionsPiecePieceIdGet', 'pieceId', pieceId)
            const localVarPath = `/actions/piece/{piece_id}`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Actions By Scene
         * @param {string} sceneId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActionsBySceneActionsSceneSceneIdGet: async (sceneId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sceneId' is not null or undefined
            assertParamExists('listActionsBySceneActionsSceneSceneIdGet', 'sceneId', sceneId)
            const localVarPath = `/actions/scene/{scene_id}`
                .replace(`{${"scene_id"}}`, encodeURIComponent(String(sceneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retirer Media
         * @param {string} actionId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retirerMediaActionsActionIdMediasDelete: async (actionId: string, path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('retirerMediaActionsActionIdMediasDelete', 'actionId', actionId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('retirerMediaActionsActionIdMediasDelete', 'path', path)
            const localVarPath = `/actions/{action_id}/medias`
                .replace(`{${"action_id"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Serve Media
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serveMediaActionsMediaPathGet: async (path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('serveMediaActionsMediaPathGet', 'path', path)
            const localVarPath = `/actions/media/{path}`
                .replace(`{${"path"}}`, encodeURIComponent(String(path)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Action
         * @param {string} actionId 
         * @param {ActionFormUpdate} actionFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActionActionsActionIdPatch: async (actionId: string, actionFormUpdate: ActionFormUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('updateActionActionsActionIdPatch', 'actionId', actionId)
            // verify required parameter 'actionFormUpdate' is not null or undefined
            assertParamExists('updateActionActionsActionIdPatch', 'actionFormUpdate', actionFormUpdate)
            const localVarPath = `/actions/{action_id}`
                .replace(`{${"action_id"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionFormUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Action Roles
         * @param {string} actionId 
         * @param {ActionRolesUpdate} actionRolesUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActionRolesActionsActionIdRolesPut: async (actionId: string, actionRolesUpdate: ActionRolesUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('updateActionRolesActionsActionIdRolesPut', 'actionId', actionId)
            // verify required parameter 'actionRolesUpdate' is not null or undefined
            assertParamExists('updateActionRolesActionsActionIdRolesPut', 'actionRolesUpdate', actionRolesUpdate)
            const localVarPath = `/actions/{action_id}/roles`
                .replace(`{${"action_id"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionRolesUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActionsApi - functional programming interface
 * @export
 */
export const ActionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Ajouter Media
         * @param {string} actionId 
         * @param {MediaKind} kind 
         * @param {File} file 
         * @param {string | null} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ajouterMediaActionsActionIdMediasPost(actionId: string, kind: MediaKind, file: File, description?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessActionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ajouterMediaActionsActionIdMediasPost(actionId, kind, file, description, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.ajouterMediaActionsActionIdMediasPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Action
         * @param {ActionFormCreate} actionFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActionActionsPost(actionFormCreate: ActionFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessActionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActionActionsPost(actionFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.createActionActionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Action
         * @param {string} actionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteActionActionsActionIdDelete(actionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessActionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteActionActionsActionIdDelete(actionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.deleteActionActionsActionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Déplace l\'action dans sa scène ou vers une autre de la pièce ; rend les actions des scènes touchées.
         * @summary Deplacer Action
         * @param {string} actionId 
         * @param {ActionPositionForm} actionPositionForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deplacerActionActionsActionIdPositionPut(actionId: string, actionPositionForm: ActionPositionForm, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListActionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deplacerActionActionsActionIdPositionPut(actionId, actionPositionForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.deplacerActionActionsActionIdPositionPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Tout le texte d\'une pièce en une requête, pour le lecteur et l\'éditeur.
         * @summary List Actions By Piece
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActionsByPieceActionsPiecePieceIdGet(pieceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListActionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActionsByPieceActionsPiecePieceIdGet(pieceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.listActionsByPieceActionsPiecePieceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Actions By Scene
         * @param {string} sceneId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActionsBySceneActionsSceneSceneIdGet(sceneId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListActionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActionsBySceneActionsSceneSceneIdGet(sceneId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.listActionsBySceneActionsSceneSceneIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retirer Media
         * @param {string} actionId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retirerMediaActionsActionIdMediasDelete(actionId: string, path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessActionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retirerMediaActionsActionIdMediasDelete(actionId, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.retirerMediaActionsActionIdMediasDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Serve Media
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serveMediaActionsMediaPathGet(path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serveMediaActionsMediaPathGet(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.serveMediaActionsMediaPathGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Action
         * @param {string} actionId 
         * @param {ActionFormUpdate} actionFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateActionActionsActionIdPatch(actionId: string, actionFormUpdate: ActionFormUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessActionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateActionActionsActionIdPatch(actionId, actionFormUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.updateActionActionsActionIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Action Roles
         * @param {string} actionId 
         * @param {ActionRolesUpdate} actionRolesUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateActionRolesActionsActionIdRolesPut(actionId: string, actionRolesUpdate: ActionRolesUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessActionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateActionRolesActionsActionIdRolesPut(actionId, actionRolesUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.updateActionRolesActionsActionIdRolesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActionsApi - factory interface
 * @export
 */
export const ActionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Ajouter Media
         * @param {ActionsApiAjouterMediaActionsActionIdMediasPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ajouterMediaActionsActionIdMediasPost(requestParameters: ActionsApiAjouterMediaActionsActionIdMediasPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessActionSchemaLite> {
            return localVarFp.ajouterMediaActionsActionIdMediasPost(requestParameters.actionId, requestParameters.kind, requestParameters.file, requestParameters.description, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Action
         * @param {ActionsApiCreateActionActionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActionActionsPost(requestParameters: ActionsApiCreateActionActionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessActionSchemaLite> {
            return localVarFp.createActionActionsPost(requestParameters.actionFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Action
         * @param {ActionsApiDeleteActionActionsActionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActionActionsActionIdDelete(requestParameters: ActionsApiDeleteActionActionsActionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessActionSchemaLite> {
            return localVarFp.deleteActionActionsActionIdDelete(requestParameters.actionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Déplace l\'action dans sa scène ou vers une autre de la pièce ; rend les actions des scènes touchées.
         * @summary Deplacer Action
         * @param {ActionsApiDeplacerActionActionsActionIdPositionPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deplacerActionActionsActionIdPositionPut(requestParameters: ActionsApiDeplacerActionActionsActionIdPositionPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListActionSchemaLite> {
            return localVarFp.deplacerActionActionsActionIdPositionPut(requestParameters.actionId, requestParameters.actionPositionForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Tout le texte d\'une pièce en une requête, pour le lecteur et l\'éditeur.
         * @summary List Actions By Piece
         * @param {ActionsApiListActionsByPieceActionsPiecePieceIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActionsByPieceActionsPiecePieceIdGet(requestParameters: ActionsApiListActionsByPieceActionsPiecePieceIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListActionSchemaLite> {
            return localVarFp.listActionsByPieceActionsPiecePieceIdGet(requestParameters.pieceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Actions By Scene
         * @param {ActionsApiListActionsBySceneActionsSceneSceneIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActionsBySceneActionsSceneSceneIdGet(requestParameters: ActionsApiListActionsBySceneActionsSceneSceneIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListActionSchemaLite> {
            return localVarFp.listActionsBySceneActionsSceneSceneIdGet(requestParameters.sceneId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retirer Media
         * @param {ActionsApiRetirerMediaActionsActionIdMediasDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retirerMediaActionsActionIdMediasDelete(requestParameters: ActionsApiRetirerMediaActionsActionIdMediasDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessActionSchemaLite> {
            return localVarFp.retirerMediaActionsActionIdMediasDelete(requestParameters.actionId, requestParameters.path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Serve Media
         * @param {ActionsApiServeMediaActionsMediaPathGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serveMediaActionsMediaPathGet(requestParameters: ActionsApiServeMediaActionsMediaPathGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.serveMediaActionsMediaPathGet(requestParameters.path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Action
         * @param {ActionsApiUpdateActionActionsActionIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActionActionsActionIdPatch(requestParameters: ActionsApiUpdateActionActionsActionIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessActionSchemaLite> {
            return localVarFp.updateActionActionsActionIdPatch(requestParameters.actionId, requestParameters.actionFormUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Action Roles
         * @param {ActionsApiUpdateActionRolesActionsActionIdRolesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActionRolesActionsActionIdRolesPut(requestParameters: ActionsApiUpdateActionRolesActionsActionIdRolesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessActionSchemaLite> {
            return localVarFp.updateActionRolesActionsActionIdRolesPut(requestParameters.actionId, requestParameters.actionRolesUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActionsApi - interface
 * @export
 * @interface ActionsApi
 */
export interface ActionsApiInterface {
    /**
     * 
     * @summary Ajouter Media
     * @param {ActionsApiAjouterMediaActionsActionIdMediasPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApiInterface
     */
    ajouterMediaActionsActionIdMediasPost(requestParameters: ActionsApiAjouterMediaActionsActionIdMediasPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessActionSchemaLite>;

    /**
     * 
     * @summary Create Action
     * @param {ActionsApiCreateActionActionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApiInterface
     */
    createActionActionsPost(requestParameters: ActionsApiCreateActionActionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessActionSchemaLite>;

    /**
     * 
     * @summary Delete Action
     * @param {ActionsApiDeleteActionActionsActionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApiInterface
     */
    deleteActionActionsActionIdDelete(requestParameters: ActionsApiDeleteActionActionsActionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessActionSchemaLite>;

    /**
     * Déplace l\'action dans sa scène ou vers une autre de la pièce ; rend les actions des scènes touchées.
     * @summary Deplacer Action
     * @param {ActionsApiDeplacerActionActionsActionIdPositionPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApiInterface
     */
    deplacerActionActionsActionIdPositionPut(requestParameters: ActionsApiDeplacerActionActionsActionIdPositionPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListActionSchemaLite>;

    /**
     * Tout le texte d\'une pièce en une requête, pour le lecteur et l\'éditeur.
     * @summary List Actions By Piece
     * @param {ActionsApiListActionsByPieceActionsPiecePieceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApiInterface
     */
    listActionsByPieceActionsPiecePieceIdGet(requestParameters: ActionsApiListActionsByPieceActionsPiecePieceIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListActionSchemaLite>;

    /**
     * 
     * @summary List Actions By Scene
     * @param {ActionsApiListActionsBySceneActionsSceneSceneIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApiInterface
     */
    listActionsBySceneActionsSceneSceneIdGet(requestParameters: ActionsApiListActionsBySceneActionsSceneSceneIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListActionSchemaLite>;

    /**
     * 
     * @summary Retirer Media
     * @param {ActionsApiRetirerMediaActionsActionIdMediasDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApiInterface
     */
    retirerMediaActionsActionIdMediasDelete(requestParameters: ActionsApiRetirerMediaActionsActionIdMediasDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessActionSchemaLite>;

    /**
     * 
     * @summary Serve Media
     * @param {ActionsApiServeMediaActionsMediaPathGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApiInterface
     */
    serveMediaActionsMediaPathGet(requestParameters: ActionsApiServeMediaActionsMediaPathGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @summary Update Action
     * @param {ActionsApiUpdateActionActionsActionIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApiInterface
     */
    updateActionActionsActionIdPatch(requestParameters: ActionsApiUpdateActionActionsActionIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessActionSchemaLite>;

    /**
     * 
     * @summary Update Action Roles
     * @param {ActionsApiUpdateActionRolesActionsActionIdRolesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApiInterface
     */
    updateActionRolesActionsActionIdRolesPut(requestParameters: ActionsApiUpdateActionRolesActionsActionIdRolesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessActionSchemaLite>;

}

/**
 * Request parameters for ajouterMediaActionsActionIdMediasPost operation in ActionsApi.
 * @export
 * @interface ActionsApiAjouterMediaActionsActionIdMediasPostRequest
 */
export interface ActionsApiAjouterMediaActionsActionIdMediasPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionsApiAjouterMediaActionsActionIdMediasPost
     */
    readonly actionId: string

    /**
     * 
     * @type {MediaKind}
     * @memberof ActionsApiAjouterMediaActionsActionIdMediasPost
     */
    readonly kind: MediaKind

    /**
     * 
     * @type {File}
     * @memberof ActionsApiAjouterMediaActionsActionIdMediasPost
     */
    readonly file: File

    /**
     * 
     * @type {string}
     * @memberof ActionsApiAjouterMediaActionsActionIdMediasPost
     */
    readonly description?: string | null
}

/**
 * Request parameters for createActionActionsPost operation in ActionsApi.
 * @export
 * @interface ActionsApiCreateActionActionsPostRequest
 */
export interface ActionsApiCreateActionActionsPostRequest {
    /**
     * 
     * @type {ActionFormCreate}
     * @memberof ActionsApiCreateActionActionsPost
     */
    readonly actionFormCreate: ActionFormCreate
}

/**
 * Request parameters for deleteActionActionsActionIdDelete operation in ActionsApi.
 * @export
 * @interface ActionsApiDeleteActionActionsActionIdDeleteRequest
 */
export interface ActionsApiDeleteActionActionsActionIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionsApiDeleteActionActionsActionIdDelete
     */
    readonly actionId: string
}

/**
 * Request parameters for deplacerActionActionsActionIdPositionPut operation in ActionsApi.
 * @export
 * @interface ActionsApiDeplacerActionActionsActionIdPositionPutRequest
 */
export interface ActionsApiDeplacerActionActionsActionIdPositionPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionsApiDeplacerActionActionsActionIdPositionPut
     */
    readonly actionId: string

    /**
     * 
     * @type {ActionPositionForm}
     * @memberof ActionsApiDeplacerActionActionsActionIdPositionPut
     */
    readonly actionPositionForm: ActionPositionForm
}

/**
 * Request parameters for listActionsByPieceActionsPiecePieceIdGet operation in ActionsApi.
 * @export
 * @interface ActionsApiListActionsByPieceActionsPiecePieceIdGetRequest
 */
export interface ActionsApiListActionsByPieceActionsPiecePieceIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionsApiListActionsByPieceActionsPiecePieceIdGet
     */
    readonly pieceId: string
}

/**
 * Request parameters for listActionsBySceneActionsSceneSceneIdGet operation in ActionsApi.
 * @export
 * @interface ActionsApiListActionsBySceneActionsSceneSceneIdGetRequest
 */
export interface ActionsApiListActionsBySceneActionsSceneSceneIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionsApiListActionsBySceneActionsSceneSceneIdGet
     */
    readonly sceneId: string
}

/**
 * Request parameters for retirerMediaActionsActionIdMediasDelete operation in ActionsApi.
 * @export
 * @interface ActionsApiRetirerMediaActionsActionIdMediasDeleteRequest
 */
export interface ActionsApiRetirerMediaActionsActionIdMediasDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionsApiRetirerMediaActionsActionIdMediasDelete
     */
    readonly actionId: string

    /**
     * 
     * @type {string}
     * @memberof ActionsApiRetirerMediaActionsActionIdMediasDelete
     */
    readonly path: string
}

/**
 * Request parameters for serveMediaActionsMediaPathGet operation in ActionsApi.
 * @export
 * @interface ActionsApiServeMediaActionsMediaPathGetRequest
 */
export interface ActionsApiServeMediaActionsMediaPathGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionsApiServeMediaActionsMediaPathGet
     */
    readonly path: string
}

/**
 * Request parameters for updateActionActionsActionIdPatch operation in ActionsApi.
 * @export
 * @interface ActionsApiUpdateActionActionsActionIdPatchRequest
 */
export interface ActionsApiUpdateActionActionsActionIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionsApiUpdateActionActionsActionIdPatch
     */
    readonly actionId: string

    /**
     * 
     * @type {ActionFormUpdate}
     * @memberof ActionsApiUpdateActionActionsActionIdPatch
     */
    readonly actionFormUpdate: ActionFormUpdate
}

/**
 * Request parameters for updateActionRolesActionsActionIdRolesPut operation in ActionsApi.
 * @export
 * @interface ActionsApiUpdateActionRolesActionsActionIdRolesPutRequest
 */
export interface ActionsApiUpdateActionRolesActionsActionIdRolesPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionsApiUpdateActionRolesActionsActionIdRolesPut
     */
    readonly actionId: string

    /**
     * 
     * @type {ActionRolesUpdate}
     * @memberof ActionsApiUpdateActionRolesActionsActionIdRolesPut
     */
    readonly actionRolesUpdate: ActionRolesUpdate
}

/**
 * ActionsApi - object-oriented interface
 * @export
 * @class ActionsApi
 * @extends {BaseAPI}
 */
export class ActionsApi extends BaseAPI implements ActionsApiInterface {
    /**
     * 
     * @summary Ajouter Media
     * @param {ActionsApiAjouterMediaActionsActionIdMediasPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public ajouterMediaActionsActionIdMediasPost(requestParameters: ActionsApiAjouterMediaActionsActionIdMediasPostRequest, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).ajouterMediaActionsActionIdMediasPost(requestParameters.actionId, requestParameters.kind, requestParameters.file, requestParameters.description, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Action
     * @param {ActionsApiCreateActionActionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public createActionActionsPost(requestParameters: ActionsApiCreateActionActionsPostRequest, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).createActionActionsPost(requestParameters.actionFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Action
     * @param {ActionsApiDeleteActionActionsActionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public deleteActionActionsActionIdDelete(requestParameters: ActionsApiDeleteActionActionsActionIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).deleteActionActionsActionIdDelete(requestParameters.actionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Déplace l\'action dans sa scène ou vers une autre de la pièce ; rend les actions des scènes touchées.
     * @summary Deplacer Action
     * @param {ActionsApiDeplacerActionActionsActionIdPositionPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public deplacerActionActionsActionIdPositionPut(requestParameters: ActionsApiDeplacerActionActionsActionIdPositionPutRequest, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).deplacerActionActionsActionIdPositionPut(requestParameters.actionId, requestParameters.actionPositionForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Tout le texte d\'une pièce en une requête, pour le lecteur et l\'éditeur.
     * @summary List Actions By Piece
     * @param {ActionsApiListActionsByPieceActionsPiecePieceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public listActionsByPieceActionsPiecePieceIdGet(requestParameters: ActionsApiListActionsByPieceActionsPiecePieceIdGetRequest, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).listActionsByPieceActionsPiecePieceIdGet(requestParameters.pieceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Actions By Scene
     * @param {ActionsApiListActionsBySceneActionsSceneSceneIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public listActionsBySceneActionsSceneSceneIdGet(requestParameters: ActionsApiListActionsBySceneActionsSceneSceneIdGetRequest, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).listActionsBySceneActionsSceneSceneIdGet(requestParameters.sceneId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retirer Media
     * @param {ActionsApiRetirerMediaActionsActionIdMediasDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public retirerMediaActionsActionIdMediasDelete(requestParameters: ActionsApiRetirerMediaActionsActionIdMediasDeleteRequest, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).retirerMediaActionsActionIdMediasDelete(requestParameters.actionId, requestParameters.path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Serve Media
     * @param {ActionsApiServeMediaActionsMediaPathGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public serveMediaActionsMediaPathGet(requestParameters: ActionsApiServeMediaActionsMediaPathGetRequest, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).serveMediaActionsMediaPathGet(requestParameters.path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Action
     * @param {ActionsApiUpdateActionActionsActionIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public updateActionActionsActionIdPatch(requestParameters: ActionsApiUpdateActionActionsActionIdPatchRequest, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).updateActionActionsActionIdPatch(requestParameters.actionId, requestParameters.actionFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Action Roles
     * @param {ActionsApiUpdateActionRolesActionsActionIdRolesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public updateActionRolesActionsActionIdRolesPut(requestParameters: ActionsApiUpdateActionRolesActionsActionIdRolesPutRequest, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).updateActionRolesActionsActionIdRolesPut(requestParameters.actionId, requestParameters.actionRolesUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CalendrierApi - axios parameter creator
 * @export
 */
export const CalendrierApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Sans JWT : lu par les agendas abonnés, le jeton fait office de mot de passe.
         * @summary Flux Calendrier
         * @param {string} jeton 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fluxCalendrierCalendrierJetonIcsGet: async (jeton: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jeton' is not null or undefined
            assertParamExists('fluxCalendrierCalendrierJetonIcsGet', 'jeton', jeton)
            const localVarPath = `/calendrier/{jeton}.ics`
                .replace(`{${"jeton"}}`, encodeURIComponent(String(jeton)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adresse d\'abonnement du membre connecté à l\'agenda de sa production, créée à la première demande.
         * @summary Get Abonnement
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbonnementCalendrierProductionProductionIdGet: async (productionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('getAbonnementCalendrierProductionProductionIdGet', 'productionId', productionId)
            const localVarPath = `/calendrier/production/{production_id}`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nouvelle adresse : l\'ancienne cesse de répondre, pour tous les agendas qui y étaient abonnés.
         * @summary Regenerer Abonnement
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenererAbonnementCalendrierProductionProductionIdPost: async (productionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('regenererAbonnementCalendrierProductionProductionIdPost', 'productionId', productionId)
            const localVarPath = `/calendrier/production/{production_id}`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalendrierApi - functional programming interface
 * @export
 */
export const CalendrierApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalendrierApiAxiosParamCreator(configuration)
    return {
        /**
         * Sans JWT : lu par les agendas abonnés, le jeton fait office de mot de passe.
         * @summary Flux Calendrier
         * @param {string} jeton 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fluxCalendrierCalendrierJetonIcsGet(jeton: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fluxCalendrierCalendrierJetonIcsGet(jeton, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendrierApi.fluxCalendrierCalendrierJetonIcsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adresse d\'abonnement du membre connecté à l\'agenda de sa production, créée à la première demande.
         * @summary Get Abonnement
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbonnementCalendrierProductionProductionIdGet(productionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessAbonnementCalendrierSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbonnementCalendrierProductionProductionIdGet(productionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendrierApi.getAbonnementCalendrierProductionProductionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nouvelle adresse : l\'ancienne cesse de répondre, pour tous les agendas qui y étaient abonnés.
         * @summary Regenerer Abonnement
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regenererAbonnementCalendrierProductionProductionIdPost(productionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessAbonnementCalendrierSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.regenererAbonnementCalendrierProductionProductionIdPost(productionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendrierApi.regenererAbonnementCalendrierProductionProductionIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalendrierApi - factory interface
 * @export
 */
export const CalendrierApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalendrierApiFp(configuration)
    return {
        /**
         * Sans JWT : lu par les agendas abonnés, le jeton fait office de mot de passe.
         * @summary Flux Calendrier
         * @param {CalendrierApiFluxCalendrierCalendrierJetonIcsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fluxCalendrierCalendrierJetonIcsGet(requestParameters: CalendrierApiFluxCalendrierCalendrierJetonIcsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.fluxCalendrierCalendrierJetonIcsGet(requestParameters.jeton, options).then((request) => request(axios, basePath));
        },
        /**
         * Adresse d\'abonnement du membre connecté à l\'agenda de sa production, créée à la première demande.
         * @summary Get Abonnement
         * @param {CalendrierApiGetAbonnementCalendrierProductionProductionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbonnementCalendrierProductionProductionIdGet(requestParameters: CalendrierApiGetAbonnementCalendrierProductionProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAbonnementCalendrierSchema> {
            return localVarFp.getAbonnementCalendrierProductionProductionIdGet(requestParameters.productionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Nouvelle adresse : l\'ancienne cesse de répondre, pour tous les agendas qui y étaient abonnés.
         * @summary Regenerer Abonnement
         * @param {CalendrierApiRegenererAbonnementCalendrierProductionProductionIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenererAbonnementCalendrierProductionProductionIdPost(requestParameters: CalendrierApiRegenererAbonnementCalendrierProductionProductionIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAbonnementCalendrierSchema> {
            return localVarFp.regenererAbonnementCalendrierProductionProductionIdPost(requestParameters.productionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalendrierApi - interface
 * @export
 * @interface CalendrierApi
 */
export interface CalendrierApiInterface {
    /**
     * Sans JWT : lu par les agendas abonnés, le jeton fait office de mot de passe.
     * @summary Flux Calendrier
     * @param {CalendrierApiFluxCalendrierCalendrierJetonIcsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendrierApiInterface
     */
    fluxCalendrierCalendrierJetonIcsGet(requestParameters: CalendrierApiFluxCalendrierCalendrierJetonIcsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Adresse d\'abonnement du membre connecté à l\'agenda de sa production, créée à la première demande.
     * @summary Get Abonnement
     * @param {CalendrierApiGetAbonnementCalendrierProductionProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendrierApiInterface
     */
    getAbonnementCalendrierProductionProductionIdGet(requestParameters: CalendrierApiGetAbonnementCalendrierProductionProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAbonnementCalendrierSchema>;

    /**
     * Nouvelle adresse : l\'ancienne cesse de répondre, pour tous les agendas qui y étaient abonnés.
     * @summary Regenerer Abonnement
     * @param {CalendrierApiRegenererAbonnementCalendrierProductionProductionIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendrierApiInterface
     */
    regenererAbonnementCalendrierProductionProductionIdPost(requestParameters: CalendrierApiRegenererAbonnementCalendrierProductionProductionIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAbonnementCalendrierSchema>;

}

/**
 * Request parameters for fluxCalendrierCalendrierJetonIcsGet operation in CalendrierApi.
 * @export
 * @interface CalendrierApiFluxCalendrierCalendrierJetonIcsGetRequest
 */
export interface CalendrierApiFluxCalendrierCalendrierJetonIcsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CalendrierApiFluxCalendrierCalendrierJetonIcsGet
     */
    readonly jeton: string
}

/**
 * Request parameters for getAbonnementCalendrierProductionProductionIdGet operation in CalendrierApi.
 * @export
 * @interface CalendrierApiGetAbonnementCalendrierProductionProductionIdGetRequest
 */
export interface CalendrierApiGetAbonnementCalendrierProductionProductionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CalendrierApiGetAbonnementCalendrierProductionProductionIdGet
     */
    readonly productionId: string
}

/**
 * Request parameters for regenererAbonnementCalendrierProductionProductionIdPost operation in CalendrierApi.
 * @export
 * @interface CalendrierApiRegenererAbonnementCalendrierProductionProductionIdPostRequest
 */
export interface CalendrierApiRegenererAbonnementCalendrierProductionProductionIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof CalendrierApiRegenererAbonnementCalendrierProductionProductionIdPost
     */
    readonly productionId: string
}

/**
 * CalendrierApi - object-oriented interface
 * @export
 * @class CalendrierApi
 * @extends {BaseAPI}
 */
export class CalendrierApi extends BaseAPI implements CalendrierApiInterface {
    /**
     * Sans JWT : lu par les agendas abonnés, le jeton fait office de mot de passe.
     * @summary Flux Calendrier
     * @param {CalendrierApiFluxCalendrierCalendrierJetonIcsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendrierApi
     */
    public fluxCalendrierCalendrierJetonIcsGet(requestParameters: CalendrierApiFluxCalendrierCalendrierJetonIcsGetRequest, options?: RawAxiosRequestConfig) {
        return CalendrierApiFp(this.configuration).fluxCalendrierCalendrierJetonIcsGet(requestParameters.jeton, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adresse d\'abonnement du membre connecté à l\'agenda de sa production, créée à la première demande.
     * @summary Get Abonnement
     * @param {CalendrierApiGetAbonnementCalendrierProductionProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendrierApi
     */
    public getAbonnementCalendrierProductionProductionIdGet(requestParameters: CalendrierApiGetAbonnementCalendrierProductionProductionIdGetRequest, options?: RawAxiosRequestConfig) {
        return CalendrierApiFp(this.configuration).getAbonnementCalendrierProductionProductionIdGet(requestParameters.productionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nouvelle adresse : l\'ancienne cesse de répondre, pour tous les agendas qui y étaient abonnés.
     * @summary Regenerer Abonnement
     * @param {CalendrierApiRegenererAbonnementCalendrierProductionProductionIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendrierApi
     */
    public regenererAbonnementCalendrierProductionProductionIdPost(requestParameters: CalendrierApiRegenererAbonnementCalendrierProductionProductionIdPostRequest, options?: RawAxiosRequestConfig) {
        return CalendrierApiFp(this.configuration).regenererAbonnementCalendrierProductionProductionIdPost(requestParameters.productionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CastingsApi - axios parameter creator
 * @export
 */
export const CastingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Casting
         * @param {CastingFormCreate} castingFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCastingCastingsPost: async (castingFormCreate: CastingFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'castingFormCreate' is not null or undefined
            assertParamExists('createCastingCastingsPost', 'castingFormCreate', castingFormCreate)
            const localVarPath = `/castings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(castingFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Casting
         * @param {string} castingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCastingCastingsCastingIdDelete: async (castingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'castingId' is not null or undefined
            assertParamExists('deleteCastingCastingsCastingIdDelete', 'castingId', castingId)
            const localVarPath = `/castings/{casting_id}`
                .replace(`{${"casting_id"}}`, encodeURIComponent(String(castingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Castings By Production
         * @param {string} productionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListCastingsByProductionCastingsProductionProductionIdGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCastingsByProductionCastingsProductionProductionIdGet: async (productionId: string, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListCastingsByProductionCastingsProductionProductionIdGetSortOrderEnum, search?: string | null, searchFields?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('listCastingsByProductionCastingsProductionProductionIdGet', 'productionId', productionId)
            const localVarPath = `/castings/production/{production_id}`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['search_fields'] = searchFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Castings By User
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListCastingsByUserCastingsGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCastingsByUserCastingsGet: async (page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListCastingsByUserCastingsGetSortOrderEnum, search?: string | null, searchFields?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/castings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['search_fields'] = searchFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CastingsApi - functional programming interface
 * @export
 */
export const CastingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CastingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Casting
         * @param {CastingFormCreate} castingFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCastingCastingsPost(castingFormCreate: CastingFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessCastingSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCastingCastingsPost(castingFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CastingsApi.createCastingCastingsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Casting
         * @param {string} castingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCastingCastingsCastingIdDelete(castingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessCastingSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCastingCastingsCastingIdDelete(castingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CastingsApi.deleteCastingCastingsCastingIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Castings By Production
         * @param {string} productionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListCastingsByProductionCastingsProductionProductionIdGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCastingsByProductionCastingsProductionProductionIdGet(productionId: string, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListCastingsByProductionCastingsProductionProductionIdGetSortOrderEnum, search?: string | null, searchFields?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListCastingSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCastingsByProductionCastingsProductionProductionIdGet(productionId, page, pageSize, sortBy, sortOrder, search, searchFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CastingsApi.listCastingsByProductionCastingsProductionProductionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Castings By User
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListCastingsByUserCastingsGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCastingsByUserCastingsGet(page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListCastingsByUserCastingsGetSortOrderEnum, search?: string | null, searchFields?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListCastingSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCastingsByUserCastingsGet(page, pageSize, sortBy, sortOrder, search, searchFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CastingsApi.listCastingsByUserCastingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CastingsApi - factory interface
 * @export
 */
export const CastingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CastingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Casting
         * @param {CastingsApiCreateCastingCastingsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCastingCastingsPost(requestParameters: CastingsApiCreateCastingCastingsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCastingSchemaLite> {
            return localVarFp.createCastingCastingsPost(requestParameters.castingFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Casting
         * @param {CastingsApiDeleteCastingCastingsCastingIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCastingCastingsCastingIdDelete(requestParameters: CastingsApiDeleteCastingCastingsCastingIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCastingSchemaLite> {
            return localVarFp.deleteCastingCastingsCastingIdDelete(requestParameters.castingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Castings By Production
         * @param {CastingsApiListCastingsByProductionCastingsProductionProductionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCastingsByProductionCastingsProductionProductionIdGet(requestParameters: CastingsApiListCastingsByProductionCastingsProductionProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListCastingSchemaLite> {
            return localVarFp.listCastingsByProductionCastingsProductionProductionIdGet(requestParameters.productionId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Castings By User
         * @param {CastingsApiListCastingsByUserCastingsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCastingsByUserCastingsGet(requestParameters: CastingsApiListCastingsByUserCastingsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListCastingSchemaLite> {
            return localVarFp.listCastingsByUserCastingsGet(requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CastingsApi - interface
 * @export
 * @interface CastingsApi
 */
export interface CastingsApiInterface {
    /**
     * 
     * @summary Create Casting
     * @param {CastingsApiCreateCastingCastingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CastingsApiInterface
     */
    createCastingCastingsPost(requestParameters: CastingsApiCreateCastingCastingsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCastingSchemaLite>;

    /**
     * 
     * @summary Delete Casting
     * @param {CastingsApiDeleteCastingCastingsCastingIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CastingsApiInterface
     */
    deleteCastingCastingsCastingIdDelete(requestParameters: CastingsApiDeleteCastingCastingsCastingIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCastingSchemaLite>;

    /**
     * 
     * @summary List Castings By Production
     * @param {CastingsApiListCastingsByProductionCastingsProductionProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CastingsApiInterface
     */
    listCastingsByProductionCastingsProductionProductionIdGet(requestParameters: CastingsApiListCastingsByProductionCastingsProductionProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListCastingSchemaLite>;

    /**
     * 
     * @summary List Castings By User
     * @param {CastingsApiListCastingsByUserCastingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CastingsApiInterface
     */
    listCastingsByUserCastingsGet(requestParameters?: CastingsApiListCastingsByUserCastingsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListCastingSchemaLite>;

}

/**
 * Request parameters for createCastingCastingsPost operation in CastingsApi.
 * @export
 * @interface CastingsApiCreateCastingCastingsPostRequest
 */
export interface CastingsApiCreateCastingCastingsPostRequest {
    /**
     * 
     * @type {CastingFormCreate}
     * @memberof CastingsApiCreateCastingCastingsPost
     */
    readonly castingFormCreate: CastingFormCreate
}

/**
 * Request parameters for deleteCastingCastingsCastingIdDelete operation in CastingsApi.
 * @export
 * @interface CastingsApiDeleteCastingCastingsCastingIdDeleteRequest
 */
export interface CastingsApiDeleteCastingCastingsCastingIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof CastingsApiDeleteCastingCastingsCastingIdDelete
     */
    readonly castingId: string
}

/**
 * Request parameters for listCastingsByProductionCastingsProductionProductionIdGet operation in CastingsApi.
 * @export
 * @interface CastingsApiListCastingsByProductionCastingsProductionProductionIdGetRequest
 */
export interface CastingsApiListCastingsByProductionCastingsProductionProductionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CastingsApiListCastingsByProductionCastingsProductionProductionIdGet
     */
    readonly productionId: string

    /**
     * 
     * @type {number}
     * @memberof CastingsApiListCastingsByProductionCastingsProductionProductionIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CastingsApiListCastingsByProductionCastingsProductionProductionIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof CastingsApiListCastingsByProductionCastingsProductionProductionIdGet
     */
    readonly sortBy?: string | null

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof CastingsApiListCastingsByProductionCastingsProductionProductionIdGet
     */
    readonly sortOrder?: ListCastingsByProductionCastingsProductionProductionIdGetSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof CastingsApiListCastingsByProductionCastingsProductionProductionIdGet
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof CastingsApiListCastingsByProductionCastingsProductionProductionIdGet
     */
    readonly searchFields?: string | null
}

/**
 * Request parameters for listCastingsByUserCastingsGet operation in CastingsApi.
 * @export
 * @interface CastingsApiListCastingsByUserCastingsGetRequest
 */
export interface CastingsApiListCastingsByUserCastingsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CastingsApiListCastingsByUserCastingsGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CastingsApiListCastingsByUserCastingsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof CastingsApiListCastingsByUserCastingsGet
     */
    readonly sortBy?: string | null

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof CastingsApiListCastingsByUserCastingsGet
     */
    readonly sortOrder?: ListCastingsByUserCastingsGetSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof CastingsApiListCastingsByUserCastingsGet
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof CastingsApiListCastingsByUserCastingsGet
     */
    readonly searchFields?: string | null
}

/**
 * CastingsApi - object-oriented interface
 * @export
 * @class CastingsApi
 * @extends {BaseAPI}
 */
export class CastingsApi extends BaseAPI implements CastingsApiInterface {
    /**
     * 
     * @summary Create Casting
     * @param {CastingsApiCreateCastingCastingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CastingsApi
     */
    public createCastingCastingsPost(requestParameters: CastingsApiCreateCastingCastingsPostRequest, options?: RawAxiosRequestConfig) {
        return CastingsApiFp(this.configuration).createCastingCastingsPost(requestParameters.castingFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Casting
     * @param {CastingsApiDeleteCastingCastingsCastingIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CastingsApi
     */
    public deleteCastingCastingsCastingIdDelete(requestParameters: CastingsApiDeleteCastingCastingsCastingIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CastingsApiFp(this.configuration).deleteCastingCastingsCastingIdDelete(requestParameters.castingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Castings By Production
     * @param {CastingsApiListCastingsByProductionCastingsProductionProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CastingsApi
     */
    public listCastingsByProductionCastingsProductionProductionIdGet(requestParameters: CastingsApiListCastingsByProductionCastingsProductionProductionIdGetRequest, options?: RawAxiosRequestConfig) {
        return CastingsApiFp(this.configuration).listCastingsByProductionCastingsProductionProductionIdGet(requestParameters.productionId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Castings By User
     * @param {CastingsApiListCastingsByUserCastingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CastingsApi
     */
    public listCastingsByUserCastingsGet(requestParameters: CastingsApiListCastingsByUserCastingsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CastingsApiFp(this.configuration).listCastingsByUserCastingsGet(requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListCastingsByProductionCastingsProductionProductionIdGetSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListCastingsByProductionCastingsProductionProductionIdGetSortOrderEnum = typeof ListCastingsByProductionCastingsProductionProductionIdGetSortOrderEnum[keyof typeof ListCastingsByProductionCastingsProductionProductionIdGetSortOrderEnum];
/**
 * @export
 */
export const ListCastingsByUserCastingsGetSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListCastingsByUserCastingsGetSortOrderEnum = typeof ListCastingsByUserCastingsGetSortOrderEnum[keyof typeof ListCastingsByUserCastingsGetSortOrderEnum];


/**
 * CommentairesApi - axios parameter creator
 * @export
 */
export const CommentairesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Commentaire
         * @param {string} productionId 
         * @param {CommentaireFormCreate} commentaireFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommentaireCommentairesPost: async (productionId: string, commentaireFormCreate: CommentaireFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('createCommentaireCommentairesPost', 'productionId', productionId)
            // verify required parameter 'commentaireFormCreate' is not null or undefined
            assertParamExists('createCommentaireCommentairesPost', 'commentaireFormCreate', commentaireFormCreate)
            const localVarPath = `/commentaires`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productionId !== undefined) {
                localVarQueryParameter['production_id'] = productionId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentaireFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Commentaire
         * @param {string} commentaireId 
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommentaireCommentairesCommentaireIdDelete: async (commentaireId: string, productionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commentaireId' is not null or undefined
            assertParamExists('deleteCommentaireCommentairesCommentaireIdDelete', 'commentaireId', commentaireId)
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('deleteCommentaireCommentairesCommentaireIdDelete', 'productionId', productionId)
            const localVarPath = `/commentaires/{commentaire_id}`
                .replace(`{${"commentaire_id"}}`, encodeURIComponent(String(commentaireId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productionId !== undefined) {
                localVarQueryParameter['production_id'] = productionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Commentaires For Production
         * @param {string} productionId 
         * @param {string | null} [sceneId] 
         * @param {string | null} [actionId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListCommentairesForProductionCommentairesProductionProductionIdGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommentairesForProductionCommentairesProductionProductionIdGet: async (productionId: string, sceneId?: string | null, actionId?: string | null, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListCommentairesForProductionCommentairesProductionProductionIdGetSortOrderEnum, search?: string | null, searchFields?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('listCommentairesForProductionCommentairesProductionProductionIdGet', 'productionId', productionId)
            const localVarPath = `/commentaires/production/{production_id}`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sceneId !== undefined) {
                localVarQueryParameter['scene_id'] = sceneId;
            }

            if (actionId !== undefined) {
                localVarQueryParameter['action_id'] = actionId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['search_fields'] = searchFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Commentaire
         * @param {string} commentaireId 
         * @param {string} productionId 
         * @param {CommentaireFormUpdate} commentaireFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommentaireCommentairesCommentaireIdPatch: async (commentaireId: string, productionId: string, commentaireFormUpdate: CommentaireFormUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commentaireId' is not null or undefined
            assertParamExists('updateCommentaireCommentairesCommentaireIdPatch', 'commentaireId', commentaireId)
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('updateCommentaireCommentairesCommentaireIdPatch', 'productionId', productionId)
            // verify required parameter 'commentaireFormUpdate' is not null or undefined
            assertParamExists('updateCommentaireCommentairesCommentaireIdPatch', 'commentaireFormUpdate', commentaireFormUpdate)
            const localVarPath = `/commentaires/{commentaire_id}`
                .replace(`{${"commentaire_id"}}`, encodeURIComponent(String(commentaireId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productionId !== undefined) {
                localVarQueryParameter['production_id'] = productionId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentaireFormUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommentairesApi - functional programming interface
 * @export
 */
export const CommentairesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommentairesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Commentaire
         * @param {string} productionId 
         * @param {CommentaireFormCreate} commentaireFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCommentaireCommentairesPost(productionId: string, commentaireFormCreate: CommentaireFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessCommentaireSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCommentaireCommentairesPost(productionId, commentaireFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentairesApi.createCommentaireCommentairesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Commentaire
         * @param {string} commentaireId 
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCommentaireCommentairesCommentaireIdDelete(commentaireId: string, productionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessBool>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCommentaireCommentairesCommentaireIdDelete(commentaireId, productionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentairesApi.deleteCommentaireCommentairesCommentaireIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Commentaires For Production
         * @param {string} productionId 
         * @param {string | null} [sceneId] 
         * @param {string | null} [actionId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListCommentairesForProductionCommentairesProductionProductionIdGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCommentairesForProductionCommentairesProductionProductionIdGet(productionId: string, sceneId?: string | null, actionId?: string | null, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListCommentairesForProductionCommentairesProductionProductionIdGetSortOrderEnum, search?: string | null, searchFields?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListCommentaireSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCommentairesForProductionCommentairesProductionProductionIdGet(productionId, sceneId, actionId, page, pageSize, sortBy, sortOrder, search, searchFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentairesApi.listCommentairesForProductionCommentairesProductionProductionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Commentaire
         * @param {string} commentaireId 
         * @param {string} productionId 
         * @param {CommentaireFormUpdate} commentaireFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommentaireCommentairesCommentaireIdPatch(commentaireId: string, productionId: string, commentaireFormUpdate: CommentaireFormUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessCommentaireSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommentaireCommentairesCommentaireIdPatch(commentaireId, productionId, commentaireFormUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentairesApi.updateCommentaireCommentairesCommentaireIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommentairesApi - factory interface
 * @export
 */
export const CommentairesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommentairesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Commentaire
         * @param {CommentairesApiCreateCommentaireCommentairesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommentaireCommentairesPost(requestParameters: CommentairesApiCreateCommentaireCommentairesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCommentaireSchemaLite> {
            return localVarFp.createCommentaireCommentairesPost(requestParameters.productionId, requestParameters.commentaireFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Commentaire
         * @param {CommentairesApiDeleteCommentaireCommentairesCommentaireIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommentaireCommentairesCommentaireIdDelete(requestParameters: CommentairesApiDeleteCommentaireCommentairesCommentaireIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessBool> {
            return localVarFp.deleteCommentaireCommentairesCommentaireIdDelete(requestParameters.commentaireId, requestParameters.productionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Commentaires For Production
         * @param {CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommentairesForProductionCommentairesProductionProductionIdGet(requestParameters: CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListCommentaireSchemaLite> {
            return localVarFp.listCommentairesForProductionCommentairesProductionProductionIdGet(requestParameters.productionId, requestParameters.sceneId, requestParameters.actionId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Commentaire
         * @param {CommentairesApiUpdateCommentaireCommentairesCommentaireIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommentaireCommentairesCommentaireIdPatch(requestParameters: CommentairesApiUpdateCommentaireCommentairesCommentaireIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCommentaireSchemaLite> {
            return localVarFp.updateCommentaireCommentairesCommentaireIdPatch(requestParameters.commentaireId, requestParameters.productionId, requestParameters.commentaireFormUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommentairesApi - interface
 * @export
 * @interface CommentairesApi
 */
export interface CommentairesApiInterface {
    /**
     * 
     * @summary Create Commentaire
     * @param {CommentairesApiCreateCommentaireCommentairesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentairesApiInterface
     */
    createCommentaireCommentairesPost(requestParameters: CommentairesApiCreateCommentaireCommentairesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCommentaireSchemaLite>;

    /**
     * 
     * @summary Delete Commentaire
     * @param {CommentairesApiDeleteCommentaireCommentairesCommentaireIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentairesApiInterface
     */
    deleteCommentaireCommentairesCommentaireIdDelete(requestParameters: CommentairesApiDeleteCommentaireCommentairesCommentaireIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessBool>;

    /**
     * 
     * @summary List Commentaires For Production
     * @param {CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentairesApiInterface
     */
    listCommentairesForProductionCommentairesProductionProductionIdGet(requestParameters: CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListCommentaireSchemaLite>;

    /**
     * 
     * @summary Update Commentaire
     * @param {CommentairesApiUpdateCommentaireCommentairesCommentaireIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentairesApiInterface
     */
    updateCommentaireCommentairesCommentaireIdPatch(requestParameters: CommentairesApiUpdateCommentaireCommentairesCommentaireIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCommentaireSchemaLite>;

}

/**
 * Request parameters for createCommentaireCommentairesPost operation in CommentairesApi.
 * @export
 * @interface CommentairesApiCreateCommentaireCommentairesPostRequest
 */
export interface CommentairesApiCreateCommentaireCommentairesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof CommentairesApiCreateCommentaireCommentairesPost
     */
    readonly productionId: string

    /**
     * 
     * @type {CommentaireFormCreate}
     * @memberof CommentairesApiCreateCommentaireCommentairesPost
     */
    readonly commentaireFormCreate: CommentaireFormCreate
}

/**
 * Request parameters for deleteCommentaireCommentairesCommentaireIdDelete operation in CommentairesApi.
 * @export
 * @interface CommentairesApiDeleteCommentaireCommentairesCommentaireIdDeleteRequest
 */
export interface CommentairesApiDeleteCommentaireCommentairesCommentaireIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof CommentairesApiDeleteCommentaireCommentairesCommentaireIdDelete
     */
    readonly commentaireId: string

    /**
     * 
     * @type {string}
     * @memberof CommentairesApiDeleteCommentaireCommentairesCommentaireIdDelete
     */
    readonly productionId: string
}

/**
 * Request parameters for listCommentairesForProductionCommentairesProductionProductionIdGet operation in CommentairesApi.
 * @export
 * @interface CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGetRequest
 */
export interface CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGet
     */
    readonly productionId: string

    /**
     * 
     * @type {string}
     * @memberof CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGet
     */
    readonly sceneId?: string | null

    /**
     * 
     * @type {string}
     * @memberof CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGet
     */
    readonly actionId?: string | null

    /**
     * 
     * @type {number}
     * @memberof CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGet
     */
    readonly sortBy?: string | null

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGet
     */
    readonly sortOrder?: ListCommentairesForProductionCommentairesProductionProductionIdGetSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGet
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGet
     */
    readonly searchFields?: string | null
}

/**
 * Request parameters for updateCommentaireCommentairesCommentaireIdPatch operation in CommentairesApi.
 * @export
 * @interface CommentairesApiUpdateCommentaireCommentairesCommentaireIdPatchRequest
 */
export interface CommentairesApiUpdateCommentaireCommentairesCommentaireIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof CommentairesApiUpdateCommentaireCommentairesCommentaireIdPatch
     */
    readonly commentaireId: string

    /**
     * 
     * @type {string}
     * @memberof CommentairesApiUpdateCommentaireCommentairesCommentaireIdPatch
     */
    readonly productionId: string

    /**
     * 
     * @type {CommentaireFormUpdate}
     * @memberof CommentairesApiUpdateCommentaireCommentairesCommentaireIdPatch
     */
    readonly commentaireFormUpdate: CommentaireFormUpdate
}

/**
 * CommentairesApi - object-oriented interface
 * @export
 * @class CommentairesApi
 * @extends {BaseAPI}
 */
export class CommentairesApi extends BaseAPI implements CommentairesApiInterface {
    /**
     * 
     * @summary Create Commentaire
     * @param {CommentairesApiCreateCommentaireCommentairesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentairesApi
     */
    public createCommentaireCommentairesPost(requestParameters: CommentairesApiCreateCommentaireCommentairesPostRequest, options?: RawAxiosRequestConfig) {
        return CommentairesApiFp(this.configuration).createCommentaireCommentairesPost(requestParameters.productionId, requestParameters.commentaireFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Commentaire
     * @param {CommentairesApiDeleteCommentaireCommentairesCommentaireIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentairesApi
     */
    public deleteCommentaireCommentairesCommentaireIdDelete(requestParameters: CommentairesApiDeleteCommentaireCommentairesCommentaireIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CommentairesApiFp(this.configuration).deleteCommentaireCommentairesCommentaireIdDelete(requestParameters.commentaireId, requestParameters.productionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Commentaires For Production
     * @param {CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentairesApi
     */
    public listCommentairesForProductionCommentairesProductionProductionIdGet(requestParameters: CommentairesApiListCommentairesForProductionCommentairesProductionProductionIdGetRequest, options?: RawAxiosRequestConfig) {
        return CommentairesApiFp(this.configuration).listCommentairesForProductionCommentairesProductionProductionIdGet(requestParameters.productionId, requestParameters.sceneId, requestParameters.actionId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Commentaire
     * @param {CommentairesApiUpdateCommentaireCommentairesCommentaireIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentairesApi
     */
    public updateCommentaireCommentairesCommentaireIdPatch(requestParameters: CommentairesApiUpdateCommentaireCommentairesCommentaireIdPatchRequest, options?: RawAxiosRequestConfig) {
        return CommentairesApiFp(this.configuration).updateCommentaireCommentairesCommentaireIdPatch(requestParameters.commentaireId, requestParameters.productionId, requestParameters.commentaireFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListCommentairesForProductionCommentairesProductionProductionIdGetSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListCommentairesForProductionCommentairesProductionProductionIdGetSortOrderEnum = typeof ListCommentairesForProductionCommentairesProductionProductionIdGetSortOrderEnum[keyof typeof ListCommentairesForProductionCommentairesProductionProductionIdGetSortOrderEnum];


/**
 * CompagniesApi - axios parameter creator
 * @export
 */
export const CompagniesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Adhesion
         * @param {string} compagnieId 
         * @param {AdhesionFormCreate} adhesionFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdhesionCompagniesCompagnieIdAdhesionsPost: async (compagnieId: string, adhesionFormCreate: AdhesionFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'compagnieId' is not null or undefined
            assertParamExists('addAdhesionCompagniesCompagnieIdAdhesionsPost', 'compagnieId', compagnieId)
            // verify required parameter 'adhesionFormCreate' is not null or undefined
            assertParamExists('addAdhesionCompagniesCompagnieIdAdhesionsPost', 'adhesionFormCreate', adhesionFormCreate)
            const localVarPath = `/compagnies/{compagnie_id}/adhesions`
                .replace(`{${"compagnie_id"}}`, encodeURIComponent(String(compagnieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adhesionFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Compagnie
         * @param {CompagnieFormCreate} compagnieFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompagnieCompagniesPost: async (compagnieFormCreate: CompagnieFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'compagnieFormCreate' is not null or undefined
            assertParamExists('createCompagnieCompagniesPost', 'compagnieFormCreate', compagnieFormCreate)
            const localVarPath = `/compagnies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(compagnieFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Definir Logo
         * @param {string} compagnieId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        definirLogoCompagniesCompagnieIdLogoPost: async (compagnieId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'compagnieId' is not null or undefined
            assertParamExists('definirLogoCompagniesCompagnieIdLogoPost', 'compagnieId', compagnieId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('definirLogoCompagniesCompagnieIdLogoPost', 'file', file)
            const localVarPath = `/compagnies/{compagnie_id}/logo`
                .replace(`{${"compagnie_id"}}`, encodeURIComponent(String(compagnieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Adhesion
         * @param {string} compagnieId 
         * @param {string} personneId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDelete: async (compagnieId: string, personneId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'compagnieId' is not null or undefined
            assertParamExists('deleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDelete', 'compagnieId', compagnieId)
            // verify required parameter 'personneId' is not null or undefined
            assertParamExists('deleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDelete', 'personneId', personneId)
            const localVarPath = `/compagnies/{compagnie_id}/adhesions/{personne_id}`
                .replace(`{${"compagnie_id"}}`, encodeURIComponent(String(compagnieId)))
                .replace(`{${"personne_id"}}`, encodeURIComponent(String(personneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Compagnie
         * @param {string} compagnieId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompagnieCompagniesCompagnieIdDelete: async (compagnieId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'compagnieId' is not null or undefined
            assertParamExists('deleteCompagnieCompagniesCompagnieIdDelete', 'compagnieId', compagnieId)
            const localVarPath = `/compagnies/{compagnie_id}`
                .replace(`{${"compagnie_id"}}`, encodeURIComponent(String(compagnieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Compagnie
         * @param {string} compagnieId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompagnieCompagniesCompagnieIdGet: async (compagnieId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'compagnieId' is not null or undefined
            assertParamExists('getCompagnieCompagniesCompagnieIdGet', 'compagnieId', compagnieId)
            const localVarPath = `/compagnies/{compagnie_id}`
                .replace(`{${"compagnie_id"}}`, encodeURIComponent(String(compagnieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * `v` (logo_version) n\'est pas lu : il change l\'URL à chaque logo, ce qui permet un cache immuable.
         * @summary Get Logo
         * @param {string} compagnieId 
         * @param {string | null} [v] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogoCompagniesCompagnieIdLogoGet: async (compagnieId: string, v?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'compagnieId' is not null or undefined
            assertParamExists('getLogoCompagniesCompagnieIdLogoGet', 'compagnieId', compagnieId)
            const localVarPath = `/compagnies/{compagnie_id}/logo`
                .replace(`{${"compagnie_id"}}`, encodeURIComponent(String(compagnieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (v !== undefined) {
                localVarQueryParameter['v'] = v;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Adhesions
         * @param {string} compagnieId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdhesionsCompagniesCompagnieIdAdhesionsGet: async (compagnieId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'compagnieId' is not null or undefined
            assertParamExists('listAdhesionsCompagniesCompagnieIdAdhesionsGet', 'compagnieId', compagnieId)
            const localVarPath = `/compagnies/{compagnie_id}/adhesions`
                .replace(`{${"compagnie_id"}}`, encodeURIComponent(String(compagnieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Compagnies
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListCompagniesCompagniesGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompagniesCompagniesGet: async (page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListCompagniesCompagniesGetSortOrderEnum, search?: string | null, searchFields?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/compagnies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['search_fields'] = searchFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reordonner Troupes
         * @param {string} compagnieId 
         * @param {TroupesOrdreForm} troupesOrdreForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reordonnerTroupesCompagniesCompagnieIdTroupesOrdrePut: async (compagnieId: string, troupesOrdreForm: TroupesOrdreForm, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'compagnieId' is not null or undefined
            assertParamExists('reordonnerTroupesCompagniesCompagnieIdTroupesOrdrePut', 'compagnieId', compagnieId)
            // verify required parameter 'troupesOrdreForm' is not null or undefined
            assertParamExists('reordonnerTroupesCompagniesCompagnieIdTroupesOrdrePut', 'troupesOrdreForm', troupesOrdreForm)
            const localVarPath = `/compagnies/{compagnie_id}/troupes/ordre`
                .replace(`{${"compagnie_id"}}`, encodeURIComponent(String(compagnieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(troupesOrdreForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retirer Logo
         * @param {string} compagnieId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retirerLogoCompagniesCompagnieIdLogoDelete: async (compagnieId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'compagnieId' is not null or undefined
            assertParamExists('retirerLogoCompagniesCompagnieIdLogoDelete', 'compagnieId', compagnieId)
            const localVarPath = `/compagnies/{compagnie_id}/logo`
                .replace(`{${"compagnie_id"}}`, encodeURIComponent(String(compagnieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Adhesion
         * @param {string} compagnieId 
         * @param {string} personneId 
         * @param {AdhesionFormUpdate} adhesionFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch: async (compagnieId: string, personneId: string, adhesionFormUpdate: AdhesionFormUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'compagnieId' is not null or undefined
            assertParamExists('updateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch', 'compagnieId', compagnieId)
            // verify required parameter 'personneId' is not null or undefined
            assertParamExists('updateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch', 'personneId', personneId)
            // verify required parameter 'adhesionFormUpdate' is not null or undefined
            assertParamExists('updateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch', 'adhesionFormUpdate', adhesionFormUpdate)
            const localVarPath = `/compagnies/{compagnie_id}/adhesions/{personne_id}`
                .replace(`{${"compagnie_id"}}`, encodeURIComponent(String(compagnieId)))
                .replace(`{${"personne_id"}}`, encodeURIComponent(String(personneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adhesionFormUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Compagnie
         * @param {string} compagnieId 
         * @param {CompagnieFormUpdate} compagnieFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompagnieCompagniesCompagnieIdPatch: async (compagnieId: string, compagnieFormUpdate: CompagnieFormUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'compagnieId' is not null or undefined
            assertParamExists('updateCompagnieCompagniesCompagnieIdPatch', 'compagnieId', compagnieId)
            // verify required parameter 'compagnieFormUpdate' is not null or undefined
            assertParamExists('updateCompagnieCompagniesCompagnieIdPatch', 'compagnieFormUpdate', compagnieFormUpdate)
            const localVarPath = `/compagnies/{compagnie_id}`
                .replace(`{${"compagnie_id"}}`, encodeURIComponent(String(compagnieId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(compagnieFormUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompagniesApi - functional programming interface
 * @export
 */
export const CompagniesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompagniesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Adhesion
         * @param {string} compagnieId 
         * @param {AdhesionFormCreate} adhesionFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAdhesionCompagniesCompagnieIdAdhesionsPost(compagnieId: string, adhesionFormCreate: AdhesionFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessAdhesionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAdhesionCompagniesCompagnieIdAdhesionsPost(compagnieId, adhesionFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompagniesApi.addAdhesionCompagniesCompagnieIdAdhesionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Compagnie
         * @param {CompagnieFormCreate} compagnieFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCompagnieCompagniesPost(compagnieFormCreate: CompagnieFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessCompagnieSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCompagnieCompagniesPost(compagnieFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompagniesApi.createCompagnieCompagniesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Definir Logo
         * @param {string} compagnieId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async definirLogoCompagniesCompagnieIdLogoPost(compagnieId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessCompagnieSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.definirLogoCompagniesCompagnieIdLogoPost(compagnieId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompagniesApi.definirLogoCompagniesCompagnieIdLogoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Adhesion
         * @param {string} compagnieId 
         * @param {string} personneId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDelete(compagnieId: string, personneId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessAdhesionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDelete(compagnieId, personneId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompagniesApi.deleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Compagnie
         * @param {string} compagnieId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCompagnieCompagniesCompagnieIdDelete(compagnieId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessCompagnieSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCompagnieCompagniesCompagnieIdDelete(compagnieId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompagniesApi.deleteCompagnieCompagniesCompagnieIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Compagnie
         * @param {string} compagnieId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompagnieCompagniesCompagnieIdGet(compagnieId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessCompagnieSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompagnieCompagniesCompagnieIdGet(compagnieId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompagniesApi.getCompagnieCompagniesCompagnieIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * `v` (logo_version) n\'est pas lu : il change l\'URL à chaque logo, ce qui permet un cache immuable.
         * @summary Get Logo
         * @param {string} compagnieId 
         * @param {string | null} [v] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogoCompagniesCompagnieIdLogoGet(compagnieId: string, v?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogoCompagniesCompagnieIdLogoGet(compagnieId, v, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompagniesApi.getLogoCompagniesCompagnieIdLogoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Adhesions
         * @param {string} compagnieId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAdhesionsCompagniesCompagnieIdAdhesionsGet(compagnieId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListAdhesionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAdhesionsCompagniesCompagnieIdAdhesionsGet(compagnieId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompagniesApi.listAdhesionsCompagniesCompagnieIdAdhesionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Compagnies
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListCompagniesCompagniesGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCompagniesCompagniesGet(page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListCompagniesCompagniesGetSortOrderEnum, search?: string | null, searchFields?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListCompagnieSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCompagniesCompagniesGet(page, pageSize, sortBy, sortOrder, search, searchFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompagniesApi.listCompagniesCompagniesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reordonner Troupes
         * @param {string} compagnieId 
         * @param {TroupesOrdreForm} troupesOrdreForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reordonnerTroupesCompagniesCompagnieIdTroupesOrdrePut(compagnieId: string, troupesOrdreForm: TroupesOrdreForm, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListTroupeSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reordonnerTroupesCompagniesCompagnieIdTroupesOrdrePut(compagnieId, troupesOrdreForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompagniesApi.reordonnerTroupesCompagniesCompagnieIdTroupesOrdrePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retirer Logo
         * @param {string} compagnieId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retirerLogoCompagniesCompagnieIdLogoDelete(compagnieId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessCompagnieSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retirerLogoCompagniesCompagnieIdLogoDelete(compagnieId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompagniesApi.retirerLogoCompagniesCompagnieIdLogoDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Adhesion
         * @param {string} compagnieId 
         * @param {string} personneId 
         * @param {AdhesionFormUpdate} adhesionFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch(compagnieId: string, personneId: string, adhesionFormUpdate: AdhesionFormUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessAdhesionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch(compagnieId, personneId, adhesionFormUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompagniesApi.updateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Compagnie
         * @param {string} compagnieId 
         * @param {CompagnieFormUpdate} compagnieFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompagnieCompagniesCompagnieIdPatch(compagnieId: string, compagnieFormUpdate: CompagnieFormUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessCompagnieSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompagnieCompagniesCompagnieIdPatch(compagnieId, compagnieFormUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompagniesApi.updateCompagnieCompagniesCompagnieIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompagniesApi - factory interface
 * @export
 */
export const CompagniesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompagniesApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Adhesion
         * @param {CompagniesApiAddAdhesionCompagniesCompagnieIdAdhesionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdhesionCompagniesCompagnieIdAdhesionsPost(requestParameters: CompagniesApiAddAdhesionCompagniesCompagnieIdAdhesionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAdhesionSchemaLite> {
            return localVarFp.addAdhesionCompagniesCompagnieIdAdhesionsPost(requestParameters.compagnieId, requestParameters.adhesionFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Compagnie
         * @param {CompagniesApiCreateCompagnieCompagniesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompagnieCompagniesPost(requestParameters: CompagniesApiCreateCompagnieCompagniesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCompagnieSchemaLite> {
            return localVarFp.createCompagnieCompagniesPost(requestParameters.compagnieFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Definir Logo
         * @param {CompagniesApiDefinirLogoCompagniesCompagnieIdLogoPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        definirLogoCompagniesCompagnieIdLogoPost(requestParameters: CompagniesApiDefinirLogoCompagniesCompagnieIdLogoPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCompagnieSchemaLite> {
            return localVarFp.definirLogoCompagniesCompagnieIdLogoPost(requestParameters.compagnieId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Adhesion
         * @param {CompagniesApiDeleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDelete(requestParameters: CompagniesApiDeleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAdhesionSchemaLite> {
            return localVarFp.deleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDelete(requestParameters.compagnieId, requestParameters.personneId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Compagnie
         * @param {CompagniesApiDeleteCompagnieCompagniesCompagnieIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompagnieCompagniesCompagnieIdDelete(requestParameters: CompagniesApiDeleteCompagnieCompagniesCompagnieIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCompagnieSchemaLite> {
            return localVarFp.deleteCompagnieCompagniesCompagnieIdDelete(requestParameters.compagnieId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Compagnie
         * @param {CompagniesApiGetCompagnieCompagniesCompagnieIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompagnieCompagniesCompagnieIdGet(requestParameters: CompagniesApiGetCompagnieCompagniesCompagnieIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCompagnieSchema> {
            return localVarFp.getCompagnieCompagniesCompagnieIdGet(requestParameters.compagnieId, options).then((request) => request(axios, basePath));
        },
        /**
         * `v` (logo_version) n\'est pas lu : il change l\'URL à chaque logo, ce qui permet un cache immuable.
         * @summary Get Logo
         * @param {CompagniesApiGetLogoCompagniesCompagnieIdLogoGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogoCompagniesCompagnieIdLogoGet(requestParameters: CompagniesApiGetLogoCompagniesCompagnieIdLogoGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getLogoCompagniesCompagnieIdLogoGet(requestParameters.compagnieId, requestParameters.v, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Adhesions
         * @param {CompagniesApiListAdhesionsCompagniesCompagnieIdAdhesionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdhesionsCompagniesCompagnieIdAdhesionsGet(requestParameters: CompagniesApiListAdhesionsCompagniesCompagnieIdAdhesionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListAdhesionSchemaLite> {
            return localVarFp.listAdhesionsCompagniesCompagnieIdAdhesionsGet(requestParameters.compagnieId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Compagnies
         * @param {CompagniesApiListCompagniesCompagniesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompagniesCompagniesGet(requestParameters: CompagniesApiListCompagniesCompagniesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListCompagnieSchemaLite> {
            return localVarFp.listCompagniesCompagniesGet(requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reordonner Troupes
         * @param {CompagniesApiReordonnerTroupesCompagniesCompagnieIdTroupesOrdrePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reordonnerTroupesCompagniesCompagnieIdTroupesOrdrePut(requestParameters: CompagniesApiReordonnerTroupesCompagniesCompagnieIdTroupesOrdrePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListTroupeSchemaLite> {
            return localVarFp.reordonnerTroupesCompagniesCompagnieIdTroupesOrdrePut(requestParameters.compagnieId, requestParameters.troupesOrdreForm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retirer Logo
         * @param {CompagniesApiRetirerLogoCompagniesCompagnieIdLogoDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retirerLogoCompagniesCompagnieIdLogoDelete(requestParameters: CompagniesApiRetirerLogoCompagniesCompagnieIdLogoDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCompagnieSchemaLite> {
            return localVarFp.retirerLogoCompagniesCompagnieIdLogoDelete(requestParameters.compagnieId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Adhesion
         * @param {CompagniesApiUpdateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch(requestParameters: CompagniesApiUpdateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAdhesionSchemaLite> {
            return localVarFp.updateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch(requestParameters.compagnieId, requestParameters.personneId, requestParameters.adhesionFormUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Compagnie
         * @param {CompagniesApiUpdateCompagnieCompagniesCompagnieIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompagnieCompagniesCompagnieIdPatch(requestParameters: CompagniesApiUpdateCompagnieCompagniesCompagnieIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCompagnieSchemaLite> {
            return localVarFp.updateCompagnieCompagniesCompagnieIdPatch(requestParameters.compagnieId, requestParameters.compagnieFormUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompagniesApi - interface
 * @export
 * @interface CompagniesApi
 */
export interface CompagniesApiInterface {
    /**
     * 
     * @summary Add Adhesion
     * @param {CompagniesApiAddAdhesionCompagniesCompagnieIdAdhesionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApiInterface
     */
    addAdhesionCompagniesCompagnieIdAdhesionsPost(requestParameters: CompagniesApiAddAdhesionCompagniesCompagnieIdAdhesionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAdhesionSchemaLite>;

    /**
     * 
     * @summary Create Compagnie
     * @param {CompagniesApiCreateCompagnieCompagniesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApiInterface
     */
    createCompagnieCompagniesPost(requestParameters: CompagniesApiCreateCompagnieCompagniesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCompagnieSchemaLite>;

    /**
     * 
     * @summary Definir Logo
     * @param {CompagniesApiDefinirLogoCompagniesCompagnieIdLogoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApiInterface
     */
    definirLogoCompagniesCompagnieIdLogoPost(requestParameters: CompagniesApiDefinirLogoCompagniesCompagnieIdLogoPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCompagnieSchemaLite>;

    /**
     * 
     * @summary Delete Adhesion
     * @param {CompagniesApiDeleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApiInterface
     */
    deleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDelete(requestParameters: CompagniesApiDeleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAdhesionSchemaLite>;

    /**
     * 
     * @summary Delete Compagnie
     * @param {CompagniesApiDeleteCompagnieCompagniesCompagnieIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApiInterface
     */
    deleteCompagnieCompagniesCompagnieIdDelete(requestParameters: CompagniesApiDeleteCompagnieCompagniesCompagnieIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCompagnieSchemaLite>;

    /**
     * 
     * @summary Get Compagnie
     * @param {CompagniesApiGetCompagnieCompagniesCompagnieIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApiInterface
     */
    getCompagnieCompagniesCompagnieIdGet(requestParameters: CompagniesApiGetCompagnieCompagniesCompagnieIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCompagnieSchema>;

    /**
     * `v` (logo_version) n\'est pas lu : il change l\'URL à chaque logo, ce qui permet un cache immuable.
     * @summary Get Logo
     * @param {CompagniesApiGetLogoCompagniesCompagnieIdLogoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApiInterface
     */
    getLogoCompagniesCompagnieIdLogoGet(requestParameters: CompagniesApiGetLogoCompagniesCompagnieIdLogoGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary List Adhesions
     * @param {CompagniesApiListAdhesionsCompagniesCompagnieIdAdhesionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApiInterface
     */
    listAdhesionsCompagniesCompagnieIdAdhesionsGet(requestParameters: CompagniesApiListAdhesionsCompagniesCompagnieIdAdhesionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListAdhesionSchemaLite>;

    /**
     * 
     * @summary List Compagnies
     * @param {CompagniesApiListCompagniesCompagniesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApiInterface
     */
    listCompagniesCompagniesGet(requestParameters?: CompagniesApiListCompagniesCompagniesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListCompagnieSchemaLite>;

    /**
     * 
     * @summary Reordonner Troupes
     * @param {CompagniesApiReordonnerTroupesCompagniesCompagnieIdTroupesOrdrePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApiInterface
     */
    reordonnerTroupesCompagniesCompagnieIdTroupesOrdrePut(requestParameters: CompagniesApiReordonnerTroupesCompagniesCompagnieIdTroupesOrdrePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListTroupeSchemaLite>;

    /**
     * 
     * @summary Retirer Logo
     * @param {CompagniesApiRetirerLogoCompagniesCompagnieIdLogoDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApiInterface
     */
    retirerLogoCompagniesCompagnieIdLogoDelete(requestParameters: CompagniesApiRetirerLogoCompagniesCompagnieIdLogoDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCompagnieSchemaLite>;

    /**
     * 
     * @summary Update Adhesion
     * @param {CompagniesApiUpdateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApiInterface
     */
    updateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch(requestParameters: CompagniesApiUpdateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAdhesionSchemaLite>;

    /**
     * 
     * @summary Update Compagnie
     * @param {CompagniesApiUpdateCompagnieCompagniesCompagnieIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApiInterface
     */
    updateCompagnieCompagniesCompagnieIdPatch(requestParameters: CompagniesApiUpdateCompagnieCompagniesCompagnieIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCompagnieSchemaLite>;

}

/**
 * Request parameters for addAdhesionCompagniesCompagnieIdAdhesionsPost operation in CompagniesApi.
 * @export
 * @interface CompagniesApiAddAdhesionCompagniesCompagnieIdAdhesionsPostRequest
 */
export interface CompagniesApiAddAdhesionCompagniesCompagnieIdAdhesionsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof CompagniesApiAddAdhesionCompagniesCompagnieIdAdhesionsPost
     */
    readonly compagnieId: string

    /**
     * 
     * @type {AdhesionFormCreate}
     * @memberof CompagniesApiAddAdhesionCompagniesCompagnieIdAdhesionsPost
     */
    readonly adhesionFormCreate: AdhesionFormCreate
}

/**
 * Request parameters for createCompagnieCompagniesPost operation in CompagniesApi.
 * @export
 * @interface CompagniesApiCreateCompagnieCompagniesPostRequest
 */
export interface CompagniesApiCreateCompagnieCompagniesPostRequest {
    /**
     * 
     * @type {CompagnieFormCreate}
     * @memberof CompagniesApiCreateCompagnieCompagniesPost
     */
    readonly compagnieFormCreate: CompagnieFormCreate
}

/**
 * Request parameters for definirLogoCompagniesCompagnieIdLogoPost operation in CompagniesApi.
 * @export
 * @interface CompagniesApiDefinirLogoCompagniesCompagnieIdLogoPostRequest
 */
export interface CompagniesApiDefinirLogoCompagniesCompagnieIdLogoPostRequest {
    /**
     * 
     * @type {string}
     * @memberof CompagniesApiDefinirLogoCompagniesCompagnieIdLogoPost
     */
    readonly compagnieId: string

    /**
     * 
     * @type {File}
     * @memberof CompagniesApiDefinirLogoCompagniesCompagnieIdLogoPost
     */
    readonly file: File
}

/**
 * Request parameters for deleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDelete operation in CompagniesApi.
 * @export
 * @interface CompagniesApiDeleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDeleteRequest
 */
export interface CompagniesApiDeleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof CompagniesApiDeleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDelete
     */
    readonly compagnieId: string

    /**
     * 
     * @type {string}
     * @memberof CompagniesApiDeleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDelete
     */
    readonly personneId: string
}

/**
 * Request parameters for deleteCompagnieCompagniesCompagnieIdDelete operation in CompagniesApi.
 * @export
 * @interface CompagniesApiDeleteCompagnieCompagniesCompagnieIdDeleteRequest
 */
export interface CompagniesApiDeleteCompagnieCompagniesCompagnieIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof CompagniesApiDeleteCompagnieCompagniesCompagnieIdDelete
     */
    readonly compagnieId: string
}

/**
 * Request parameters for getCompagnieCompagniesCompagnieIdGet operation in CompagniesApi.
 * @export
 * @interface CompagniesApiGetCompagnieCompagniesCompagnieIdGetRequest
 */
export interface CompagniesApiGetCompagnieCompagniesCompagnieIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CompagniesApiGetCompagnieCompagniesCompagnieIdGet
     */
    readonly compagnieId: string
}

/**
 * Request parameters for getLogoCompagniesCompagnieIdLogoGet operation in CompagniesApi.
 * @export
 * @interface CompagniesApiGetLogoCompagniesCompagnieIdLogoGetRequest
 */
export interface CompagniesApiGetLogoCompagniesCompagnieIdLogoGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CompagniesApiGetLogoCompagniesCompagnieIdLogoGet
     */
    readonly compagnieId: string

    /**
     * 
     * @type {string}
     * @memberof CompagniesApiGetLogoCompagniesCompagnieIdLogoGet
     */
    readonly v?: string | null
}

/**
 * Request parameters for listAdhesionsCompagniesCompagnieIdAdhesionsGet operation in CompagniesApi.
 * @export
 * @interface CompagniesApiListAdhesionsCompagniesCompagnieIdAdhesionsGetRequest
 */
export interface CompagniesApiListAdhesionsCompagniesCompagnieIdAdhesionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CompagniesApiListAdhesionsCompagniesCompagnieIdAdhesionsGet
     */
    readonly compagnieId: string
}

/**
 * Request parameters for listCompagniesCompagniesGet operation in CompagniesApi.
 * @export
 * @interface CompagniesApiListCompagniesCompagniesGetRequest
 */
export interface CompagniesApiListCompagniesCompagniesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CompagniesApiListCompagniesCompagniesGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CompagniesApiListCompagniesCompagniesGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof CompagniesApiListCompagniesCompagniesGet
     */
    readonly sortBy?: string | null

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof CompagniesApiListCompagniesCompagniesGet
     */
    readonly sortOrder?: ListCompagniesCompagniesGetSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof CompagniesApiListCompagniesCompagniesGet
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof CompagniesApiListCompagniesCompagniesGet
     */
    readonly searchFields?: string | null
}

/**
 * Request parameters for reordonnerTroupesCompagniesCompagnieIdTroupesOrdrePut operation in CompagniesApi.
 * @export
 * @interface CompagniesApiReordonnerTroupesCompagniesCompagnieIdTroupesOrdrePutRequest
 */
export interface CompagniesApiReordonnerTroupesCompagniesCompagnieIdTroupesOrdrePutRequest {
    /**
     * 
     * @type {string}
     * @memberof CompagniesApiReordonnerTroupesCompagniesCompagnieIdTroupesOrdrePut
     */
    readonly compagnieId: string

    /**
     * 
     * @type {TroupesOrdreForm}
     * @memberof CompagniesApiReordonnerTroupesCompagniesCompagnieIdTroupesOrdrePut
     */
    readonly troupesOrdreForm: TroupesOrdreForm
}

/**
 * Request parameters for retirerLogoCompagniesCompagnieIdLogoDelete operation in CompagniesApi.
 * @export
 * @interface CompagniesApiRetirerLogoCompagniesCompagnieIdLogoDeleteRequest
 */
export interface CompagniesApiRetirerLogoCompagniesCompagnieIdLogoDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof CompagniesApiRetirerLogoCompagniesCompagnieIdLogoDelete
     */
    readonly compagnieId: string
}

/**
 * Request parameters for updateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch operation in CompagniesApi.
 * @export
 * @interface CompagniesApiUpdateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatchRequest
 */
export interface CompagniesApiUpdateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof CompagniesApiUpdateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch
     */
    readonly compagnieId: string

    /**
     * 
     * @type {string}
     * @memberof CompagniesApiUpdateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch
     */
    readonly personneId: string

    /**
     * 
     * @type {AdhesionFormUpdate}
     * @memberof CompagniesApiUpdateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch
     */
    readonly adhesionFormUpdate: AdhesionFormUpdate
}

/**
 * Request parameters for updateCompagnieCompagniesCompagnieIdPatch operation in CompagniesApi.
 * @export
 * @interface CompagniesApiUpdateCompagnieCompagniesCompagnieIdPatchRequest
 */
export interface CompagniesApiUpdateCompagnieCompagniesCompagnieIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof CompagniesApiUpdateCompagnieCompagniesCompagnieIdPatch
     */
    readonly compagnieId: string

    /**
     * 
     * @type {CompagnieFormUpdate}
     * @memberof CompagniesApiUpdateCompagnieCompagniesCompagnieIdPatch
     */
    readonly compagnieFormUpdate: CompagnieFormUpdate
}

/**
 * CompagniesApi - object-oriented interface
 * @export
 * @class CompagniesApi
 * @extends {BaseAPI}
 */
export class CompagniesApi extends BaseAPI implements CompagniesApiInterface {
    /**
     * 
     * @summary Add Adhesion
     * @param {CompagniesApiAddAdhesionCompagniesCompagnieIdAdhesionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApi
     */
    public addAdhesionCompagniesCompagnieIdAdhesionsPost(requestParameters: CompagniesApiAddAdhesionCompagniesCompagnieIdAdhesionsPostRequest, options?: RawAxiosRequestConfig) {
        return CompagniesApiFp(this.configuration).addAdhesionCompagniesCompagnieIdAdhesionsPost(requestParameters.compagnieId, requestParameters.adhesionFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Compagnie
     * @param {CompagniesApiCreateCompagnieCompagniesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApi
     */
    public createCompagnieCompagniesPost(requestParameters: CompagniesApiCreateCompagnieCompagniesPostRequest, options?: RawAxiosRequestConfig) {
        return CompagniesApiFp(this.configuration).createCompagnieCompagniesPost(requestParameters.compagnieFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Definir Logo
     * @param {CompagniesApiDefinirLogoCompagniesCompagnieIdLogoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApi
     */
    public definirLogoCompagniesCompagnieIdLogoPost(requestParameters: CompagniesApiDefinirLogoCompagniesCompagnieIdLogoPostRequest, options?: RawAxiosRequestConfig) {
        return CompagniesApiFp(this.configuration).definirLogoCompagniesCompagnieIdLogoPost(requestParameters.compagnieId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Adhesion
     * @param {CompagniesApiDeleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApi
     */
    public deleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDelete(requestParameters: CompagniesApiDeleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CompagniesApiFp(this.configuration).deleteAdhesionCompagniesCompagnieIdAdhesionsPersonneIdDelete(requestParameters.compagnieId, requestParameters.personneId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Compagnie
     * @param {CompagniesApiDeleteCompagnieCompagniesCompagnieIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApi
     */
    public deleteCompagnieCompagniesCompagnieIdDelete(requestParameters: CompagniesApiDeleteCompagnieCompagniesCompagnieIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CompagniesApiFp(this.configuration).deleteCompagnieCompagniesCompagnieIdDelete(requestParameters.compagnieId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Compagnie
     * @param {CompagniesApiGetCompagnieCompagniesCompagnieIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApi
     */
    public getCompagnieCompagniesCompagnieIdGet(requestParameters: CompagniesApiGetCompagnieCompagniesCompagnieIdGetRequest, options?: RawAxiosRequestConfig) {
        return CompagniesApiFp(this.configuration).getCompagnieCompagniesCompagnieIdGet(requestParameters.compagnieId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * `v` (logo_version) n\'est pas lu : il change l\'URL à chaque logo, ce qui permet un cache immuable.
     * @summary Get Logo
     * @param {CompagniesApiGetLogoCompagniesCompagnieIdLogoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApi
     */
    public getLogoCompagniesCompagnieIdLogoGet(requestParameters: CompagniesApiGetLogoCompagniesCompagnieIdLogoGetRequest, options?: RawAxiosRequestConfig) {
        return CompagniesApiFp(this.configuration).getLogoCompagniesCompagnieIdLogoGet(requestParameters.compagnieId, requestParameters.v, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Adhesions
     * @param {CompagniesApiListAdhesionsCompagniesCompagnieIdAdhesionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApi
     */
    public listAdhesionsCompagniesCompagnieIdAdhesionsGet(requestParameters: CompagniesApiListAdhesionsCompagniesCompagnieIdAdhesionsGetRequest, options?: RawAxiosRequestConfig) {
        return CompagniesApiFp(this.configuration).listAdhesionsCompagniesCompagnieIdAdhesionsGet(requestParameters.compagnieId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Compagnies
     * @param {CompagniesApiListCompagniesCompagniesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApi
     */
    public listCompagniesCompagniesGet(requestParameters: CompagniesApiListCompagniesCompagniesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CompagniesApiFp(this.configuration).listCompagniesCompagniesGet(requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reordonner Troupes
     * @param {CompagniesApiReordonnerTroupesCompagniesCompagnieIdTroupesOrdrePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApi
     */
    public reordonnerTroupesCompagniesCompagnieIdTroupesOrdrePut(requestParameters: CompagniesApiReordonnerTroupesCompagniesCompagnieIdTroupesOrdrePutRequest, options?: RawAxiosRequestConfig) {
        return CompagniesApiFp(this.configuration).reordonnerTroupesCompagniesCompagnieIdTroupesOrdrePut(requestParameters.compagnieId, requestParameters.troupesOrdreForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retirer Logo
     * @param {CompagniesApiRetirerLogoCompagniesCompagnieIdLogoDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApi
     */
    public retirerLogoCompagniesCompagnieIdLogoDelete(requestParameters: CompagniesApiRetirerLogoCompagniesCompagnieIdLogoDeleteRequest, options?: RawAxiosRequestConfig) {
        return CompagniesApiFp(this.configuration).retirerLogoCompagniesCompagnieIdLogoDelete(requestParameters.compagnieId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Adhesion
     * @param {CompagniesApiUpdateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApi
     */
    public updateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch(requestParameters: CompagniesApiUpdateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatchRequest, options?: RawAxiosRequestConfig) {
        return CompagniesApiFp(this.configuration).updateAdhesionCompagniesCompagnieIdAdhesionsPersonneIdPatch(requestParameters.compagnieId, requestParameters.personneId, requestParameters.adhesionFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Compagnie
     * @param {CompagniesApiUpdateCompagnieCompagniesCompagnieIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompagniesApi
     */
    public updateCompagnieCompagniesCompagnieIdPatch(requestParameters: CompagniesApiUpdateCompagnieCompagniesCompagnieIdPatchRequest, options?: RawAxiosRequestConfig) {
        return CompagniesApiFp(this.configuration).updateCompagnieCompagniesCompagnieIdPatch(requestParameters.compagnieId, requestParameters.compagnieFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListCompagniesCompagniesGetSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListCompagniesCompagniesGetSortOrderEnum = typeof ListCompagniesCompagniesGetSortOrderEnum[keyof typeof ListCompagniesCompagniesGetSortOrderEnum];


/**
 * DebriefsApi - axios parameter creator
 * @export
 */
export const DebriefsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Debrief
         * @param {string} evenementId 
         * @param {DebriefFormCreate} debriefFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDebriefDebriefsPost: async (evenementId: string, debriefFormCreate: DebriefFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evenementId' is not null or undefined
            assertParamExists('createDebriefDebriefsPost', 'evenementId', evenementId)
            // verify required parameter 'debriefFormCreate' is not null or undefined
            assertParamExists('createDebriefDebriefsPost', 'debriefFormCreate', debriefFormCreate)
            const localVarPath = `/debriefs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (evenementId !== undefined) {
                localVarQueryParameter['evenement_id'] = evenementId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(debriefFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Debrief
         * @param {string} debriefId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDebriefDebriefsDebriefIdDelete: async (debriefId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'debriefId' is not null or undefined
            assertParamExists('deleteDebriefDebriefsDebriefIdDelete', 'debriefId', debriefId)
            const localVarPath = `/debriefs/{debrief_id}`
                .replace(`{${"debrief_id"}}`, encodeURIComponent(String(debriefId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Debrief For Evenement
         * @param {string} evenementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDebriefForEvenementDebriefsEvenementEvenementIdGet: async (evenementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evenementId' is not null or undefined
            assertParamExists('getDebriefForEvenementDebriefsEvenementEvenementIdGet', 'evenementId', evenementId)
            const localVarPath = `/debriefs/evenement/{evenement_id}`
                .replace(`{${"evenement_id"}}`, encodeURIComponent(String(evenementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Debriefs For Production
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDebriefsForProductionDebriefsProductionProductionIdGet: async (productionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('listDebriefsForProductionDebriefsProductionProductionIdGet', 'productionId', productionId)
            const localVarPath = `/debriefs/production/{production_id}`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Debrief
         * @param {string} debriefId 
         * @param {DebriefFormUpdate} debriefFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDebriefDebriefsDebriefIdPatch: async (debriefId: string, debriefFormUpdate: DebriefFormUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'debriefId' is not null or undefined
            assertParamExists('updateDebriefDebriefsDebriefIdPatch', 'debriefId', debriefId)
            // verify required parameter 'debriefFormUpdate' is not null or undefined
            assertParamExists('updateDebriefDebriefsDebriefIdPatch', 'debriefFormUpdate', debriefFormUpdate)
            const localVarPath = `/debriefs/{debrief_id}`
                .replace(`{${"debrief_id"}}`, encodeURIComponent(String(debriefId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(debriefFormUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DebriefsApi - functional programming interface
 * @export
 */
export const DebriefsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DebriefsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Debrief
         * @param {string} evenementId 
         * @param {DebriefFormCreate} debriefFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDebriefDebriefsPost(evenementId: string, debriefFormCreate: DebriefFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessDebriefSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDebriefDebriefsPost(evenementId, debriefFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DebriefsApi.createDebriefDebriefsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Debrief
         * @param {string} debriefId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDebriefDebriefsDebriefIdDelete(debriefId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessBool>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDebriefDebriefsDebriefIdDelete(debriefId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DebriefsApi.deleteDebriefDebriefsDebriefIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Debrief For Evenement
         * @param {string} evenementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDebriefForEvenementDebriefsEvenementEvenementIdGet(evenementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessDebriefSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDebriefForEvenementDebriefsEvenementEvenementIdGet(evenementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DebriefsApi.getDebriefForEvenementDebriefsEvenementEvenementIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Debriefs For Production
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDebriefsForProductionDebriefsProductionProductionIdGet(productionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListDebriefSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDebriefsForProductionDebriefsProductionProductionIdGet(productionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DebriefsApi.listDebriefsForProductionDebriefsProductionProductionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Debrief
         * @param {string} debriefId 
         * @param {DebriefFormUpdate} debriefFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDebriefDebriefsDebriefIdPatch(debriefId: string, debriefFormUpdate: DebriefFormUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessDebriefSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDebriefDebriefsDebriefIdPatch(debriefId, debriefFormUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DebriefsApi.updateDebriefDebriefsDebriefIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DebriefsApi - factory interface
 * @export
 */
export const DebriefsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DebriefsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Debrief
         * @param {DebriefsApiCreateDebriefDebriefsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDebriefDebriefsPost(requestParameters: DebriefsApiCreateDebriefDebriefsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessDebriefSchemaLite> {
            return localVarFp.createDebriefDebriefsPost(requestParameters.evenementId, requestParameters.debriefFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Debrief
         * @param {DebriefsApiDeleteDebriefDebriefsDebriefIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDebriefDebriefsDebriefIdDelete(requestParameters: DebriefsApiDeleteDebriefDebriefsDebriefIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessBool> {
            return localVarFp.deleteDebriefDebriefsDebriefIdDelete(requestParameters.debriefId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Debrief For Evenement
         * @param {DebriefsApiGetDebriefForEvenementDebriefsEvenementEvenementIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDebriefForEvenementDebriefsEvenementEvenementIdGet(requestParameters: DebriefsApiGetDebriefForEvenementDebriefsEvenementEvenementIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessDebriefSchema> {
            return localVarFp.getDebriefForEvenementDebriefsEvenementEvenementIdGet(requestParameters.evenementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Debriefs For Production
         * @param {DebriefsApiListDebriefsForProductionDebriefsProductionProductionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDebriefsForProductionDebriefsProductionProductionIdGet(requestParameters: DebriefsApiListDebriefsForProductionDebriefsProductionProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListDebriefSchemaLite> {
            return localVarFp.listDebriefsForProductionDebriefsProductionProductionIdGet(requestParameters.productionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Debrief
         * @param {DebriefsApiUpdateDebriefDebriefsDebriefIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDebriefDebriefsDebriefIdPatch(requestParameters: DebriefsApiUpdateDebriefDebriefsDebriefIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessDebriefSchemaLite> {
            return localVarFp.updateDebriefDebriefsDebriefIdPatch(requestParameters.debriefId, requestParameters.debriefFormUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DebriefsApi - interface
 * @export
 * @interface DebriefsApi
 */
export interface DebriefsApiInterface {
    /**
     * 
     * @summary Create Debrief
     * @param {DebriefsApiCreateDebriefDebriefsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebriefsApiInterface
     */
    createDebriefDebriefsPost(requestParameters: DebriefsApiCreateDebriefDebriefsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessDebriefSchemaLite>;

    /**
     * 
     * @summary Delete Debrief
     * @param {DebriefsApiDeleteDebriefDebriefsDebriefIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebriefsApiInterface
     */
    deleteDebriefDebriefsDebriefIdDelete(requestParameters: DebriefsApiDeleteDebriefDebriefsDebriefIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessBool>;

    /**
     * 
     * @summary Get Debrief For Evenement
     * @param {DebriefsApiGetDebriefForEvenementDebriefsEvenementEvenementIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebriefsApiInterface
     */
    getDebriefForEvenementDebriefsEvenementEvenementIdGet(requestParameters: DebriefsApiGetDebriefForEvenementDebriefsEvenementEvenementIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessDebriefSchema>;

    /**
     * 
     * @summary List Debriefs For Production
     * @param {DebriefsApiListDebriefsForProductionDebriefsProductionProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebriefsApiInterface
     */
    listDebriefsForProductionDebriefsProductionProductionIdGet(requestParameters: DebriefsApiListDebriefsForProductionDebriefsProductionProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListDebriefSchemaLite>;

    /**
     * 
     * @summary Update Debrief
     * @param {DebriefsApiUpdateDebriefDebriefsDebriefIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebriefsApiInterface
     */
    updateDebriefDebriefsDebriefIdPatch(requestParameters: DebriefsApiUpdateDebriefDebriefsDebriefIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessDebriefSchemaLite>;

}

/**
 * Request parameters for createDebriefDebriefsPost operation in DebriefsApi.
 * @export
 * @interface DebriefsApiCreateDebriefDebriefsPostRequest
 */
export interface DebriefsApiCreateDebriefDebriefsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof DebriefsApiCreateDebriefDebriefsPost
     */
    readonly evenementId: string

    /**
     * 
     * @type {DebriefFormCreate}
     * @memberof DebriefsApiCreateDebriefDebriefsPost
     */
    readonly debriefFormCreate: DebriefFormCreate
}

/**
 * Request parameters for deleteDebriefDebriefsDebriefIdDelete operation in DebriefsApi.
 * @export
 * @interface DebriefsApiDeleteDebriefDebriefsDebriefIdDeleteRequest
 */
export interface DebriefsApiDeleteDebriefDebriefsDebriefIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof DebriefsApiDeleteDebriefDebriefsDebriefIdDelete
     */
    readonly debriefId: string
}

/**
 * Request parameters for getDebriefForEvenementDebriefsEvenementEvenementIdGet operation in DebriefsApi.
 * @export
 * @interface DebriefsApiGetDebriefForEvenementDebriefsEvenementEvenementIdGetRequest
 */
export interface DebriefsApiGetDebriefForEvenementDebriefsEvenementEvenementIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DebriefsApiGetDebriefForEvenementDebriefsEvenementEvenementIdGet
     */
    readonly evenementId: string
}

/**
 * Request parameters for listDebriefsForProductionDebriefsProductionProductionIdGet operation in DebriefsApi.
 * @export
 * @interface DebriefsApiListDebriefsForProductionDebriefsProductionProductionIdGetRequest
 */
export interface DebriefsApiListDebriefsForProductionDebriefsProductionProductionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DebriefsApiListDebriefsForProductionDebriefsProductionProductionIdGet
     */
    readonly productionId: string
}

/**
 * Request parameters for updateDebriefDebriefsDebriefIdPatch operation in DebriefsApi.
 * @export
 * @interface DebriefsApiUpdateDebriefDebriefsDebriefIdPatchRequest
 */
export interface DebriefsApiUpdateDebriefDebriefsDebriefIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof DebriefsApiUpdateDebriefDebriefsDebriefIdPatch
     */
    readonly debriefId: string

    /**
     * 
     * @type {DebriefFormUpdate}
     * @memberof DebriefsApiUpdateDebriefDebriefsDebriefIdPatch
     */
    readonly debriefFormUpdate: DebriefFormUpdate
}

/**
 * DebriefsApi - object-oriented interface
 * @export
 * @class DebriefsApi
 * @extends {BaseAPI}
 */
export class DebriefsApi extends BaseAPI implements DebriefsApiInterface {
    /**
     * 
     * @summary Create Debrief
     * @param {DebriefsApiCreateDebriefDebriefsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebriefsApi
     */
    public createDebriefDebriefsPost(requestParameters: DebriefsApiCreateDebriefDebriefsPostRequest, options?: RawAxiosRequestConfig) {
        return DebriefsApiFp(this.configuration).createDebriefDebriefsPost(requestParameters.evenementId, requestParameters.debriefFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Debrief
     * @param {DebriefsApiDeleteDebriefDebriefsDebriefIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebriefsApi
     */
    public deleteDebriefDebriefsDebriefIdDelete(requestParameters: DebriefsApiDeleteDebriefDebriefsDebriefIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DebriefsApiFp(this.configuration).deleteDebriefDebriefsDebriefIdDelete(requestParameters.debriefId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Debrief For Evenement
     * @param {DebriefsApiGetDebriefForEvenementDebriefsEvenementEvenementIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebriefsApi
     */
    public getDebriefForEvenementDebriefsEvenementEvenementIdGet(requestParameters: DebriefsApiGetDebriefForEvenementDebriefsEvenementEvenementIdGetRequest, options?: RawAxiosRequestConfig) {
        return DebriefsApiFp(this.configuration).getDebriefForEvenementDebriefsEvenementEvenementIdGet(requestParameters.evenementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Debriefs For Production
     * @param {DebriefsApiListDebriefsForProductionDebriefsProductionProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebriefsApi
     */
    public listDebriefsForProductionDebriefsProductionProductionIdGet(requestParameters: DebriefsApiListDebriefsForProductionDebriefsProductionProductionIdGetRequest, options?: RawAxiosRequestConfig) {
        return DebriefsApiFp(this.configuration).listDebriefsForProductionDebriefsProductionProductionIdGet(requestParameters.productionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Debrief
     * @param {DebriefsApiUpdateDebriefDebriefsDebriefIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebriefsApi
     */
    public updateDebriefDebriefsDebriefIdPatch(requestParameters: DebriefsApiUpdateDebriefDebriefsDebriefIdPatchRequest, options?: RawAxiosRequestConfig) {
        return DebriefsApiFp(this.configuration).updateDebriefDebriefsDebriefIdPatch(requestParameters.debriefId, requestParameters.debriefFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EvenementsApi - axios parameter creator
 * @export
 */
export const EvenementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Annuler Absence
         * @param {string} evenementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annulerAbsenceEvenementsEvenementIdAbsencesDelete: async (evenementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evenementId' is not null or undefined
            assertParamExists('annulerAbsenceEvenementsEvenementIdAbsencesDelete', 'evenementId', evenementId)
            const localVarPath = `/evenements/{evenement_id}/absences`
                .replace(`{${"evenement_id"}}`, encodeURIComponent(String(evenementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assign Casting To Evenement
         * @param {string} evenementId 
         * @param {CastingEvenementFormCreate} castingEvenementFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCastingToEvenementEvenementsEvenementIdCastingsPost: async (evenementId: string, castingEvenementFormCreate: CastingEvenementFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evenementId' is not null or undefined
            assertParamExists('assignCastingToEvenementEvenementsEvenementIdCastingsPost', 'evenementId', evenementId)
            // verify required parameter 'castingEvenementFormCreate' is not null or undefined
            assertParamExists('assignCastingToEvenementEvenementsEvenementIdCastingsPost', 'castingEvenementFormCreate', castingEvenementFormCreate)
            const localVarPath = `/evenements/{evenement_id}/castings`
                .replace(`{${"evenement_id"}}`, encodeURIComponent(String(evenementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(castingEvenementFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Commenter Absence
         * @param {string} evenementId 
         * @param {AbsenceFormUpdate} absenceFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commenterAbsenceEvenementsEvenementIdAbsencesPatch: async (evenementId: string, absenceFormUpdate: AbsenceFormUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evenementId' is not null or undefined
            assertParamExists('commenterAbsenceEvenementsEvenementIdAbsencesPatch', 'evenementId', evenementId)
            // verify required parameter 'absenceFormUpdate' is not null or undefined
            assertParamExists('commenterAbsenceEvenementsEvenementIdAbsencesPatch', 'absenceFormUpdate', absenceFormUpdate)
            const localVarPath = `/evenements/{evenement_id}/absences`
                .replace(`{${"evenement_id"}}`, encodeURIComponent(String(evenementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(absenceFormUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Evenement
         * @param {EvenementFormCreate} evenementFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvenementEvenementsPost: async (evenementFormCreate: EvenementFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evenementFormCreate' is not null or undefined
            assertParamExists('createEvenementEvenementsPost', 'evenementFormCreate', evenementFormCreate)
            const localVarPath = `/evenements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(evenementFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Declarer Absence
         * @param {string} evenementId 
         * @param {AbsenceFormCreate} absenceFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declarerAbsenceEvenementsEvenementIdAbsencesPost: async (evenementId: string, absenceFormCreate: AbsenceFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evenementId' is not null or undefined
            assertParamExists('declarerAbsenceEvenementsEvenementIdAbsencesPost', 'evenementId', evenementId)
            // verify required parameter 'absenceFormCreate' is not null or undefined
            assertParamExists('declarerAbsenceEvenementsEvenementIdAbsencesPost', 'absenceFormCreate', absenceFormCreate)
            const localVarPath = `/evenements/{evenement_id}/absences`
                .replace(`{${"evenement_id"}}`, encodeURIComponent(String(evenementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(absenceFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Evenement
         * @param {string} evenementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvenementEvenementsEvenementIdDelete: async (evenementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evenementId' is not null or undefined
            assertParamExists('deleteEvenementEvenementsEvenementIdDelete', 'evenementId', evenementId)
            const localVarPath = `/evenements/{evenement_id}`
                .replace(`{${"evenement_id"}}`, encodeURIComponent(String(evenementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Absences
         * @param {string} evenementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAbsencesEvenementsEvenementIdAbsencesGet: async (evenementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evenementId' is not null or undefined
            assertParamExists('listAbsencesEvenementsEvenementIdAbsencesGet', 'evenementId', evenementId)
            const localVarPath = `/evenements/{evenement_id}/absences`
                .replace(`{${"evenement_id"}}`, encodeURIComponent(String(evenementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Castings By Evenement
         * @param {string} evenementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCastingsByEvenementEvenementsEvenementIdCastingsGet: async (evenementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evenementId' is not null or undefined
            assertParamExists('listCastingsByEvenementEvenementsEvenementIdCastingsGet', 'evenementId', evenementId)
            const localVarPath = `/evenements/{evenement_id}/castings`
                .replace(`{${"evenement_id"}}`, encodeURIComponent(String(evenementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Evenements By Production
         * @param {string} productionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListEvenementsByProductionEvenementsProductionProductionIdGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvenementsByProductionEvenementsProductionProductionIdGet: async (productionId: string, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListEvenementsByProductionEvenementsProductionProductionIdGetSortOrderEnum, search?: string | null, searchFields?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('listEvenementsByProductionEvenementsProductionProductionIdGet', 'productionId', productionId)
            const localVarPath = `/evenements/production/{production_id}`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['search_fields'] = searchFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Evenements For User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvenementsForUserEvenementsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/evenements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Scènes de la pièce, chacune dite travaillable ou non selon les absences déclarées à l\'évènement.
         * @summary List Scenes Travaillables
         * @param {string} evenementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScenesTravaillablesEvenementsEvenementIdScenesGet: async (evenementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evenementId' is not null or undefined
            assertParamExists('listScenesTravaillablesEvenementsEvenementIdScenesGet', 'evenementId', evenementId)
            const localVarPath = `/evenements/{evenement_id}/scenes`
                .replace(`{${"evenement_id"}}`, encodeURIComponent(String(evenementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove Casting From Evenement
         * @param {string} evenementId 
         * @param {string} castingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDelete: async (evenementId: string, castingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evenementId' is not null or undefined
            assertParamExists('removeCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDelete', 'evenementId', evenementId)
            // verify required parameter 'castingId' is not null or undefined
            assertParamExists('removeCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDelete', 'castingId', castingId)
            const localVarPath = `/evenements/{evenement_id}/castings/{casting_id}`
                .replace(`{${"evenement_id"}}`, encodeURIComponent(String(evenementId)))
                .replace(`{${"casting_id"}}`, encodeURIComponent(String(castingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Evenement
         * @param {string} evenementId 
         * @param {EvenementFormUpdate} evenementFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvenementEvenementsEvenementIdPatch: async (evenementId: string, evenementFormUpdate: EvenementFormUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evenementId' is not null or undefined
            assertParamExists('updateEvenementEvenementsEvenementIdPatch', 'evenementId', evenementId)
            // verify required parameter 'evenementFormUpdate' is not null or undefined
            assertParamExists('updateEvenementEvenementsEvenementIdPatch', 'evenementFormUpdate', evenementFormUpdate)
            const localVarPath = `/evenements/{evenement_id}`
                .replace(`{${"evenement_id"}}`, encodeURIComponent(String(evenementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(evenementFormUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EvenementsApi - functional programming interface
 * @export
 */
export const EvenementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EvenementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Annuler Absence
         * @param {string} evenementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async annulerAbsenceEvenementsEvenementIdAbsencesDelete(evenementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessAbsenceSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.annulerAbsenceEvenementsEvenementIdAbsencesDelete(evenementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvenementsApi.annulerAbsenceEvenementsEvenementIdAbsencesDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Assign Casting To Evenement
         * @param {string} evenementId 
         * @param {CastingEvenementFormCreate} castingEvenementFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignCastingToEvenementEvenementsEvenementIdCastingsPost(evenementId: string, castingEvenementFormCreate: CastingEvenementFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessCastingEvenementSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignCastingToEvenementEvenementsEvenementIdCastingsPost(evenementId, castingEvenementFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvenementsApi.assignCastingToEvenementEvenementsEvenementIdCastingsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Commenter Absence
         * @param {string} evenementId 
         * @param {AbsenceFormUpdate} absenceFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commenterAbsenceEvenementsEvenementIdAbsencesPatch(evenementId: string, absenceFormUpdate: AbsenceFormUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessAbsenceSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commenterAbsenceEvenementsEvenementIdAbsencesPatch(evenementId, absenceFormUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvenementsApi.commenterAbsenceEvenementsEvenementIdAbsencesPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Evenement
         * @param {EvenementFormCreate} evenementFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEvenementEvenementsPost(evenementFormCreate: EvenementFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessEvenementSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEvenementEvenementsPost(evenementFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvenementsApi.createEvenementEvenementsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Declarer Absence
         * @param {string} evenementId 
         * @param {AbsenceFormCreate} absenceFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declarerAbsenceEvenementsEvenementIdAbsencesPost(evenementId: string, absenceFormCreate: AbsenceFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessAbsenceSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declarerAbsenceEvenementsEvenementIdAbsencesPost(evenementId, absenceFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvenementsApi.declarerAbsenceEvenementsEvenementIdAbsencesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Evenement
         * @param {string} evenementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEvenementEvenementsEvenementIdDelete(evenementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessEvenementSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEvenementEvenementsEvenementIdDelete(evenementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvenementsApi.deleteEvenementEvenementsEvenementIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Absences
         * @param {string} evenementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAbsencesEvenementsEvenementIdAbsencesGet(evenementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListAbsenceSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAbsencesEvenementsEvenementIdAbsencesGet(evenementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvenementsApi.listAbsencesEvenementsEvenementIdAbsencesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Castings By Evenement
         * @param {string} evenementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCastingsByEvenementEvenementsEvenementIdCastingsGet(evenementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListCastingEvenementSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCastingsByEvenementEvenementsEvenementIdCastingsGet(evenementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvenementsApi.listCastingsByEvenementEvenementsEvenementIdCastingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Evenements By Production
         * @param {string} productionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListEvenementsByProductionEvenementsProductionProductionIdGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEvenementsByProductionEvenementsProductionProductionIdGet(productionId: string, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListEvenementsByProductionEvenementsProductionProductionIdGetSortOrderEnum, search?: string | null, searchFields?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListEvenementAgendaSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEvenementsByProductionEvenementsProductionProductionIdGet(productionId, page, pageSize, sortBy, sortOrder, search, searchFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvenementsApi.listEvenementsByProductionEvenementsProductionProductionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Evenements For User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEvenementsForUserEvenementsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListEvenementAgendaSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEvenementsForUserEvenementsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvenementsApi.listEvenementsForUserEvenementsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Scènes de la pièce, chacune dite travaillable ou non selon les absences déclarées à l\'évènement.
         * @summary List Scenes Travaillables
         * @param {string} evenementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listScenesTravaillablesEvenementsEvenementIdScenesGet(evenementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListSceneTravaillableSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listScenesTravaillablesEvenementsEvenementIdScenesGet(evenementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvenementsApi.listScenesTravaillablesEvenementsEvenementIdScenesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove Casting From Evenement
         * @param {string} evenementId 
         * @param {string} castingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDelete(evenementId: string, castingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessCastingEvenementSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDelete(evenementId, castingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvenementsApi.removeCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Evenement
         * @param {string} evenementId 
         * @param {EvenementFormUpdate} evenementFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEvenementEvenementsEvenementIdPatch(evenementId: string, evenementFormUpdate: EvenementFormUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessEvenementSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEvenementEvenementsEvenementIdPatch(evenementId, evenementFormUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvenementsApi.updateEvenementEvenementsEvenementIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EvenementsApi - factory interface
 * @export
 */
export const EvenementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EvenementsApiFp(configuration)
    return {
        /**
         * 
         * @summary Annuler Absence
         * @param {EvenementsApiAnnulerAbsenceEvenementsEvenementIdAbsencesDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annulerAbsenceEvenementsEvenementIdAbsencesDelete(requestParameters: EvenementsApiAnnulerAbsenceEvenementsEvenementIdAbsencesDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAbsenceSchemaLite> {
            return localVarFp.annulerAbsenceEvenementsEvenementIdAbsencesDelete(requestParameters.evenementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assign Casting To Evenement
         * @param {EvenementsApiAssignCastingToEvenementEvenementsEvenementIdCastingsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCastingToEvenementEvenementsEvenementIdCastingsPost(requestParameters: EvenementsApiAssignCastingToEvenementEvenementsEvenementIdCastingsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCastingEvenementSchemaLite> {
            return localVarFp.assignCastingToEvenementEvenementsEvenementIdCastingsPost(requestParameters.evenementId, requestParameters.castingEvenementFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Commenter Absence
         * @param {EvenementsApiCommenterAbsenceEvenementsEvenementIdAbsencesPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commenterAbsenceEvenementsEvenementIdAbsencesPatch(requestParameters: EvenementsApiCommenterAbsenceEvenementsEvenementIdAbsencesPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAbsenceSchemaLite> {
            return localVarFp.commenterAbsenceEvenementsEvenementIdAbsencesPatch(requestParameters.evenementId, requestParameters.absenceFormUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Evenement
         * @param {EvenementsApiCreateEvenementEvenementsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvenementEvenementsPost(requestParameters: EvenementsApiCreateEvenementEvenementsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessEvenementSchemaLite> {
            return localVarFp.createEvenementEvenementsPost(requestParameters.evenementFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Declarer Absence
         * @param {EvenementsApiDeclarerAbsenceEvenementsEvenementIdAbsencesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declarerAbsenceEvenementsEvenementIdAbsencesPost(requestParameters: EvenementsApiDeclarerAbsenceEvenementsEvenementIdAbsencesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAbsenceSchemaLite> {
            return localVarFp.declarerAbsenceEvenementsEvenementIdAbsencesPost(requestParameters.evenementId, requestParameters.absenceFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Evenement
         * @param {EvenementsApiDeleteEvenementEvenementsEvenementIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvenementEvenementsEvenementIdDelete(requestParameters: EvenementsApiDeleteEvenementEvenementsEvenementIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessEvenementSchemaLite> {
            return localVarFp.deleteEvenementEvenementsEvenementIdDelete(requestParameters.evenementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Absences
         * @param {EvenementsApiListAbsencesEvenementsEvenementIdAbsencesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAbsencesEvenementsEvenementIdAbsencesGet(requestParameters: EvenementsApiListAbsencesEvenementsEvenementIdAbsencesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListAbsenceSchemaLite> {
            return localVarFp.listAbsencesEvenementsEvenementIdAbsencesGet(requestParameters.evenementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Castings By Evenement
         * @param {EvenementsApiListCastingsByEvenementEvenementsEvenementIdCastingsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCastingsByEvenementEvenementsEvenementIdCastingsGet(requestParameters: EvenementsApiListCastingsByEvenementEvenementsEvenementIdCastingsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListCastingEvenementSchemaLite> {
            return localVarFp.listCastingsByEvenementEvenementsEvenementIdCastingsGet(requestParameters.evenementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Evenements By Production
         * @param {EvenementsApiListEvenementsByProductionEvenementsProductionProductionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvenementsByProductionEvenementsProductionProductionIdGet(requestParameters: EvenementsApiListEvenementsByProductionEvenementsProductionProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListEvenementAgendaSchema> {
            return localVarFp.listEvenementsByProductionEvenementsProductionProductionIdGet(requestParameters.productionId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Evenements For User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvenementsForUserEvenementsGet(options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListEvenementAgendaSchema> {
            return localVarFp.listEvenementsForUserEvenementsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Scènes de la pièce, chacune dite travaillable ou non selon les absences déclarées à l\'évènement.
         * @summary List Scenes Travaillables
         * @param {EvenementsApiListScenesTravaillablesEvenementsEvenementIdScenesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScenesTravaillablesEvenementsEvenementIdScenesGet(requestParameters: EvenementsApiListScenesTravaillablesEvenementsEvenementIdScenesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListSceneTravaillableSchema> {
            return localVarFp.listScenesTravaillablesEvenementsEvenementIdScenesGet(requestParameters.evenementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove Casting From Evenement
         * @param {EvenementsApiRemoveCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDelete(requestParameters: EvenementsApiRemoveCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCastingEvenementSchemaLite> {
            return localVarFp.removeCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDelete(requestParameters.evenementId, requestParameters.castingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Evenement
         * @param {EvenementsApiUpdateEvenementEvenementsEvenementIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvenementEvenementsEvenementIdPatch(requestParameters: EvenementsApiUpdateEvenementEvenementsEvenementIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessEvenementSchemaLite> {
            return localVarFp.updateEvenementEvenementsEvenementIdPatch(requestParameters.evenementId, requestParameters.evenementFormUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EvenementsApi - interface
 * @export
 * @interface EvenementsApi
 */
export interface EvenementsApiInterface {
    /**
     * 
     * @summary Annuler Absence
     * @param {EvenementsApiAnnulerAbsenceEvenementsEvenementIdAbsencesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApiInterface
     */
    annulerAbsenceEvenementsEvenementIdAbsencesDelete(requestParameters: EvenementsApiAnnulerAbsenceEvenementsEvenementIdAbsencesDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAbsenceSchemaLite>;

    /**
     * 
     * @summary Assign Casting To Evenement
     * @param {EvenementsApiAssignCastingToEvenementEvenementsEvenementIdCastingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApiInterface
     */
    assignCastingToEvenementEvenementsEvenementIdCastingsPost(requestParameters: EvenementsApiAssignCastingToEvenementEvenementsEvenementIdCastingsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCastingEvenementSchemaLite>;

    /**
     * 
     * @summary Commenter Absence
     * @param {EvenementsApiCommenterAbsenceEvenementsEvenementIdAbsencesPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApiInterface
     */
    commenterAbsenceEvenementsEvenementIdAbsencesPatch(requestParameters: EvenementsApiCommenterAbsenceEvenementsEvenementIdAbsencesPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAbsenceSchemaLite>;

    /**
     * 
     * @summary Create Evenement
     * @param {EvenementsApiCreateEvenementEvenementsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApiInterface
     */
    createEvenementEvenementsPost(requestParameters: EvenementsApiCreateEvenementEvenementsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessEvenementSchemaLite>;

    /**
     * 
     * @summary Declarer Absence
     * @param {EvenementsApiDeclarerAbsenceEvenementsEvenementIdAbsencesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApiInterface
     */
    declarerAbsenceEvenementsEvenementIdAbsencesPost(requestParameters: EvenementsApiDeclarerAbsenceEvenementsEvenementIdAbsencesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessAbsenceSchemaLite>;

    /**
     * 
     * @summary Delete Evenement
     * @param {EvenementsApiDeleteEvenementEvenementsEvenementIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApiInterface
     */
    deleteEvenementEvenementsEvenementIdDelete(requestParameters: EvenementsApiDeleteEvenementEvenementsEvenementIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessEvenementSchemaLite>;

    /**
     * 
     * @summary List Absences
     * @param {EvenementsApiListAbsencesEvenementsEvenementIdAbsencesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApiInterface
     */
    listAbsencesEvenementsEvenementIdAbsencesGet(requestParameters: EvenementsApiListAbsencesEvenementsEvenementIdAbsencesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListAbsenceSchemaLite>;

    /**
     * 
     * @summary List Castings By Evenement
     * @param {EvenementsApiListCastingsByEvenementEvenementsEvenementIdCastingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApiInterface
     */
    listCastingsByEvenementEvenementsEvenementIdCastingsGet(requestParameters: EvenementsApiListCastingsByEvenementEvenementsEvenementIdCastingsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListCastingEvenementSchemaLite>;

    /**
     * 
     * @summary List Evenements By Production
     * @param {EvenementsApiListEvenementsByProductionEvenementsProductionProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApiInterface
     */
    listEvenementsByProductionEvenementsProductionProductionIdGet(requestParameters: EvenementsApiListEvenementsByProductionEvenementsProductionProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListEvenementAgendaSchema>;

    /**
     * 
     * @summary List Evenements For User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApiInterface
     */
    listEvenementsForUserEvenementsGet(options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListEvenementAgendaSchema>;

    /**
     * Scènes de la pièce, chacune dite travaillable ou non selon les absences déclarées à l\'évènement.
     * @summary List Scenes Travaillables
     * @param {EvenementsApiListScenesTravaillablesEvenementsEvenementIdScenesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApiInterface
     */
    listScenesTravaillablesEvenementsEvenementIdScenesGet(requestParameters: EvenementsApiListScenesTravaillablesEvenementsEvenementIdScenesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListSceneTravaillableSchema>;

    /**
     * 
     * @summary Remove Casting From Evenement
     * @param {EvenementsApiRemoveCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApiInterface
     */
    removeCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDelete(requestParameters: EvenementsApiRemoveCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessCastingEvenementSchemaLite>;

    /**
     * 
     * @summary Update Evenement
     * @param {EvenementsApiUpdateEvenementEvenementsEvenementIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApiInterface
     */
    updateEvenementEvenementsEvenementIdPatch(requestParameters: EvenementsApiUpdateEvenementEvenementsEvenementIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessEvenementSchemaLite>;

}

/**
 * Request parameters for annulerAbsenceEvenementsEvenementIdAbsencesDelete operation in EvenementsApi.
 * @export
 * @interface EvenementsApiAnnulerAbsenceEvenementsEvenementIdAbsencesDeleteRequest
 */
export interface EvenementsApiAnnulerAbsenceEvenementsEvenementIdAbsencesDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof EvenementsApiAnnulerAbsenceEvenementsEvenementIdAbsencesDelete
     */
    readonly evenementId: string
}

/**
 * Request parameters for assignCastingToEvenementEvenementsEvenementIdCastingsPost operation in EvenementsApi.
 * @export
 * @interface EvenementsApiAssignCastingToEvenementEvenementsEvenementIdCastingsPostRequest
 */
export interface EvenementsApiAssignCastingToEvenementEvenementsEvenementIdCastingsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof EvenementsApiAssignCastingToEvenementEvenementsEvenementIdCastingsPost
     */
    readonly evenementId: string

    /**
     * 
     * @type {CastingEvenementFormCreate}
     * @memberof EvenementsApiAssignCastingToEvenementEvenementsEvenementIdCastingsPost
     */
    readonly castingEvenementFormCreate: CastingEvenementFormCreate
}

/**
 * Request parameters for commenterAbsenceEvenementsEvenementIdAbsencesPatch operation in EvenementsApi.
 * @export
 * @interface EvenementsApiCommenterAbsenceEvenementsEvenementIdAbsencesPatchRequest
 */
export interface EvenementsApiCommenterAbsenceEvenementsEvenementIdAbsencesPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof EvenementsApiCommenterAbsenceEvenementsEvenementIdAbsencesPatch
     */
    readonly evenementId: string

    /**
     * 
     * @type {AbsenceFormUpdate}
     * @memberof EvenementsApiCommenterAbsenceEvenementsEvenementIdAbsencesPatch
     */
    readonly absenceFormUpdate: AbsenceFormUpdate
}

/**
 * Request parameters for createEvenementEvenementsPost operation in EvenementsApi.
 * @export
 * @interface EvenementsApiCreateEvenementEvenementsPostRequest
 */
export interface EvenementsApiCreateEvenementEvenementsPostRequest {
    /**
     * 
     * @type {EvenementFormCreate}
     * @memberof EvenementsApiCreateEvenementEvenementsPost
     */
    readonly evenementFormCreate: EvenementFormCreate
}

/**
 * Request parameters for declarerAbsenceEvenementsEvenementIdAbsencesPost operation in EvenementsApi.
 * @export
 * @interface EvenementsApiDeclarerAbsenceEvenementsEvenementIdAbsencesPostRequest
 */
export interface EvenementsApiDeclarerAbsenceEvenementsEvenementIdAbsencesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof EvenementsApiDeclarerAbsenceEvenementsEvenementIdAbsencesPost
     */
    readonly evenementId: string

    /**
     * 
     * @type {AbsenceFormCreate}
     * @memberof EvenementsApiDeclarerAbsenceEvenementsEvenementIdAbsencesPost
     */
    readonly absenceFormCreate: AbsenceFormCreate
}

/**
 * Request parameters for deleteEvenementEvenementsEvenementIdDelete operation in EvenementsApi.
 * @export
 * @interface EvenementsApiDeleteEvenementEvenementsEvenementIdDeleteRequest
 */
export interface EvenementsApiDeleteEvenementEvenementsEvenementIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof EvenementsApiDeleteEvenementEvenementsEvenementIdDelete
     */
    readonly evenementId: string
}

/**
 * Request parameters for listAbsencesEvenementsEvenementIdAbsencesGet operation in EvenementsApi.
 * @export
 * @interface EvenementsApiListAbsencesEvenementsEvenementIdAbsencesGetRequest
 */
export interface EvenementsApiListAbsencesEvenementsEvenementIdAbsencesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EvenementsApiListAbsencesEvenementsEvenementIdAbsencesGet
     */
    readonly evenementId: string
}

/**
 * Request parameters for listCastingsByEvenementEvenementsEvenementIdCastingsGet operation in EvenementsApi.
 * @export
 * @interface EvenementsApiListCastingsByEvenementEvenementsEvenementIdCastingsGetRequest
 */
export interface EvenementsApiListCastingsByEvenementEvenementsEvenementIdCastingsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EvenementsApiListCastingsByEvenementEvenementsEvenementIdCastingsGet
     */
    readonly evenementId: string
}

/**
 * Request parameters for listEvenementsByProductionEvenementsProductionProductionIdGet operation in EvenementsApi.
 * @export
 * @interface EvenementsApiListEvenementsByProductionEvenementsProductionProductionIdGetRequest
 */
export interface EvenementsApiListEvenementsByProductionEvenementsProductionProductionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EvenementsApiListEvenementsByProductionEvenementsProductionProductionIdGet
     */
    readonly productionId: string

    /**
     * 
     * @type {number}
     * @memberof EvenementsApiListEvenementsByProductionEvenementsProductionProductionIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof EvenementsApiListEvenementsByProductionEvenementsProductionProductionIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof EvenementsApiListEvenementsByProductionEvenementsProductionProductionIdGet
     */
    readonly sortBy?: string | null

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof EvenementsApiListEvenementsByProductionEvenementsProductionProductionIdGet
     */
    readonly sortOrder?: ListEvenementsByProductionEvenementsProductionProductionIdGetSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof EvenementsApiListEvenementsByProductionEvenementsProductionProductionIdGet
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof EvenementsApiListEvenementsByProductionEvenementsProductionProductionIdGet
     */
    readonly searchFields?: string | null
}

/**
 * Request parameters for listScenesTravaillablesEvenementsEvenementIdScenesGet operation in EvenementsApi.
 * @export
 * @interface EvenementsApiListScenesTravaillablesEvenementsEvenementIdScenesGetRequest
 */
export interface EvenementsApiListScenesTravaillablesEvenementsEvenementIdScenesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EvenementsApiListScenesTravaillablesEvenementsEvenementIdScenesGet
     */
    readonly evenementId: string
}

/**
 * Request parameters for removeCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDelete operation in EvenementsApi.
 * @export
 * @interface EvenementsApiRemoveCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDeleteRequest
 */
export interface EvenementsApiRemoveCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof EvenementsApiRemoveCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDelete
     */
    readonly evenementId: string

    /**
     * 
     * @type {string}
     * @memberof EvenementsApiRemoveCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDelete
     */
    readonly castingId: string
}

/**
 * Request parameters for updateEvenementEvenementsEvenementIdPatch operation in EvenementsApi.
 * @export
 * @interface EvenementsApiUpdateEvenementEvenementsEvenementIdPatchRequest
 */
export interface EvenementsApiUpdateEvenementEvenementsEvenementIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof EvenementsApiUpdateEvenementEvenementsEvenementIdPatch
     */
    readonly evenementId: string

    /**
     * 
     * @type {EvenementFormUpdate}
     * @memberof EvenementsApiUpdateEvenementEvenementsEvenementIdPatch
     */
    readonly evenementFormUpdate: EvenementFormUpdate
}

/**
 * EvenementsApi - object-oriented interface
 * @export
 * @class EvenementsApi
 * @extends {BaseAPI}
 */
export class EvenementsApi extends BaseAPI implements EvenementsApiInterface {
    /**
     * 
     * @summary Annuler Absence
     * @param {EvenementsApiAnnulerAbsenceEvenementsEvenementIdAbsencesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApi
     */
    public annulerAbsenceEvenementsEvenementIdAbsencesDelete(requestParameters: EvenementsApiAnnulerAbsenceEvenementsEvenementIdAbsencesDeleteRequest, options?: RawAxiosRequestConfig) {
        return EvenementsApiFp(this.configuration).annulerAbsenceEvenementsEvenementIdAbsencesDelete(requestParameters.evenementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assign Casting To Evenement
     * @param {EvenementsApiAssignCastingToEvenementEvenementsEvenementIdCastingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApi
     */
    public assignCastingToEvenementEvenementsEvenementIdCastingsPost(requestParameters: EvenementsApiAssignCastingToEvenementEvenementsEvenementIdCastingsPostRequest, options?: RawAxiosRequestConfig) {
        return EvenementsApiFp(this.configuration).assignCastingToEvenementEvenementsEvenementIdCastingsPost(requestParameters.evenementId, requestParameters.castingEvenementFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Commenter Absence
     * @param {EvenementsApiCommenterAbsenceEvenementsEvenementIdAbsencesPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApi
     */
    public commenterAbsenceEvenementsEvenementIdAbsencesPatch(requestParameters: EvenementsApiCommenterAbsenceEvenementsEvenementIdAbsencesPatchRequest, options?: RawAxiosRequestConfig) {
        return EvenementsApiFp(this.configuration).commenterAbsenceEvenementsEvenementIdAbsencesPatch(requestParameters.evenementId, requestParameters.absenceFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Evenement
     * @param {EvenementsApiCreateEvenementEvenementsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApi
     */
    public createEvenementEvenementsPost(requestParameters: EvenementsApiCreateEvenementEvenementsPostRequest, options?: RawAxiosRequestConfig) {
        return EvenementsApiFp(this.configuration).createEvenementEvenementsPost(requestParameters.evenementFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Declarer Absence
     * @param {EvenementsApiDeclarerAbsenceEvenementsEvenementIdAbsencesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApi
     */
    public declarerAbsenceEvenementsEvenementIdAbsencesPost(requestParameters: EvenementsApiDeclarerAbsenceEvenementsEvenementIdAbsencesPostRequest, options?: RawAxiosRequestConfig) {
        return EvenementsApiFp(this.configuration).declarerAbsenceEvenementsEvenementIdAbsencesPost(requestParameters.evenementId, requestParameters.absenceFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Evenement
     * @param {EvenementsApiDeleteEvenementEvenementsEvenementIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApi
     */
    public deleteEvenementEvenementsEvenementIdDelete(requestParameters: EvenementsApiDeleteEvenementEvenementsEvenementIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return EvenementsApiFp(this.configuration).deleteEvenementEvenementsEvenementIdDelete(requestParameters.evenementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Absences
     * @param {EvenementsApiListAbsencesEvenementsEvenementIdAbsencesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApi
     */
    public listAbsencesEvenementsEvenementIdAbsencesGet(requestParameters: EvenementsApiListAbsencesEvenementsEvenementIdAbsencesGetRequest, options?: RawAxiosRequestConfig) {
        return EvenementsApiFp(this.configuration).listAbsencesEvenementsEvenementIdAbsencesGet(requestParameters.evenementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Castings By Evenement
     * @param {EvenementsApiListCastingsByEvenementEvenementsEvenementIdCastingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApi
     */
    public listCastingsByEvenementEvenementsEvenementIdCastingsGet(requestParameters: EvenementsApiListCastingsByEvenementEvenementsEvenementIdCastingsGetRequest, options?: RawAxiosRequestConfig) {
        return EvenementsApiFp(this.configuration).listCastingsByEvenementEvenementsEvenementIdCastingsGet(requestParameters.evenementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Evenements By Production
     * @param {EvenementsApiListEvenementsByProductionEvenementsProductionProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApi
     */
    public listEvenementsByProductionEvenementsProductionProductionIdGet(requestParameters: EvenementsApiListEvenementsByProductionEvenementsProductionProductionIdGetRequest, options?: RawAxiosRequestConfig) {
        return EvenementsApiFp(this.configuration).listEvenementsByProductionEvenementsProductionProductionIdGet(requestParameters.productionId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Evenements For User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApi
     */
    public listEvenementsForUserEvenementsGet(options?: RawAxiosRequestConfig) {
        return EvenementsApiFp(this.configuration).listEvenementsForUserEvenementsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Scènes de la pièce, chacune dite travaillable ou non selon les absences déclarées à l\'évènement.
     * @summary List Scenes Travaillables
     * @param {EvenementsApiListScenesTravaillablesEvenementsEvenementIdScenesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApi
     */
    public listScenesTravaillablesEvenementsEvenementIdScenesGet(requestParameters: EvenementsApiListScenesTravaillablesEvenementsEvenementIdScenesGetRequest, options?: RawAxiosRequestConfig) {
        return EvenementsApiFp(this.configuration).listScenesTravaillablesEvenementsEvenementIdScenesGet(requestParameters.evenementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove Casting From Evenement
     * @param {EvenementsApiRemoveCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApi
     */
    public removeCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDelete(requestParameters: EvenementsApiRemoveCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return EvenementsApiFp(this.configuration).removeCastingFromEvenementEvenementsEvenementIdCastingsCastingIdDelete(requestParameters.evenementId, requestParameters.castingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Evenement
     * @param {EvenementsApiUpdateEvenementEvenementsEvenementIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvenementsApi
     */
    public updateEvenementEvenementsEvenementIdPatch(requestParameters: EvenementsApiUpdateEvenementEvenementsEvenementIdPatchRequest, options?: RawAxiosRequestConfig) {
        return EvenementsApiFp(this.configuration).updateEvenementEvenementsEvenementIdPatch(requestParameters.evenementId, requestParameters.evenementFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListEvenementsByProductionEvenementsProductionProductionIdGetSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListEvenementsByProductionEvenementsProductionProductionIdGetSortOrderEnum = typeof ListEvenementsByProductionEvenementsProductionProductionIdGetSortOrderEnum[keyof typeof ListEvenementsByProductionEvenementsProductionProductionIdGetSortOrderEnum];


/**
 * InternalApi - axios parameter creator
 * @export
 */
export const InternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Keycloak Events
         * @param {string | null} [xReplikaSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keycloakEventsInternalKeycloakEventsPost: async (xReplikaSignature?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/internal/keycloak-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xReplikaSignature != null) {
                localVarHeaderParameter['x-replika-signature'] = String(xReplikaSignature);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalApi - functional programming interface
 * @export
 */
export const InternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Keycloak Events
         * @param {string | null} [xReplikaSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keycloakEventsInternalKeycloakEventsPost(xReplikaSignature?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.keycloakEventsInternalKeycloakEventsPost(xReplikaSignature, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.keycloakEventsInternalKeycloakEventsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternalApi - factory interface
 * @export
 */
export const InternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalApiFp(configuration)
    return {
        /**
         * 
         * @summary Keycloak Events
         * @param {InternalApiKeycloakEventsInternalKeycloakEventsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keycloakEventsInternalKeycloakEventsPost(requestParameters: InternalApiKeycloakEventsInternalKeycloakEventsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.keycloakEventsInternalKeycloakEventsPost(requestParameters.xReplikaSignature, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InternalApi - interface
 * @export
 * @interface InternalApi
 */
export interface InternalApiInterface {
    /**
     * 
     * @summary Keycloak Events
     * @param {InternalApiKeycloakEventsInternalKeycloakEventsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApiInterface
     */
    keycloakEventsInternalKeycloakEventsPost(requestParameters?: InternalApiKeycloakEventsInternalKeycloakEventsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any>;

}

/**
 * Request parameters for keycloakEventsInternalKeycloakEventsPost operation in InternalApi.
 * @export
 * @interface InternalApiKeycloakEventsInternalKeycloakEventsPostRequest
 */
export interface InternalApiKeycloakEventsInternalKeycloakEventsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalApiKeycloakEventsInternalKeycloakEventsPost
     */
    readonly xReplikaSignature?: string | null
}

/**
 * InternalApi - object-oriented interface
 * @export
 * @class InternalApi
 * @extends {BaseAPI}
 */
export class InternalApi extends BaseAPI implements InternalApiInterface {
    /**
     * 
     * @summary Keycloak Events
     * @param {InternalApiKeycloakEventsInternalKeycloakEventsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public keycloakEventsInternalKeycloakEventsPost(requestParameters: InternalApiKeycloakEventsInternalKeycloakEventsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).keycloakEventsInternalKeycloakEventsPost(requestParameters.xReplikaSignature, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MembresApi - axios parameter creator
 * @export
 */
export const MembresApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete Membre
         * @param {string} membreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMembreMembresMembreIdDelete: async (membreId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'membreId' is not null or undefined
            assertParamExists('deleteMembreMembresMembreIdDelete', 'membreId', membreId)
            const localVarPath = `/membres/{membre_id}`
                .replace(`{${"membre_id"}}`, encodeURIComponent(String(membreId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Membre
         * @param {string} membreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembreMembresMembreIdGet: async (membreId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'membreId' is not null or undefined
            assertParamExists('getMembreMembresMembreIdGet', 'membreId', membreId)
            const localVarPath = `/membres/{membre_id}`
                .replace(`{${"membre_id"}}`, encodeURIComponent(String(membreId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Membres By Production
         * @param {string} productionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListMembresByProductionMembresProductionProductionIdGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembresByProductionMembresProductionProductionIdGet: async (productionId: string, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListMembresByProductionMembresProductionProductionIdGetSortOrderEnum, search?: string | null, searchFields?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('listMembresByProductionMembresProductionProductionIdGet', 'productionId', productionId)
            const localVarPath = `/membres/production/{production_id}`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['search_fields'] = searchFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Membres By User
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListMembresByUserMembresGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembresByUserMembresGet: async (page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListMembresByUserMembresGetSortOrderEnum, search?: string | null, searchFields?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/membres`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['search_fields'] = searchFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Membre
         * @param {string} membreId 
         * @param {MembreFormUpdate} membreFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMembreMembresMembreIdPatch: async (membreId: string, membreFormUpdate: MembreFormUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'membreId' is not null or undefined
            assertParamExists('updateMembreMembresMembreIdPatch', 'membreId', membreId)
            // verify required parameter 'membreFormUpdate' is not null or undefined
            assertParamExists('updateMembreMembresMembreIdPatch', 'membreFormUpdate', membreFormUpdate)
            const localVarPath = `/membres/{membre_id}`
                .replace(`{${"membre_id"}}`, encodeURIComponent(String(membreId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(membreFormUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MembresApi - functional programming interface
 * @export
 */
export const MembresApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MembresApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete Membre
         * @param {string} membreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMembreMembresMembreIdDelete(membreId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessMembreSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMembreMembresMembreIdDelete(membreId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembresApi.deleteMembreMembresMembreIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Membre
         * @param {string} membreId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMembreMembresMembreIdGet(membreId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessMembreSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMembreMembresMembreIdGet(membreId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembresApi.getMembreMembresMembreIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Membres By Production
         * @param {string} productionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListMembresByProductionMembresProductionProductionIdGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMembresByProductionMembresProductionProductionIdGet(productionId: string, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListMembresByProductionMembresProductionProductionIdGetSortOrderEnum, search?: string | null, searchFields?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListMembreSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMembresByProductionMembresProductionProductionIdGet(productionId, page, pageSize, sortBy, sortOrder, search, searchFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembresApi.listMembresByProductionMembresProductionProductionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Membres By User
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListMembresByUserMembresGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMembresByUserMembresGet(page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListMembresByUserMembresGetSortOrderEnum, search?: string | null, searchFields?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListMembreSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMembresByUserMembresGet(page, pageSize, sortBy, sortOrder, search, searchFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembresApi.listMembresByUserMembresGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Membre
         * @param {string} membreId 
         * @param {MembreFormUpdate} membreFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMembreMembresMembreIdPatch(membreId: string, membreFormUpdate: MembreFormUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessMembreSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMembreMembresMembreIdPatch(membreId, membreFormUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembresApi.updateMembreMembresMembreIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MembresApi - factory interface
 * @export
 */
export const MembresApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MembresApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete Membre
         * @param {MembresApiDeleteMembreMembresMembreIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMembreMembresMembreIdDelete(requestParameters: MembresApiDeleteMembreMembresMembreIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessMembreSchemaLite> {
            return localVarFp.deleteMembreMembresMembreIdDelete(requestParameters.membreId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Membre
         * @param {MembresApiGetMembreMembresMembreIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembreMembresMembreIdGet(requestParameters: MembresApiGetMembreMembresMembreIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessMembreSchema> {
            return localVarFp.getMembreMembresMembreIdGet(requestParameters.membreId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Membres By Production
         * @param {MembresApiListMembresByProductionMembresProductionProductionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembresByProductionMembresProductionProductionIdGet(requestParameters: MembresApiListMembresByProductionMembresProductionProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListMembreSchemaLite> {
            return localVarFp.listMembresByProductionMembresProductionProductionIdGet(requestParameters.productionId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Membres By User
         * @param {MembresApiListMembresByUserMembresGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembresByUserMembresGet(requestParameters: MembresApiListMembresByUserMembresGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListMembreSchemaLite> {
            return localVarFp.listMembresByUserMembresGet(requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Membre
         * @param {MembresApiUpdateMembreMembresMembreIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMembreMembresMembreIdPatch(requestParameters: MembresApiUpdateMembreMembresMembreIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessMembreSchemaLite> {
            return localVarFp.updateMembreMembresMembreIdPatch(requestParameters.membreId, requestParameters.membreFormUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MembresApi - interface
 * @export
 * @interface MembresApi
 */
export interface MembresApiInterface {
    /**
     * 
     * @summary Delete Membre
     * @param {MembresApiDeleteMembreMembresMembreIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembresApiInterface
     */
    deleteMembreMembresMembreIdDelete(requestParameters: MembresApiDeleteMembreMembresMembreIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessMembreSchemaLite>;

    /**
     * 
     * @summary Get Membre
     * @param {MembresApiGetMembreMembresMembreIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembresApiInterface
     */
    getMembreMembresMembreIdGet(requestParameters: MembresApiGetMembreMembresMembreIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessMembreSchema>;

    /**
     * 
     * @summary List Membres By Production
     * @param {MembresApiListMembresByProductionMembresProductionProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembresApiInterface
     */
    listMembresByProductionMembresProductionProductionIdGet(requestParameters: MembresApiListMembresByProductionMembresProductionProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListMembreSchemaLite>;

    /**
     * 
     * @summary List Membres By User
     * @param {MembresApiListMembresByUserMembresGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembresApiInterface
     */
    listMembresByUserMembresGet(requestParameters?: MembresApiListMembresByUserMembresGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListMembreSchemaLite>;

    /**
     * 
     * @summary Update Membre
     * @param {MembresApiUpdateMembreMembresMembreIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembresApiInterface
     */
    updateMembreMembresMembreIdPatch(requestParameters: MembresApiUpdateMembreMembresMembreIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessMembreSchemaLite>;

}

/**
 * Request parameters for deleteMembreMembresMembreIdDelete operation in MembresApi.
 * @export
 * @interface MembresApiDeleteMembreMembresMembreIdDeleteRequest
 */
export interface MembresApiDeleteMembreMembresMembreIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof MembresApiDeleteMembreMembresMembreIdDelete
     */
    readonly membreId: string
}

/**
 * Request parameters for getMembreMembresMembreIdGet operation in MembresApi.
 * @export
 * @interface MembresApiGetMembreMembresMembreIdGetRequest
 */
export interface MembresApiGetMembreMembresMembreIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MembresApiGetMembreMembresMembreIdGet
     */
    readonly membreId: string
}

/**
 * Request parameters for listMembresByProductionMembresProductionProductionIdGet operation in MembresApi.
 * @export
 * @interface MembresApiListMembresByProductionMembresProductionProductionIdGetRequest
 */
export interface MembresApiListMembresByProductionMembresProductionProductionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MembresApiListMembresByProductionMembresProductionProductionIdGet
     */
    readonly productionId: string

    /**
     * 
     * @type {number}
     * @memberof MembresApiListMembresByProductionMembresProductionProductionIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof MembresApiListMembresByProductionMembresProductionProductionIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof MembresApiListMembresByProductionMembresProductionProductionIdGet
     */
    readonly sortBy?: string | null

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof MembresApiListMembresByProductionMembresProductionProductionIdGet
     */
    readonly sortOrder?: ListMembresByProductionMembresProductionProductionIdGetSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof MembresApiListMembresByProductionMembresProductionProductionIdGet
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof MembresApiListMembresByProductionMembresProductionProductionIdGet
     */
    readonly searchFields?: string | null
}

/**
 * Request parameters for listMembresByUserMembresGet operation in MembresApi.
 * @export
 * @interface MembresApiListMembresByUserMembresGetRequest
 */
export interface MembresApiListMembresByUserMembresGetRequest {
    /**
     * 
     * @type {number}
     * @memberof MembresApiListMembresByUserMembresGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof MembresApiListMembresByUserMembresGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof MembresApiListMembresByUserMembresGet
     */
    readonly sortBy?: string | null

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof MembresApiListMembresByUserMembresGet
     */
    readonly sortOrder?: ListMembresByUserMembresGetSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof MembresApiListMembresByUserMembresGet
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof MembresApiListMembresByUserMembresGet
     */
    readonly searchFields?: string | null
}

/**
 * Request parameters for updateMembreMembresMembreIdPatch operation in MembresApi.
 * @export
 * @interface MembresApiUpdateMembreMembresMembreIdPatchRequest
 */
export interface MembresApiUpdateMembreMembresMembreIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof MembresApiUpdateMembreMembresMembreIdPatch
     */
    readonly membreId: string

    /**
     * 
     * @type {MembreFormUpdate}
     * @memberof MembresApiUpdateMembreMembresMembreIdPatch
     */
    readonly membreFormUpdate: MembreFormUpdate
}

/**
 * MembresApi - object-oriented interface
 * @export
 * @class MembresApi
 * @extends {BaseAPI}
 */
export class MembresApi extends BaseAPI implements MembresApiInterface {
    /**
     * 
     * @summary Delete Membre
     * @param {MembresApiDeleteMembreMembresMembreIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembresApi
     */
    public deleteMembreMembresMembreIdDelete(requestParameters: MembresApiDeleteMembreMembresMembreIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return MembresApiFp(this.configuration).deleteMembreMembresMembreIdDelete(requestParameters.membreId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Membre
     * @param {MembresApiGetMembreMembresMembreIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembresApi
     */
    public getMembreMembresMembreIdGet(requestParameters: MembresApiGetMembreMembresMembreIdGetRequest, options?: RawAxiosRequestConfig) {
        return MembresApiFp(this.configuration).getMembreMembresMembreIdGet(requestParameters.membreId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Membres By Production
     * @param {MembresApiListMembresByProductionMembresProductionProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembresApi
     */
    public listMembresByProductionMembresProductionProductionIdGet(requestParameters: MembresApiListMembresByProductionMembresProductionProductionIdGetRequest, options?: RawAxiosRequestConfig) {
        return MembresApiFp(this.configuration).listMembresByProductionMembresProductionProductionIdGet(requestParameters.productionId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Membres By User
     * @param {MembresApiListMembresByUserMembresGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembresApi
     */
    public listMembresByUserMembresGet(requestParameters: MembresApiListMembresByUserMembresGetRequest = {}, options?: RawAxiosRequestConfig) {
        return MembresApiFp(this.configuration).listMembresByUserMembresGet(requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Membre
     * @param {MembresApiUpdateMembreMembresMembreIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembresApi
     */
    public updateMembreMembresMembreIdPatch(requestParameters: MembresApiUpdateMembreMembresMembreIdPatchRequest, options?: RawAxiosRequestConfig) {
        return MembresApiFp(this.configuration).updateMembreMembresMembreIdPatch(requestParameters.membreId, requestParameters.membreFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListMembresByProductionMembresProductionProductionIdGetSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListMembresByProductionMembresProductionProductionIdGetSortOrderEnum = typeof ListMembresByProductionMembresProductionProductionIdGetSortOrderEnum[keyof typeof ListMembresByProductionMembresProductionProductionIdGetSortOrderEnum];
/**
 * @export
 */
export const ListMembresByUserMembresGetSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListMembresByUserMembresGetSortOrderEnum = typeof ListMembresByUserMembresGetSortOrderEnum[keyof typeof ListMembresByUserMembresGetSortOrderEnum];


/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List Notifications
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListNotificationsNotificationsGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotificationsNotificationsGet: async (page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListNotificationsNotificationsGetSortOrderEnum, search?: string | null, searchFields?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['search_fields'] = searchFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark All As Read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllAsReadNotificationsLuToutPatch: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/lu-tout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark As Read
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsReadNotificationsNotificationIdLuPatch: async (notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('markAsReadNotificationsNotificationIdLuPatch', 'notificationId', notificationId)
            const localVarPath = `/notifications/{notification_id}/lu`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unread Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unreadCountNotificationsUnreadCountGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/unread-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List Notifications
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListNotificationsNotificationsGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNotificationsNotificationsGet(page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListNotificationsNotificationsGetSortOrderEnum, search?: string | null, searchFields?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListNotificationSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNotificationsNotificationsGet(page, pageSize, sortBy, sortOrder, search, searchFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.listNotificationsNotificationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark All As Read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAllAsReadNotificationsLuToutPatch(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessNoneType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAllAsReadNotificationsLuToutPatch(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.markAllAsReadNotificationsLuToutPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark As Read
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAsReadNotificationsNotificationIdLuPatch(notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessNotificationSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAsReadNotificationsNotificationIdLuPatch(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.markAsReadNotificationsNotificationIdLuPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unread Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unreadCountNotificationsUnreadCountGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessInt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unreadCountNotificationsUnreadCountGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.unreadCountNotificationsUnreadCountGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary List Notifications
         * @param {NotificationsApiListNotificationsNotificationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotificationsNotificationsGet(requestParameters: NotificationsApiListNotificationsNotificationsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListNotificationSchemaLite> {
            return localVarFp.listNotificationsNotificationsGet(requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark All As Read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllAsReadNotificationsLuToutPatch(options?: RawAxiosRequestConfig): AxiosPromise<APISuccessNoneType> {
            return localVarFp.markAllAsReadNotificationsLuToutPatch(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark As Read
         * @param {NotificationsApiMarkAsReadNotificationsNotificationIdLuPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsReadNotificationsNotificationIdLuPatch(requestParameters: NotificationsApiMarkAsReadNotificationsNotificationIdLuPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessNotificationSchemaLite> {
            return localVarFp.markAsReadNotificationsNotificationIdLuPatch(requestParameters.notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unread Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unreadCountNotificationsUnreadCountGet(options?: RawAxiosRequestConfig): AxiosPromise<APISuccessInt> {
            return localVarFp.unreadCountNotificationsUnreadCountGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - interface
 * @export
 * @interface NotificationsApi
 */
export interface NotificationsApiInterface {
    /**
     * 
     * @summary List Notifications
     * @param {NotificationsApiListNotificationsNotificationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    listNotificationsNotificationsGet(requestParameters?: NotificationsApiListNotificationsNotificationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListNotificationSchemaLite>;

    /**
     * 
     * @summary Mark All As Read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    markAllAsReadNotificationsLuToutPatch(options?: RawAxiosRequestConfig): AxiosPromise<APISuccessNoneType>;

    /**
     * 
     * @summary Mark As Read
     * @param {NotificationsApiMarkAsReadNotificationsNotificationIdLuPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    markAsReadNotificationsNotificationIdLuPatch(requestParameters: NotificationsApiMarkAsReadNotificationsNotificationIdLuPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessNotificationSchemaLite>;

    /**
     * 
     * @summary Unread Count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    unreadCountNotificationsUnreadCountGet(options?: RawAxiosRequestConfig): AxiosPromise<APISuccessInt>;

}

/**
 * Request parameters for listNotificationsNotificationsGet operation in NotificationsApi.
 * @export
 * @interface NotificationsApiListNotificationsNotificationsGetRequest
 */
export interface NotificationsApiListNotificationsNotificationsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof NotificationsApiListNotificationsNotificationsGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof NotificationsApiListNotificationsNotificationsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiListNotificationsNotificationsGet
     */
    readonly sortBy?: string | null

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof NotificationsApiListNotificationsNotificationsGet
     */
    readonly sortOrder?: ListNotificationsNotificationsGetSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiListNotificationsNotificationsGet
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiListNotificationsNotificationsGet
     */
    readonly searchFields?: string | null
}

/**
 * Request parameters for markAsReadNotificationsNotificationIdLuPatch operation in NotificationsApi.
 * @export
 * @interface NotificationsApiMarkAsReadNotificationsNotificationIdLuPatchRequest
 */
export interface NotificationsApiMarkAsReadNotificationsNotificationIdLuPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationsApiMarkAsReadNotificationsNotificationIdLuPatch
     */
    readonly notificationId: string
}

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI implements NotificationsApiInterface {
    /**
     * 
     * @summary List Notifications
     * @param {NotificationsApiListNotificationsNotificationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public listNotificationsNotificationsGet(requestParameters: NotificationsApiListNotificationsNotificationsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).listNotificationsNotificationsGet(requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark All As Read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public markAllAsReadNotificationsLuToutPatch(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).markAllAsReadNotificationsLuToutPatch(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark As Read
     * @param {NotificationsApiMarkAsReadNotificationsNotificationIdLuPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public markAsReadNotificationsNotificationIdLuPatch(requestParameters: NotificationsApiMarkAsReadNotificationsNotificationIdLuPatchRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).markAsReadNotificationsNotificationIdLuPatch(requestParameters.notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unread Count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public unreadCountNotificationsUnreadCountGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).unreadCountNotificationsUnreadCountGet(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListNotificationsNotificationsGetSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListNotificationsNotificationsGetSortOrderEnum = typeof ListNotificationsNotificationsGetSortOrderEnum[keyof typeof ListNotificationsNotificationsGetSortOrderEnum];


/**
 * PersonnesApi - axios parameter creator
 * @export
 */
export const PersonnesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Definir Avatar
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        definirAvatarPersonnesMeAvatarPost: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('definirAvatarPersonnesMeAvatarPost', 'file', file)
            const localVarPath = `/personnes/me/avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ce que la suppression du compte bloquerait, transmettrait, emporterait et quitterait.
         * @summary Get Apercu Suppression
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApercuSuppressionPersonnesMeSuppressionGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/personnes/me/suppression`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * `v` (avatar_version) n\'est pas lu : il change l\'URL à chaque photo, ce qui permet un cache immuable.
         * @summary Get Avatar
         * @param {string} personneId 
         * @param {string | null} [v] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarPersonnesPersonneIdAvatarGet: async (personneId: string, v?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personneId' is not null or undefined
            assertParamExists('getAvatarPersonnesPersonneIdAvatarGet', 'personneId', personneId)
            const localVarPath = `/personnes/{personne_id}/avatar`
                .replace(`{${"personne_id"}}`, encodeURIComponent(String(personneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (v !== undefined) {
                localVarQueryParameter['v'] = v;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get By External Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByExternalIdPersonnesMeGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/personnes/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Preferences Mail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferencesMailPersonnesMePreferencesMailGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/personnes/me/preferences-mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retirer Avatar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retirerAvatarPersonnesMeAvatarDelete: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/personnes/me/avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supprime la personne et son compte Keycloak ; ses pièces partagées en écriture passent aux collaborateurs choisis.
         * @summary Supprimer Compte
         * @param {SuppressionCompteForm} suppressionCompteForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supprimerComptePersonnesMeDelete: async (suppressionCompteForm: SuppressionCompteForm, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suppressionCompteForm' is not null or undefined
            assertParamExists('supprimerComptePersonnesMeDelete', 'suppressionCompteForm', suppressionCompteForm)
            const localVarPath = `/personnes/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(suppressionCompteForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Preferences Mail
         * @param {PreferencesMailFormUpdate} preferencesMailFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferencesMailPersonnesMePreferencesMailPatch: async (preferencesMailFormUpdate: PreferencesMailFormUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferencesMailFormUpdate' is not null or undefined
            assertParamExists('updatePreferencesMailPersonnesMePreferencesMailPatch', 'preferencesMailFormUpdate', preferencesMailFormUpdate)
            const localVarPath = `/personnes/me/preferences-mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preferencesMailFormUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersonnesApi - functional programming interface
 * @export
 */
export const PersonnesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PersonnesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Definir Avatar
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async definirAvatarPersonnesMeAvatarPost(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessMoiSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.definirAvatarPersonnesMeAvatarPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnesApi.definirAvatarPersonnesMeAvatarPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ce que la suppression du compte bloquerait, transmettrait, emporterait et quitterait.
         * @summary Get Apercu Suppression
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApercuSuppressionPersonnesMeSuppressionGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessSuppressionCompteApercuSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApercuSuppressionPersonnesMeSuppressionGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnesApi.getApercuSuppressionPersonnesMeSuppressionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * `v` (avatar_version) n\'est pas lu : il change l\'URL à chaque photo, ce qui permet un cache immuable.
         * @summary Get Avatar
         * @param {string} personneId 
         * @param {string | null} [v] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvatarPersonnesPersonneIdAvatarGet(personneId: string, v?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvatarPersonnesPersonneIdAvatarGet(personneId, v, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnesApi.getAvatarPersonnesPersonneIdAvatarGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get By External Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByExternalIdPersonnesMeGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessMoiSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByExternalIdPersonnesMeGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnesApi.getByExternalIdPersonnesMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Preferences Mail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreferencesMailPersonnesMePreferencesMailGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessPreferencesMailSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreferencesMailPersonnesMePreferencesMailGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnesApi.getPreferencesMailPersonnesMePreferencesMailGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retirer Avatar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retirerAvatarPersonnesMeAvatarDelete(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessMoiSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retirerAvatarPersonnesMeAvatarDelete(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnesApi.retirerAvatarPersonnesMeAvatarDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supprime la personne et son compte Keycloak ; ses pièces partagées en écriture passent aux collaborateurs choisis.
         * @summary Supprimer Compte
         * @param {SuppressionCompteForm} suppressionCompteForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supprimerComptePersonnesMeDelete(suppressionCompteForm: SuppressionCompteForm, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessBool>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supprimerComptePersonnesMeDelete(suppressionCompteForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnesApi.supprimerComptePersonnesMeDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Preferences Mail
         * @param {PreferencesMailFormUpdate} preferencesMailFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePreferencesMailPersonnesMePreferencesMailPatch(preferencesMailFormUpdate: PreferencesMailFormUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessPreferencesMailSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePreferencesMailPersonnesMePreferencesMailPatch(preferencesMailFormUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnesApi.updatePreferencesMailPersonnesMePreferencesMailPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PersonnesApi - factory interface
 * @export
 */
export const PersonnesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PersonnesApiFp(configuration)
    return {
        /**
         * 
         * @summary Definir Avatar
         * @param {PersonnesApiDefinirAvatarPersonnesMeAvatarPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        definirAvatarPersonnesMeAvatarPost(requestParameters: PersonnesApiDefinirAvatarPersonnesMeAvatarPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessMoiSchema> {
            return localVarFp.definirAvatarPersonnesMeAvatarPost(requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * Ce que la suppression du compte bloquerait, transmettrait, emporterait et quitterait.
         * @summary Get Apercu Suppression
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApercuSuppressionPersonnesMeSuppressionGet(options?: RawAxiosRequestConfig): AxiosPromise<APISuccessSuppressionCompteApercuSchema> {
            return localVarFp.getApercuSuppressionPersonnesMeSuppressionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * `v` (avatar_version) n\'est pas lu : il change l\'URL à chaque photo, ce qui permet un cache immuable.
         * @summary Get Avatar
         * @param {PersonnesApiGetAvatarPersonnesPersonneIdAvatarGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarPersonnesPersonneIdAvatarGet(requestParameters: PersonnesApiGetAvatarPersonnesPersonneIdAvatarGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getAvatarPersonnesPersonneIdAvatarGet(requestParameters.personneId, requestParameters.v, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get By External Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByExternalIdPersonnesMeGet(options?: RawAxiosRequestConfig): AxiosPromise<APISuccessMoiSchema> {
            return localVarFp.getByExternalIdPersonnesMeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Preferences Mail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferencesMailPersonnesMePreferencesMailGet(options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPreferencesMailSchema> {
            return localVarFp.getPreferencesMailPersonnesMePreferencesMailGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retirer Avatar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retirerAvatarPersonnesMeAvatarDelete(options?: RawAxiosRequestConfig): AxiosPromise<APISuccessMoiSchema> {
            return localVarFp.retirerAvatarPersonnesMeAvatarDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * Supprime la personne et son compte Keycloak ; ses pièces partagées en écriture passent aux collaborateurs choisis.
         * @summary Supprimer Compte
         * @param {PersonnesApiSupprimerComptePersonnesMeDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supprimerComptePersonnesMeDelete(requestParameters: PersonnesApiSupprimerComptePersonnesMeDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessBool> {
            return localVarFp.supprimerComptePersonnesMeDelete(requestParameters.suppressionCompteForm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Preferences Mail
         * @param {PersonnesApiUpdatePreferencesMailPersonnesMePreferencesMailPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferencesMailPersonnesMePreferencesMailPatch(requestParameters: PersonnesApiUpdatePreferencesMailPersonnesMePreferencesMailPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPreferencesMailSchema> {
            return localVarFp.updatePreferencesMailPersonnesMePreferencesMailPatch(requestParameters.preferencesMailFormUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PersonnesApi - interface
 * @export
 * @interface PersonnesApi
 */
export interface PersonnesApiInterface {
    /**
     * 
     * @summary Definir Avatar
     * @param {PersonnesApiDefinirAvatarPersonnesMeAvatarPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApiInterface
     */
    definirAvatarPersonnesMeAvatarPost(requestParameters: PersonnesApiDefinirAvatarPersonnesMeAvatarPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessMoiSchema>;

    /**
     * Ce que la suppression du compte bloquerait, transmettrait, emporterait et quitterait.
     * @summary Get Apercu Suppression
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApiInterface
     */
    getApercuSuppressionPersonnesMeSuppressionGet(options?: RawAxiosRequestConfig): AxiosPromise<APISuccessSuppressionCompteApercuSchema>;

    /**
     * `v` (avatar_version) n\'est pas lu : il change l\'URL à chaque photo, ce qui permet un cache immuable.
     * @summary Get Avatar
     * @param {PersonnesApiGetAvatarPersonnesPersonneIdAvatarGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApiInterface
     */
    getAvatarPersonnesPersonneIdAvatarGet(requestParameters: PersonnesApiGetAvatarPersonnesPersonneIdAvatarGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Get By External Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApiInterface
     */
    getByExternalIdPersonnesMeGet(options?: RawAxiosRequestConfig): AxiosPromise<APISuccessMoiSchema>;

    /**
     * 
     * @summary Get Preferences Mail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApiInterface
     */
    getPreferencesMailPersonnesMePreferencesMailGet(options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPreferencesMailSchema>;

    /**
     * 
     * @summary Retirer Avatar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApiInterface
     */
    retirerAvatarPersonnesMeAvatarDelete(options?: RawAxiosRequestConfig): AxiosPromise<APISuccessMoiSchema>;

    /**
     * Supprime la personne et son compte Keycloak ; ses pièces partagées en écriture passent aux collaborateurs choisis.
     * @summary Supprimer Compte
     * @param {PersonnesApiSupprimerComptePersonnesMeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApiInterface
     */
    supprimerComptePersonnesMeDelete(requestParameters: PersonnesApiSupprimerComptePersonnesMeDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessBool>;

    /**
     * 
     * @summary Update Preferences Mail
     * @param {PersonnesApiUpdatePreferencesMailPersonnesMePreferencesMailPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApiInterface
     */
    updatePreferencesMailPersonnesMePreferencesMailPatch(requestParameters: PersonnesApiUpdatePreferencesMailPersonnesMePreferencesMailPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPreferencesMailSchema>;

}

/**
 * Request parameters for definirAvatarPersonnesMeAvatarPost operation in PersonnesApi.
 * @export
 * @interface PersonnesApiDefinirAvatarPersonnesMeAvatarPostRequest
 */
export interface PersonnesApiDefinirAvatarPersonnesMeAvatarPostRequest {
    /**
     * 
     * @type {File}
     * @memberof PersonnesApiDefinirAvatarPersonnesMeAvatarPost
     */
    readonly file: File
}

/**
 * Request parameters for getAvatarPersonnesPersonneIdAvatarGet operation in PersonnesApi.
 * @export
 * @interface PersonnesApiGetAvatarPersonnesPersonneIdAvatarGetRequest
 */
export interface PersonnesApiGetAvatarPersonnesPersonneIdAvatarGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PersonnesApiGetAvatarPersonnesPersonneIdAvatarGet
     */
    readonly personneId: string

    /**
     * 
     * @type {string}
     * @memberof PersonnesApiGetAvatarPersonnesPersonneIdAvatarGet
     */
    readonly v?: string | null
}

/**
 * Request parameters for supprimerComptePersonnesMeDelete operation in PersonnesApi.
 * @export
 * @interface PersonnesApiSupprimerComptePersonnesMeDeleteRequest
 */
export interface PersonnesApiSupprimerComptePersonnesMeDeleteRequest {
    /**
     * 
     * @type {SuppressionCompteForm}
     * @memberof PersonnesApiSupprimerComptePersonnesMeDelete
     */
    readonly suppressionCompteForm: SuppressionCompteForm
}

/**
 * Request parameters for updatePreferencesMailPersonnesMePreferencesMailPatch operation in PersonnesApi.
 * @export
 * @interface PersonnesApiUpdatePreferencesMailPersonnesMePreferencesMailPatchRequest
 */
export interface PersonnesApiUpdatePreferencesMailPersonnesMePreferencesMailPatchRequest {
    /**
     * 
     * @type {PreferencesMailFormUpdate}
     * @memberof PersonnesApiUpdatePreferencesMailPersonnesMePreferencesMailPatch
     */
    readonly preferencesMailFormUpdate: PreferencesMailFormUpdate
}

/**
 * PersonnesApi - object-oriented interface
 * @export
 * @class PersonnesApi
 * @extends {BaseAPI}
 */
export class PersonnesApi extends BaseAPI implements PersonnesApiInterface {
    /**
     * 
     * @summary Definir Avatar
     * @param {PersonnesApiDefinirAvatarPersonnesMeAvatarPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApi
     */
    public definirAvatarPersonnesMeAvatarPost(requestParameters: PersonnesApiDefinirAvatarPersonnesMeAvatarPostRequest, options?: RawAxiosRequestConfig) {
        return PersonnesApiFp(this.configuration).definirAvatarPersonnesMeAvatarPost(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ce que la suppression du compte bloquerait, transmettrait, emporterait et quitterait.
     * @summary Get Apercu Suppression
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApi
     */
    public getApercuSuppressionPersonnesMeSuppressionGet(options?: RawAxiosRequestConfig) {
        return PersonnesApiFp(this.configuration).getApercuSuppressionPersonnesMeSuppressionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * `v` (avatar_version) n\'est pas lu : il change l\'URL à chaque photo, ce qui permet un cache immuable.
     * @summary Get Avatar
     * @param {PersonnesApiGetAvatarPersonnesPersonneIdAvatarGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApi
     */
    public getAvatarPersonnesPersonneIdAvatarGet(requestParameters: PersonnesApiGetAvatarPersonnesPersonneIdAvatarGetRequest, options?: RawAxiosRequestConfig) {
        return PersonnesApiFp(this.configuration).getAvatarPersonnesPersonneIdAvatarGet(requestParameters.personneId, requestParameters.v, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get By External Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApi
     */
    public getByExternalIdPersonnesMeGet(options?: RawAxiosRequestConfig) {
        return PersonnesApiFp(this.configuration).getByExternalIdPersonnesMeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Preferences Mail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApi
     */
    public getPreferencesMailPersonnesMePreferencesMailGet(options?: RawAxiosRequestConfig) {
        return PersonnesApiFp(this.configuration).getPreferencesMailPersonnesMePreferencesMailGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retirer Avatar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApi
     */
    public retirerAvatarPersonnesMeAvatarDelete(options?: RawAxiosRequestConfig) {
        return PersonnesApiFp(this.configuration).retirerAvatarPersonnesMeAvatarDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supprime la personne et son compte Keycloak ; ses pièces partagées en écriture passent aux collaborateurs choisis.
     * @summary Supprimer Compte
     * @param {PersonnesApiSupprimerComptePersonnesMeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApi
     */
    public supprimerComptePersonnesMeDelete(requestParameters: PersonnesApiSupprimerComptePersonnesMeDeleteRequest, options?: RawAxiosRequestConfig) {
        return PersonnesApiFp(this.configuration).supprimerComptePersonnesMeDelete(requestParameters.suppressionCompteForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Preferences Mail
     * @param {PersonnesApiUpdatePreferencesMailPersonnesMePreferencesMailPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnesApi
     */
    public updatePreferencesMailPersonnesMePreferencesMailPatch(requestParameters: PersonnesApiUpdatePreferencesMailPersonnesMePreferencesMailPatchRequest, options?: RawAxiosRequestConfig) {
        return PersonnesApiFp(this.configuration).updatePreferencesMailPersonnesMePreferencesMailPatch(requestParameters.preferencesMailFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PiecesApi - axios parameter creator
 * @export
 */
export const PiecesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Confirm Import Piece Text
         * @param {string} pieceId 
         * @param {ImportCorrectionsSchema} [importCorrectionsSchema] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmImportPieceTextPiecesPieceIdImportTextConfirmPost: async (pieceId: string, importCorrectionsSchema?: ImportCorrectionsSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('confirmImportPieceTextPiecesPieceIdImportTextConfirmPost', 'pieceId', pieceId)
            const localVarPath = `/pieces/{piece_id}/import-text/confirm`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importCorrectionsSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Partage
         * @param {string} pieceId 
         * @param {PartageFormCreate} partageFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartagePiecesPieceIdPartagesPost: async (pieceId: string, partageFormCreate: PartageFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('createPartagePiecesPieceIdPartagesPost', 'pieceId', pieceId)
            // verify required parameter 'partageFormCreate' is not null or undefined
            assertParamExists('createPartagePiecesPieceIdPartagesPost', 'partageFormCreate', partageFormCreate)
            const localVarPath = `/pieces/{piece_id}/partages`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partageFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Piece
         * @param {PieceFormInformations} pieceFormInformations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPiecePiecesPost: async (pieceFormInformations: PieceFormInformations, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceFormInformations' is not null or undefined
            assertParamExists('createPiecePiecesPost', 'pieceFormInformations', pieceFormInformations)
            const localVarPath = `/pieces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pieceFormInformations, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Affiche Piece
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAffichePiecePiecesPieceIdAfficheDelete: async (pieceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('deleteAffichePiecePiecesPieceIdAfficheDelete', 'pieceId', pieceId)
            const localVarPath = `/pieces/{piece_id}/affiche`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Partage
         * @param {string} pieceId 
         * @param {string} personneId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartagePiecesPieceIdPartagesPersonneIdDelete: async (pieceId: string, personneId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('deletePartagePiecesPieceIdPartagesPersonneIdDelete', 'pieceId', pieceId)
            // verify required parameter 'personneId' is not null or undefined
            assertParamExists('deletePartagePiecesPieceIdPartagesPersonneIdDelete', 'personneId', personneId)
            const localVarPath = `/pieces/{piece_id}/partages/{personne_id}`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)))
                .replace(`{${"personne_id"}}`, encodeURIComponent(String(personneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Piece
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePiecePiecesPieceIdDelete: async (pieceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('deletePiecePiecesPieceIdDelete', 'pieceId', pieceId)
            const localVarPath = `/pieces/{piece_id}`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Duplicate Piece
         * @param {string} pieceId 
         * @param {PieceFormAdaptation} pieceFormAdaptation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicatePiecePiecesPieceIdDuplicatePost: async (pieceId: string, pieceFormAdaptation: PieceFormAdaptation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('duplicatePiecePiecesPieceIdDuplicatePost', 'pieceId', pieceId)
            // verify required parameter 'pieceFormAdaptation' is not null or undefined
            assertParamExists('duplicatePiecePiecesPieceIdDuplicatePost', 'pieceFormAdaptation', pieceFormAdaptation)
            const localVarPath = `/pieces/{piece_id}/duplicate`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pieceFormAdaptation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Piece Pdf
         * @param {string} pieceId 
         * @param {number} [fontSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPiecePdfPiecesPieceIdExportPdfPost: async (pieceId: string, fontSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('exportPiecePdfPiecesPieceIdExportPdfPost', 'pieceId', pieceId)
            const localVarPath = `/pieces/{piece_id}/export-pdf`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fontSize !== undefined) {
                localVarQueryParameter['font_size'] = fontSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Piece
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPiecePiecesPieceIdGet: async (pieceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('getPiecePiecesPieceIdGet', 'pieceId', pieceId)
            const localVarPath = `/pieces/{piece_id}`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Statistiques
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistiquesPiecesPieceIdStatistiquesGet: async (pieceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('getStatistiquesPiecesPieceIdStatistiquesGet', 'pieceId', pieceId)
            const localVarPath = `/pieces/{piece_id}/statistiques`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import Piece Text
         * @param {string} pieceId 
         * @param {File} file 
         * @param {boolean} [strict] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPieceTextPiecesPieceIdImportTextPost: async (pieceId: string, file: File, strict?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('importPieceTextPiecesPieceIdImportTextPost', 'pieceId', pieceId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importPieceTextPiecesPieceIdImportTextPost', 'file', file)
            const localVarPath = `/pieces/{piece_id}/import-text`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (strict !== undefined) {
                localVarQueryParameter['strict'] = strict;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * La pièce et ses autres adaptations, limitées à celles que l\'appelant voit.
         * @summary List Adaptations
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdaptationsPiecesPieceIdAdaptationsGet: async (pieceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('listAdaptationsPiecesPieceIdAdaptationsGet', 'pieceId', pieceId)
            const localVarPath = `/pieces/{piece_id}/adaptations`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Partageables
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartageablesPiecesPieceIdPartageablesGet: async (pieceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('listPartageablesPiecesPieceIdPartageablesGet', 'pieceId', pieceId)
            const localVarPath = `/pieces/{piece_id}/partageables`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Partages
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartagesPiecesPieceIdPartagesGet: async (pieceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('listPartagesPiecesPieceIdPartagesGet', 'pieceId', pieceId)
            const localVarPath = `/pieces/{piece_id}/partages`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Pieces Librairie
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListPiecesLibrairiePiecesGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPiecesLibrairiePiecesGet: async (page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListPiecesLibrairiePiecesGetSortOrderEnum, search?: string | null, searchFields?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pieces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['search_fields'] = searchFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Informations
         * @param {string} pieceId 
         * @param {PieceFormInformations} pieceFormInformations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInformationsPiecesPieceIdInformationsPatch: async (pieceId: string, pieceFormInformations: PieceFormInformations, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('updateInformationsPiecesPieceIdInformationsPatch', 'pieceId', pieceId)
            // verify required parameter 'pieceFormInformations' is not null or undefined
            assertParamExists('updateInformationsPiecesPieceIdInformationsPatch', 'pieceFormInformations', pieceFormInformations)
            const localVarPath = `/pieces/{piece_id}/informations`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pieceFormInformations, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Partage
         * @param {string} pieceId 
         * @param {string} personneId 
         * @param {PartageFormUpdate} partageFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartagePiecesPieceIdPartagesPersonneIdPatch: async (pieceId: string, personneId: string, partageFormUpdate: PartageFormUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('updatePartagePiecesPieceIdPartagesPersonneIdPatch', 'pieceId', pieceId)
            // verify required parameter 'personneId' is not null or undefined
            assertParamExists('updatePartagePiecesPieceIdPartagesPersonneIdPatch', 'personneId', personneId)
            // verify required parameter 'partageFormUpdate' is not null or undefined
            assertParamExists('updatePartagePiecesPieceIdPartagesPersonneIdPatch', 'partageFormUpdate', partageFormUpdate)
            const localVarPath = `/pieces/{piece_id}/partages/{personne_id}`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)))
                .replace(`{${"personne_id"}}`, encodeURIComponent(String(personneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partageFormUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Affiche Piece
         * @param {string} pieceId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAffichePiecePiecesPieceIdAffichePost: async (pieceId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('uploadAffichePiecePiecesPieceIdAffichePost', 'pieceId', pieceId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadAffichePiecePiecesPieceIdAffichePost', 'file', file)
            const localVarPath = `/pieces/{piece_id}/affiche`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PiecesApi - functional programming interface
 * @export
 */
export const PiecesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PiecesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Confirm Import Piece Text
         * @param {string} pieceId 
         * @param {ImportCorrectionsSchema} [importCorrectionsSchema] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmImportPieceTextPiecesPieceIdImportTextConfirmPost(pieceId: string, importCorrectionsSchema?: ImportCorrectionsSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessPieceSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmImportPieceTextPiecesPieceIdImportTextConfirmPost(pieceId, importCorrectionsSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.confirmImportPieceTextPiecesPieceIdImportTextConfirmPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Partage
         * @param {string} pieceId 
         * @param {PartageFormCreate} partageFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPartagePiecesPieceIdPartagesPost(pieceId: string, partageFormCreate: PartageFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessPartageSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPartagePiecesPieceIdPartagesPost(pieceId, partageFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.createPartagePiecesPieceIdPartagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Piece
         * @param {PieceFormInformations} pieceFormInformations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPiecePiecesPost(pieceFormInformations: PieceFormInformations, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessPieceSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPiecePiecesPost(pieceFormInformations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.createPiecePiecesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Affiche Piece
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAffichePiecePiecesPieceIdAfficheDelete(pieceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessPieceSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAffichePiecePiecesPieceIdAfficheDelete(pieceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.deleteAffichePiecePiecesPieceIdAfficheDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Partage
         * @param {string} pieceId 
         * @param {string} personneId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePartagePiecesPieceIdPartagesPersonneIdDelete(pieceId: string, personneId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessPartageSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePartagePiecesPieceIdPartagesPersonneIdDelete(pieceId, personneId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.deletePartagePiecesPieceIdPartagesPersonneIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Piece
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePiecePiecesPieceIdDelete(pieceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessPieceSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePiecePiecesPieceIdDelete(pieceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.deletePiecePiecesPieceIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Duplicate Piece
         * @param {string} pieceId 
         * @param {PieceFormAdaptation} pieceFormAdaptation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicatePiecePiecesPieceIdDuplicatePost(pieceId: string, pieceFormAdaptation: PieceFormAdaptation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessPieceSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicatePiecePiecesPieceIdDuplicatePost(pieceId, pieceFormAdaptation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.duplicatePiecePiecesPieceIdDuplicatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Piece Pdf
         * @param {string} pieceId 
         * @param {number} [fontSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPiecePdfPiecesPieceIdExportPdfPost(pieceId: string, fontSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPiecePdfPiecesPieceIdExportPdfPost(pieceId, fontSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.exportPiecePdfPiecesPieceIdExportPdfPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Piece
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPiecePiecesPieceIdGet(pieceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessPieceSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPiecePiecesPieceIdGet(pieceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.getPiecePiecesPieceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Statistiques
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatistiquesPiecesPieceIdStatistiquesGet(pieceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessPieceStatistiquesSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatistiquesPiecesPieceIdStatistiquesGet(pieceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.getStatistiquesPiecesPieceIdStatistiquesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Import Piece Text
         * @param {string} pieceId 
         * @param {File} file 
         * @param {boolean} [strict] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importPieceTextPiecesPieceIdImportTextPost(pieceId: string, file: File, strict?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessParsedDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importPieceTextPiecesPieceIdImportTextPost(pieceId, file, strict, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.importPieceTextPiecesPieceIdImportTextPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * La pièce et ses autres adaptations, limitées à celles que l\'appelant voit.
         * @summary List Adaptations
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAdaptationsPiecesPieceIdAdaptationsGet(pieceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListPieceAdaptationSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAdaptationsPiecesPieceIdAdaptationsGet(pieceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.listAdaptationsPiecesPieceIdAdaptationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Partageables
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPartageablesPiecesPieceIdPartageablesGet(pieceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListPersonneSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPartageablesPiecesPieceIdPartageablesGet(pieceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.listPartageablesPiecesPieceIdPartageablesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Partages
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPartagesPiecesPieceIdPartagesGet(pieceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListPartageSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPartagesPiecesPieceIdPartagesGet(pieceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.listPartagesPiecesPieceIdPartagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Pieces Librairie
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListPiecesLibrairiePiecesGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPiecesLibrairiePiecesGet(page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListPiecesLibrairiePiecesGetSortOrderEnum, search?: string | null, searchFields?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListPieceSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPiecesLibrairiePiecesGet(page, pageSize, sortBy, sortOrder, search, searchFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.listPiecesLibrairiePiecesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Informations
         * @param {string} pieceId 
         * @param {PieceFormInformations} pieceFormInformations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInformationsPiecesPieceIdInformationsPatch(pieceId: string, pieceFormInformations: PieceFormInformations, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessPieceSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInformationsPiecesPieceIdInformationsPatch(pieceId, pieceFormInformations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.updateInformationsPiecesPieceIdInformationsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Partage
         * @param {string} pieceId 
         * @param {string} personneId 
         * @param {PartageFormUpdate} partageFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePartagePiecesPieceIdPartagesPersonneIdPatch(pieceId: string, personneId: string, partageFormUpdate: PartageFormUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessPartageSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePartagePiecesPieceIdPartagesPersonneIdPatch(pieceId, personneId, partageFormUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.updatePartagePiecesPieceIdPartagesPersonneIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Affiche Piece
         * @param {string} pieceId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAffichePiecePiecesPieceIdAffichePost(pieceId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessPieceSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAffichePiecePiecesPieceIdAffichePost(pieceId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PiecesApi.uploadAffichePiecePiecesPieceIdAffichePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PiecesApi - factory interface
 * @export
 */
export const PiecesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PiecesApiFp(configuration)
    return {
        /**
         * 
         * @summary Confirm Import Piece Text
         * @param {PiecesApiConfirmImportPieceTextPiecesPieceIdImportTextConfirmPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmImportPieceTextPiecesPieceIdImportTextConfirmPost(requestParameters: PiecesApiConfirmImportPieceTextPiecesPieceIdImportTextConfirmPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchemaLite> {
            return localVarFp.confirmImportPieceTextPiecesPieceIdImportTextConfirmPost(requestParameters.pieceId, requestParameters.importCorrectionsSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Partage
         * @param {PiecesApiCreatePartagePiecesPieceIdPartagesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartagePiecesPieceIdPartagesPost(requestParameters: PiecesApiCreatePartagePiecesPieceIdPartagesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPartageSchemaLite> {
            return localVarFp.createPartagePiecesPieceIdPartagesPost(requestParameters.pieceId, requestParameters.partageFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Piece
         * @param {PiecesApiCreatePiecePiecesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPiecePiecesPost(requestParameters: PiecesApiCreatePiecePiecesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchemaLite> {
            return localVarFp.createPiecePiecesPost(requestParameters.pieceFormInformations, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Affiche Piece
         * @param {PiecesApiDeleteAffichePiecePiecesPieceIdAfficheDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAffichePiecePiecesPieceIdAfficheDelete(requestParameters: PiecesApiDeleteAffichePiecePiecesPieceIdAfficheDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchemaLite> {
            return localVarFp.deleteAffichePiecePiecesPieceIdAfficheDelete(requestParameters.pieceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Partage
         * @param {PiecesApiDeletePartagePiecesPieceIdPartagesPersonneIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartagePiecesPieceIdPartagesPersonneIdDelete(requestParameters: PiecesApiDeletePartagePiecesPieceIdPartagesPersonneIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPartageSchemaLite> {
            return localVarFp.deletePartagePiecesPieceIdPartagesPersonneIdDelete(requestParameters.pieceId, requestParameters.personneId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Piece
         * @param {PiecesApiDeletePiecePiecesPieceIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePiecePiecesPieceIdDelete(requestParameters: PiecesApiDeletePiecePiecesPieceIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchemaLite> {
            return localVarFp.deletePiecePiecesPieceIdDelete(requestParameters.pieceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Duplicate Piece
         * @param {PiecesApiDuplicatePiecePiecesPieceIdDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicatePiecePiecesPieceIdDuplicatePost(requestParameters: PiecesApiDuplicatePiecePiecesPieceIdDuplicatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchemaLite> {
            return localVarFp.duplicatePiecePiecesPieceIdDuplicatePost(requestParameters.pieceId, requestParameters.pieceFormAdaptation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Piece Pdf
         * @param {PiecesApiExportPiecePdfPiecesPieceIdExportPdfPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPiecePdfPiecesPieceIdExportPdfPost(requestParameters: PiecesApiExportPiecePdfPiecesPieceIdExportPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportPiecePdfPiecesPieceIdExportPdfPost(requestParameters.pieceId, requestParameters.fontSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Piece
         * @param {PiecesApiGetPiecePiecesPieceIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPiecePiecesPieceIdGet(requestParameters: PiecesApiGetPiecePiecesPieceIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchema> {
            return localVarFp.getPiecePiecesPieceIdGet(requestParameters.pieceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Statistiques
         * @param {PiecesApiGetStatistiquesPiecesPieceIdStatistiquesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistiquesPiecesPieceIdStatistiquesGet(requestParameters: PiecesApiGetStatistiquesPiecesPieceIdStatistiquesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceStatistiquesSchema> {
            return localVarFp.getStatistiquesPiecesPieceIdStatistiquesGet(requestParameters.pieceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import Piece Text
         * @param {PiecesApiImportPieceTextPiecesPieceIdImportTextPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPieceTextPiecesPieceIdImportTextPost(requestParameters: PiecesApiImportPieceTextPiecesPieceIdImportTextPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessParsedDocument> {
            return localVarFp.importPieceTextPiecesPieceIdImportTextPost(requestParameters.pieceId, requestParameters.file, requestParameters.strict, options).then((request) => request(axios, basePath));
        },
        /**
         * La pièce et ses autres adaptations, limitées à celles que l\'appelant voit.
         * @summary List Adaptations
         * @param {PiecesApiListAdaptationsPiecesPieceIdAdaptationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdaptationsPiecesPieceIdAdaptationsGet(requestParameters: PiecesApiListAdaptationsPiecesPieceIdAdaptationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListPieceAdaptationSchema> {
            return localVarFp.listAdaptationsPiecesPieceIdAdaptationsGet(requestParameters.pieceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Partageables
         * @param {PiecesApiListPartageablesPiecesPieceIdPartageablesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartageablesPiecesPieceIdPartageablesGet(requestParameters: PiecesApiListPartageablesPiecesPieceIdPartageablesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListPersonneSchemaLite> {
            return localVarFp.listPartageablesPiecesPieceIdPartageablesGet(requestParameters.pieceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Partages
         * @param {PiecesApiListPartagesPiecesPieceIdPartagesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartagesPiecesPieceIdPartagesGet(requestParameters: PiecesApiListPartagesPiecesPieceIdPartagesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListPartageSchemaLite> {
            return localVarFp.listPartagesPiecesPieceIdPartagesGet(requestParameters.pieceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Pieces Librairie
         * @param {PiecesApiListPiecesLibrairiePiecesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPiecesLibrairiePiecesGet(requestParameters: PiecesApiListPiecesLibrairiePiecesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListPieceSchemaLite> {
            return localVarFp.listPiecesLibrairiePiecesGet(requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Informations
         * @param {PiecesApiUpdateInformationsPiecesPieceIdInformationsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInformationsPiecesPieceIdInformationsPatch(requestParameters: PiecesApiUpdateInformationsPiecesPieceIdInformationsPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchemaLite> {
            return localVarFp.updateInformationsPiecesPieceIdInformationsPatch(requestParameters.pieceId, requestParameters.pieceFormInformations, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Partage
         * @param {PiecesApiUpdatePartagePiecesPieceIdPartagesPersonneIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartagePiecesPieceIdPartagesPersonneIdPatch(requestParameters: PiecesApiUpdatePartagePiecesPieceIdPartagesPersonneIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPartageSchemaLite> {
            return localVarFp.updatePartagePiecesPieceIdPartagesPersonneIdPatch(requestParameters.pieceId, requestParameters.personneId, requestParameters.partageFormUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Affiche Piece
         * @param {PiecesApiUploadAffichePiecePiecesPieceIdAffichePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAffichePiecePiecesPieceIdAffichePost(requestParameters: PiecesApiUploadAffichePiecePiecesPieceIdAffichePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchemaLite> {
            return localVarFp.uploadAffichePiecePiecesPieceIdAffichePost(requestParameters.pieceId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PiecesApi - interface
 * @export
 * @interface PiecesApi
 */
export interface PiecesApiInterface {
    /**
     * 
     * @summary Confirm Import Piece Text
     * @param {PiecesApiConfirmImportPieceTextPiecesPieceIdImportTextConfirmPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    confirmImportPieceTextPiecesPieceIdImportTextConfirmPost(requestParameters: PiecesApiConfirmImportPieceTextPiecesPieceIdImportTextConfirmPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchemaLite>;

    /**
     * 
     * @summary Create Partage
     * @param {PiecesApiCreatePartagePiecesPieceIdPartagesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    createPartagePiecesPieceIdPartagesPost(requestParameters: PiecesApiCreatePartagePiecesPieceIdPartagesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPartageSchemaLite>;

    /**
     * 
     * @summary Create Piece
     * @param {PiecesApiCreatePiecePiecesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    createPiecePiecesPost(requestParameters: PiecesApiCreatePiecePiecesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchemaLite>;

    /**
     * 
     * @summary Delete Affiche Piece
     * @param {PiecesApiDeleteAffichePiecePiecesPieceIdAfficheDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    deleteAffichePiecePiecesPieceIdAfficheDelete(requestParameters: PiecesApiDeleteAffichePiecePiecesPieceIdAfficheDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchemaLite>;

    /**
     * 
     * @summary Delete Partage
     * @param {PiecesApiDeletePartagePiecesPieceIdPartagesPersonneIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    deletePartagePiecesPieceIdPartagesPersonneIdDelete(requestParameters: PiecesApiDeletePartagePiecesPieceIdPartagesPersonneIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPartageSchemaLite>;

    /**
     * 
     * @summary Delete Piece
     * @param {PiecesApiDeletePiecePiecesPieceIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    deletePiecePiecesPieceIdDelete(requestParameters: PiecesApiDeletePiecePiecesPieceIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchemaLite>;

    /**
     * 
     * @summary Duplicate Piece
     * @param {PiecesApiDuplicatePiecePiecesPieceIdDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    duplicatePiecePiecesPieceIdDuplicatePost(requestParameters: PiecesApiDuplicatePiecePiecesPieceIdDuplicatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchemaLite>;

    /**
     * 
     * @summary Export Piece Pdf
     * @param {PiecesApiExportPiecePdfPiecesPieceIdExportPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    exportPiecePdfPiecesPieceIdExportPdfPost(requestParameters: PiecesApiExportPiecePdfPiecesPieceIdExportPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @summary Get Piece
     * @param {PiecesApiGetPiecePiecesPieceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    getPiecePiecesPieceIdGet(requestParameters: PiecesApiGetPiecePiecesPieceIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchema>;

    /**
     * 
     * @summary Get Statistiques
     * @param {PiecesApiGetStatistiquesPiecesPieceIdStatistiquesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    getStatistiquesPiecesPieceIdStatistiquesGet(requestParameters: PiecesApiGetStatistiquesPiecesPieceIdStatistiquesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceStatistiquesSchema>;

    /**
     * 
     * @summary Import Piece Text
     * @param {PiecesApiImportPieceTextPiecesPieceIdImportTextPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    importPieceTextPiecesPieceIdImportTextPost(requestParameters: PiecesApiImportPieceTextPiecesPieceIdImportTextPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessParsedDocument>;

    /**
     * La pièce et ses autres adaptations, limitées à celles que l\'appelant voit.
     * @summary List Adaptations
     * @param {PiecesApiListAdaptationsPiecesPieceIdAdaptationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    listAdaptationsPiecesPieceIdAdaptationsGet(requestParameters: PiecesApiListAdaptationsPiecesPieceIdAdaptationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListPieceAdaptationSchema>;

    /**
     * 
     * @summary List Partageables
     * @param {PiecesApiListPartageablesPiecesPieceIdPartageablesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    listPartageablesPiecesPieceIdPartageablesGet(requestParameters: PiecesApiListPartageablesPiecesPieceIdPartageablesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListPersonneSchemaLite>;

    /**
     * 
     * @summary List Partages
     * @param {PiecesApiListPartagesPiecesPieceIdPartagesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    listPartagesPiecesPieceIdPartagesGet(requestParameters: PiecesApiListPartagesPiecesPieceIdPartagesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListPartageSchemaLite>;

    /**
     * 
     * @summary List Pieces Librairie
     * @param {PiecesApiListPiecesLibrairiePiecesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    listPiecesLibrairiePiecesGet(requestParameters?: PiecesApiListPiecesLibrairiePiecesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListPieceSchemaLite>;

    /**
     * 
     * @summary Update Informations
     * @param {PiecesApiUpdateInformationsPiecesPieceIdInformationsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    updateInformationsPiecesPieceIdInformationsPatch(requestParameters: PiecesApiUpdateInformationsPiecesPieceIdInformationsPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchemaLite>;

    /**
     * 
     * @summary Update Partage
     * @param {PiecesApiUpdatePartagePiecesPieceIdPartagesPersonneIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    updatePartagePiecesPieceIdPartagesPersonneIdPatch(requestParameters: PiecesApiUpdatePartagePiecesPieceIdPartagesPersonneIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPartageSchemaLite>;

    /**
     * 
     * @summary Upload Affiche Piece
     * @param {PiecesApiUploadAffichePiecePiecesPieceIdAffichePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApiInterface
     */
    uploadAffichePiecePiecesPieceIdAffichePost(requestParameters: PiecesApiUploadAffichePiecePiecesPieceIdAffichePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessPieceSchemaLite>;

}

/**
 * Request parameters for confirmImportPieceTextPiecesPieceIdImportTextConfirmPost operation in PiecesApi.
 * @export
 * @interface PiecesApiConfirmImportPieceTextPiecesPieceIdImportTextConfirmPostRequest
 */
export interface PiecesApiConfirmImportPieceTextPiecesPieceIdImportTextConfirmPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiConfirmImportPieceTextPiecesPieceIdImportTextConfirmPost
     */
    readonly pieceId: string

    /**
     * 
     * @type {ImportCorrectionsSchema}
     * @memberof PiecesApiConfirmImportPieceTextPiecesPieceIdImportTextConfirmPost
     */
    readonly importCorrectionsSchema?: ImportCorrectionsSchema
}

/**
 * Request parameters for createPartagePiecesPieceIdPartagesPost operation in PiecesApi.
 * @export
 * @interface PiecesApiCreatePartagePiecesPieceIdPartagesPostRequest
 */
export interface PiecesApiCreatePartagePiecesPieceIdPartagesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiCreatePartagePiecesPieceIdPartagesPost
     */
    readonly pieceId: string

    /**
     * 
     * @type {PartageFormCreate}
     * @memberof PiecesApiCreatePartagePiecesPieceIdPartagesPost
     */
    readonly partageFormCreate: PartageFormCreate
}

/**
 * Request parameters for createPiecePiecesPost operation in PiecesApi.
 * @export
 * @interface PiecesApiCreatePiecePiecesPostRequest
 */
export interface PiecesApiCreatePiecePiecesPostRequest {
    /**
     * 
     * @type {PieceFormInformations}
     * @memberof PiecesApiCreatePiecePiecesPost
     */
    readonly pieceFormInformations: PieceFormInformations
}

/**
 * Request parameters for deleteAffichePiecePiecesPieceIdAfficheDelete operation in PiecesApi.
 * @export
 * @interface PiecesApiDeleteAffichePiecePiecesPieceIdAfficheDeleteRequest
 */
export interface PiecesApiDeleteAffichePiecePiecesPieceIdAfficheDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiDeleteAffichePiecePiecesPieceIdAfficheDelete
     */
    readonly pieceId: string
}

/**
 * Request parameters for deletePartagePiecesPieceIdPartagesPersonneIdDelete operation in PiecesApi.
 * @export
 * @interface PiecesApiDeletePartagePiecesPieceIdPartagesPersonneIdDeleteRequest
 */
export interface PiecesApiDeletePartagePiecesPieceIdPartagesPersonneIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiDeletePartagePiecesPieceIdPartagesPersonneIdDelete
     */
    readonly pieceId: string

    /**
     * 
     * @type {string}
     * @memberof PiecesApiDeletePartagePiecesPieceIdPartagesPersonneIdDelete
     */
    readonly personneId: string
}

/**
 * Request parameters for deletePiecePiecesPieceIdDelete operation in PiecesApi.
 * @export
 * @interface PiecesApiDeletePiecePiecesPieceIdDeleteRequest
 */
export interface PiecesApiDeletePiecePiecesPieceIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiDeletePiecePiecesPieceIdDelete
     */
    readonly pieceId: string
}

/**
 * Request parameters for duplicatePiecePiecesPieceIdDuplicatePost operation in PiecesApi.
 * @export
 * @interface PiecesApiDuplicatePiecePiecesPieceIdDuplicatePostRequest
 */
export interface PiecesApiDuplicatePiecePiecesPieceIdDuplicatePostRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiDuplicatePiecePiecesPieceIdDuplicatePost
     */
    readonly pieceId: string

    /**
     * 
     * @type {PieceFormAdaptation}
     * @memberof PiecesApiDuplicatePiecePiecesPieceIdDuplicatePost
     */
    readonly pieceFormAdaptation: PieceFormAdaptation
}

/**
 * Request parameters for exportPiecePdfPiecesPieceIdExportPdfPost operation in PiecesApi.
 * @export
 * @interface PiecesApiExportPiecePdfPiecesPieceIdExportPdfPostRequest
 */
export interface PiecesApiExportPiecePdfPiecesPieceIdExportPdfPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiExportPiecePdfPiecesPieceIdExportPdfPost
     */
    readonly pieceId: string

    /**
     * 
     * @type {number}
     * @memberof PiecesApiExportPiecePdfPiecesPieceIdExportPdfPost
     */
    readonly fontSize?: number
}

/**
 * Request parameters for getPiecePiecesPieceIdGet operation in PiecesApi.
 * @export
 * @interface PiecesApiGetPiecePiecesPieceIdGetRequest
 */
export interface PiecesApiGetPiecePiecesPieceIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiGetPiecePiecesPieceIdGet
     */
    readonly pieceId: string
}

/**
 * Request parameters for getStatistiquesPiecesPieceIdStatistiquesGet operation in PiecesApi.
 * @export
 * @interface PiecesApiGetStatistiquesPiecesPieceIdStatistiquesGetRequest
 */
export interface PiecesApiGetStatistiquesPiecesPieceIdStatistiquesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiGetStatistiquesPiecesPieceIdStatistiquesGet
     */
    readonly pieceId: string
}

/**
 * Request parameters for importPieceTextPiecesPieceIdImportTextPost operation in PiecesApi.
 * @export
 * @interface PiecesApiImportPieceTextPiecesPieceIdImportTextPostRequest
 */
export interface PiecesApiImportPieceTextPiecesPieceIdImportTextPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiImportPieceTextPiecesPieceIdImportTextPost
     */
    readonly pieceId: string

    /**
     * 
     * @type {File}
     * @memberof PiecesApiImportPieceTextPiecesPieceIdImportTextPost
     */
    readonly file: File

    /**
     * 
     * @type {boolean}
     * @memberof PiecesApiImportPieceTextPiecesPieceIdImportTextPost
     */
    readonly strict?: boolean
}

/**
 * Request parameters for listAdaptationsPiecesPieceIdAdaptationsGet operation in PiecesApi.
 * @export
 * @interface PiecesApiListAdaptationsPiecesPieceIdAdaptationsGetRequest
 */
export interface PiecesApiListAdaptationsPiecesPieceIdAdaptationsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiListAdaptationsPiecesPieceIdAdaptationsGet
     */
    readonly pieceId: string
}

/**
 * Request parameters for listPartageablesPiecesPieceIdPartageablesGet operation in PiecesApi.
 * @export
 * @interface PiecesApiListPartageablesPiecesPieceIdPartageablesGetRequest
 */
export interface PiecesApiListPartageablesPiecesPieceIdPartageablesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiListPartageablesPiecesPieceIdPartageablesGet
     */
    readonly pieceId: string
}

/**
 * Request parameters for listPartagesPiecesPieceIdPartagesGet operation in PiecesApi.
 * @export
 * @interface PiecesApiListPartagesPiecesPieceIdPartagesGetRequest
 */
export interface PiecesApiListPartagesPiecesPieceIdPartagesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiListPartagesPiecesPieceIdPartagesGet
     */
    readonly pieceId: string
}

/**
 * Request parameters for listPiecesLibrairiePiecesGet operation in PiecesApi.
 * @export
 * @interface PiecesApiListPiecesLibrairiePiecesGetRequest
 */
export interface PiecesApiListPiecesLibrairiePiecesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PiecesApiListPiecesLibrairiePiecesGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof PiecesApiListPiecesLibrairiePiecesGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof PiecesApiListPiecesLibrairiePiecesGet
     */
    readonly sortBy?: string | null

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof PiecesApiListPiecesLibrairiePiecesGet
     */
    readonly sortOrder?: ListPiecesLibrairiePiecesGetSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof PiecesApiListPiecesLibrairiePiecesGet
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof PiecesApiListPiecesLibrairiePiecesGet
     */
    readonly searchFields?: string | null
}

/**
 * Request parameters for updateInformationsPiecesPieceIdInformationsPatch operation in PiecesApi.
 * @export
 * @interface PiecesApiUpdateInformationsPiecesPieceIdInformationsPatchRequest
 */
export interface PiecesApiUpdateInformationsPiecesPieceIdInformationsPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiUpdateInformationsPiecesPieceIdInformationsPatch
     */
    readonly pieceId: string

    /**
     * 
     * @type {PieceFormInformations}
     * @memberof PiecesApiUpdateInformationsPiecesPieceIdInformationsPatch
     */
    readonly pieceFormInformations: PieceFormInformations
}

/**
 * Request parameters for updatePartagePiecesPieceIdPartagesPersonneIdPatch operation in PiecesApi.
 * @export
 * @interface PiecesApiUpdatePartagePiecesPieceIdPartagesPersonneIdPatchRequest
 */
export interface PiecesApiUpdatePartagePiecesPieceIdPartagesPersonneIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiUpdatePartagePiecesPieceIdPartagesPersonneIdPatch
     */
    readonly pieceId: string

    /**
     * 
     * @type {string}
     * @memberof PiecesApiUpdatePartagePiecesPieceIdPartagesPersonneIdPatch
     */
    readonly personneId: string

    /**
     * 
     * @type {PartageFormUpdate}
     * @memberof PiecesApiUpdatePartagePiecesPieceIdPartagesPersonneIdPatch
     */
    readonly partageFormUpdate: PartageFormUpdate
}

/**
 * Request parameters for uploadAffichePiecePiecesPieceIdAffichePost operation in PiecesApi.
 * @export
 * @interface PiecesApiUploadAffichePiecePiecesPieceIdAffichePostRequest
 */
export interface PiecesApiUploadAffichePiecePiecesPieceIdAffichePostRequest {
    /**
     * 
     * @type {string}
     * @memberof PiecesApiUploadAffichePiecePiecesPieceIdAffichePost
     */
    readonly pieceId: string

    /**
     * 
     * @type {File}
     * @memberof PiecesApiUploadAffichePiecePiecesPieceIdAffichePost
     */
    readonly file: File
}

/**
 * PiecesApi - object-oriented interface
 * @export
 * @class PiecesApi
 * @extends {BaseAPI}
 */
export class PiecesApi extends BaseAPI implements PiecesApiInterface {
    /**
     * 
     * @summary Confirm Import Piece Text
     * @param {PiecesApiConfirmImportPieceTextPiecesPieceIdImportTextConfirmPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public confirmImportPieceTextPiecesPieceIdImportTextConfirmPost(requestParameters: PiecesApiConfirmImportPieceTextPiecesPieceIdImportTextConfirmPostRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).confirmImportPieceTextPiecesPieceIdImportTextConfirmPost(requestParameters.pieceId, requestParameters.importCorrectionsSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Partage
     * @param {PiecesApiCreatePartagePiecesPieceIdPartagesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public createPartagePiecesPieceIdPartagesPost(requestParameters: PiecesApiCreatePartagePiecesPieceIdPartagesPostRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).createPartagePiecesPieceIdPartagesPost(requestParameters.pieceId, requestParameters.partageFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Piece
     * @param {PiecesApiCreatePiecePiecesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public createPiecePiecesPost(requestParameters: PiecesApiCreatePiecePiecesPostRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).createPiecePiecesPost(requestParameters.pieceFormInformations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Affiche Piece
     * @param {PiecesApiDeleteAffichePiecePiecesPieceIdAfficheDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public deleteAffichePiecePiecesPieceIdAfficheDelete(requestParameters: PiecesApiDeleteAffichePiecePiecesPieceIdAfficheDeleteRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).deleteAffichePiecePiecesPieceIdAfficheDelete(requestParameters.pieceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Partage
     * @param {PiecesApiDeletePartagePiecesPieceIdPartagesPersonneIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public deletePartagePiecesPieceIdPartagesPersonneIdDelete(requestParameters: PiecesApiDeletePartagePiecesPieceIdPartagesPersonneIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).deletePartagePiecesPieceIdPartagesPersonneIdDelete(requestParameters.pieceId, requestParameters.personneId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Piece
     * @param {PiecesApiDeletePiecePiecesPieceIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public deletePiecePiecesPieceIdDelete(requestParameters: PiecesApiDeletePiecePiecesPieceIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).deletePiecePiecesPieceIdDelete(requestParameters.pieceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Duplicate Piece
     * @param {PiecesApiDuplicatePiecePiecesPieceIdDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public duplicatePiecePiecesPieceIdDuplicatePost(requestParameters: PiecesApiDuplicatePiecePiecesPieceIdDuplicatePostRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).duplicatePiecePiecesPieceIdDuplicatePost(requestParameters.pieceId, requestParameters.pieceFormAdaptation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Piece Pdf
     * @param {PiecesApiExportPiecePdfPiecesPieceIdExportPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public exportPiecePdfPiecesPieceIdExportPdfPost(requestParameters: PiecesApiExportPiecePdfPiecesPieceIdExportPdfPostRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).exportPiecePdfPiecesPieceIdExportPdfPost(requestParameters.pieceId, requestParameters.fontSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Piece
     * @param {PiecesApiGetPiecePiecesPieceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public getPiecePiecesPieceIdGet(requestParameters: PiecesApiGetPiecePiecesPieceIdGetRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).getPiecePiecesPieceIdGet(requestParameters.pieceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Statistiques
     * @param {PiecesApiGetStatistiquesPiecesPieceIdStatistiquesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public getStatistiquesPiecesPieceIdStatistiquesGet(requestParameters: PiecesApiGetStatistiquesPiecesPieceIdStatistiquesGetRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).getStatistiquesPiecesPieceIdStatistiquesGet(requestParameters.pieceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import Piece Text
     * @param {PiecesApiImportPieceTextPiecesPieceIdImportTextPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public importPieceTextPiecesPieceIdImportTextPost(requestParameters: PiecesApiImportPieceTextPiecesPieceIdImportTextPostRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).importPieceTextPiecesPieceIdImportTextPost(requestParameters.pieceId, requestParameters.file, requestParameters.strict, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * La pièce et ses autres adaptations, limitées à celles que l\'appelant voit.
     * @summary List Adaptations
     * @param {PiecesApiListAdaptationsPiecesPieceIdAdaptationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public listAdaptationsPiecesPieceIdAdaptationsGet(requestParameters: PiecesApiListAdaptationsPiecesPieceIdAdaptationsGetRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).listAdaptationsPiecesPieceIdAdaptationsGet(requestParameters.pieceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Partageables
     * @param {PiecesApiListPartageablesPiecesPieceIdPartageablesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public listPartageablesPiecesPieceIdPartageablesGet(requestParameters: PiecesApiListPartageablesPiecesPieceIdPartageablesGetRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).listPartageablesPiecesPieceIdPartageablesGet(requestParameters.pieceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Partages
     * @param {PiecesApiListPartagesPiecesPieceIdPartagesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public listPartagesPiecesPieceIdPartagesGet(requestParameters: PiecesApiListPartagesPiecesPieceIdPartagesGetRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).listPartagesPiecesPieceIdPartagesGet(requestParameters.pieceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Pieces Librairie
     * @param {PiecesApiListPiecesLibrairiePiecesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public listPiecesLibrairiePiecesGet(requestParameters: PiecesApiListPiecesLibrairiePiecesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).listPiecesLibrairiePiecesGet(requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Informations
     * @param {PiecesApiUpdateInformationsPiecesPieceIdInformationsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public updateInformationsPiecesPieceIdInformationsPatch(requestParameters: PiecesApiUpdateInformationsPiecesPieceIdInformationsPatchRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).updateInformationsPiecesPieceIdInformationsPatch(requestParameters.pieceId, requestParameters.pieceFormInformations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Partage
     * @param {PiecesApiUpdatePartagePiecesPieceIdPartagesPersonneIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public updatePartagePiecesPieceIdPartagesPersonneIdPatch(requestParameters: PiecesApiUpdatePartagePiecesPieceIdPartagesPersonneIdPatchRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).updatePartagePiecesPieceIdPartagesPersonneIdPatch(requestParameters.pieceId, requestParameters.personneId, requestParameters.partageFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Affiche Piece
     * @param {PiecesApiUploadAffichePiecePiecesPieceIdAffichePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PiecesApi
     */
    public uploadAffichePiecePiecesPieceIdAffichePost(requestParameters: PiecesApiUploadAffichePiecePiecesPieceIdAffichePostRequest, options?: RawAxiosRequestConfig) {
        return PiecesApiFp(this.configuration).uploadAffichePiecePiecesPieceIdAffichePost(requestParameters.pieceId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListPiecesLibrairiePiecesGetSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListPiecesLibrairiePiecesGetSortOrderEnum = typeof ListPiecesLibrairiePiecesGetSortOrderEnum[keyof typeof ListPiecesLibrairiePiecesGetSortOrderEnum];


/**
 * ProductionsApi - axios parameter creator
 * @export
 */
export const ProductionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Evenement
         * @param {string} productionId 
         * @param {EvenementFormCreate} evenementFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvenementProductionsProductionIdEvenementsPost: async (productionId: string, evenementFormCreate: EvenementFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('createEvenementProductionsProductionIdEvenementsPost', 'productionId', productionId)
            // verify required parameter 'evenementFormCreate' is not null or undefined
            assertParamExists('createEvenementProductionsProductionIdEvenementsPost', 'evenementFormCreate', evenementFormCreate)
            const localVarPath = `/productions/{production_id}/evenements`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(evenementFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Production
         * @param {ProductionFormCreate} productionFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionProductionsPost: async (productionFormCreate: ProductionFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionFormCreate' is not null or undefined
            assertParamExists('createProductionProductionsPost', 'productionFormCreate', productionFormCreate)
            const localVarPath = `/productions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productionFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Regle Recurrence
         * @param {string} productionId 
         * @param {RegleRecurrenceFormCreate} regleRecurrenceFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegleRecurrenceProductionsProductionIdReglesRecurrencePost: async (productionId: string, regleRecurrenceFormCreate: RegleRecurrenceFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('createRegleRecurrenceProductionsProductionIdReglesRecurrencePost', 'productionId', productionId)
            // verify required parameter 'regleRecurrenceFormCreate' is not null or undefined
            assertParamExists('createRegleRecurrenceProductionsProductionIdReglesRecurrencePost', 'regleRecurrenceFormCreate', regleRecurrenceFormCreate)
            const localVarPath = `/productions/{production_id}/regles-recurrence`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(regleRecurrenceFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Affiche Production
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAfficheProductionProductionsProductionIdAfficheDelete: async (productionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('deleteAfficheProductionProductionsProductionIdAfficheDelete', 'productionId', productionId)
            const localVarPath = `/productions/{production_id}/affiche`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Production
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductionProductionsProductionIdDelete: async (productionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('deleteProductionProductionsProductionIdDelete', 'productionId', productionId)
            const localVarPath = `/productions/{production_id}`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Regle Recurrence
         * @param {string} productionId 
         * @param {string} regleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDelete: async (productionId: string, regleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('deleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDelete', 'productionId', productionId)
            // verify required parameter 'regleId' is not null or undefined
            assertParamExists('deleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDelete', 'regleId', regleId)
            const localVarPath = `/productions/{production_id}/regles-recurrence/{regle_id}`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)))
                .replace(`{${"regle_id"}}`, encodeURIComponent(String(regleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * La conduite du membre courant (ses notes et repères, privés) : réservée aux membres, 404 sinon.
         * @summary Export Conduite Pdf
         * @param {string} productionId 
         * @param {number} [fontSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportConduitePdfProductionsProductionIdConduiteExportPdfPost: async (productionId: string, fontSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('exportConduitePdfProductionsProductionIdConduiteExportPdfPost', 'productionId', productionId)
            const localVarPath = `/productions/{production_id}/conduite/export-pdf`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fontSize !== undefined) {
                localVarQueryParameter['font_size'] = fontSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Production Pdf
         * @param {string} productionId 
         * @param {number} [fontSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProductionPdfProductionsProductionIdExportPdfPost: async (productionId: string, fontSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('exportProductionPdfProductionsProductionIdExportPdfPost', 'productionId', productionId)
            const localVarPath = `/productions/{production_id}/export-pdf`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fontSize !== undefined) {
                localVarQueryParameter['font_size'] = fontSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Production By Piece For Current Membre
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionByPieceForCurrentMembreProductionsPiecesPieceIdGet: async (pieceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('getProductionByPieceForCurrentMembreProductionsPiecesPieceIdGet', 'pieceId', pieceId)
            const localVarPath = `/productions/pieces/{piece_id}`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Production
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionProductionsProductionIdGet: async (productionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('getProductionProductionsProductionIdGet', 'productionId', productionId)
            const localVarPath = `/productions/{production_id}`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Regle Recurrence
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegleRecurrenceProductionsProductionIdReglesRecurrenceGet: async (productionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('getRegleRecurrenceProductionsProductionIdReglesRecurrenceGet', 'productionId', productionId)
            const localVarPath = `/productions/{production_id}/regles-recurrence`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invite Members To Production
         * @param {string} productionId 
         * @param {Invitations} invitations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteMembersToProductionProductionsProductionIdMembersInvitePost: async (productionId: string, invitations: Invitations, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('inviteMembersToProductionProductionsProductionIdMembersInvitePost', 'productionId', productionId)
            // verify required parameter 'invitations' is not null or undefined
            assertParamExists('inviteMembersToProductionProductionsProductionIdMembersInvitePost', 'invitations', invitations)
            const localVarPath = `/productions/{production_id}/members/invite`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invitations, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Adherents Invitables
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGet: async (productionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('listAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGet', 'productionId', productionId)
            const localVarPath = `/productions/{production_id}/adherents-invitables`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Evenements
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvenementsProductionsProductionIdEvenementsGet: async (productionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('listEvenementsProductionsProductionIdEvenementsGet', 'productionId', productionId)
            const localVarPath = `/productions/{production_id}/evenements`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Membres
         * @param {string} productionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListMembresProductionsProductionIdMembresGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembresProductionsProductionIdMembresGet: async (productionId: string, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListMembresProductionsProductionIdMembresGetSortOrderEnum, search?: string | null, searchFields?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('listMembresProductionsProductionIdMembresGet', 'productionId', productionId)
            const localVarPath = `/productions/{production_id}/membres`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['search_fields'] = searchFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Productions By User
         * @param {Array<StatutProduction>} [statut] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListProductionsByUserProductionsGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductionsByUserProductionsGet: async (statut?: Array<StatutProduction>, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListProductionsByUserProductionsGetSortOrderEnum, search?: string | null, searchFields?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/productions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (statut) {
                localVarQueryParameter['statut'] = statut;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['search_fields'] = searchFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Informations
         * @param {string} productionId 
         * @param {ProductionFormUpdateInformations} productionFormUpdateInformations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInformationsProductionsProductionIdInformationsPatch: async (productionId: string, productionFormUpdateInformations: ProductionFormUpdateInformations, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('updateInformationsProductionsProductionIdInformationsPatch', 'productionId', productionId)
            // verify required parameter 'productionFormUpdateInformations' is not null or undefined
            assertParamExists('updateInformationsProductionsProductionIdInformationsPatch', 'productionFormUpdateInformations', productionFormUpdateInformations)
            const localVarPath = `/productions/{production_id}/informations`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productionFormUpdateInformations, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Regle Recurrence
         * @param {string} productionId 
         * @param {string} regleId 
         * @param {RegleRecurrenceFormUpdate} regleRecurrenceFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch: async (productionId: string, regleId: string, regleRecurrenceFormUpdate: RegleRecurrenceFormUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('updateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch', 'productionId', productionId)
            // verify required parameter 'regleId' is not null or undefined
            assertParamExists('updateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch', 'regleId', regleId)
            // verify required parameter 'regleRecurrenceFormUpdate' is not null or undefined
            assertParamExists('updateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch', 'regleRecurrenceFormUpdate', regleRecurrenceFormUpdate)
            const localVarPath = `/productions/{production_id}/regles-recurrence/{regle_id}`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)))
                .replace(`{${"regle_id"}}`, encodeURIComponent(String(regleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(regleRecurrenceFormUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Affiche Production
         * @param {string} productionId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAfficheProductionProductionsProductionIdAffichePost: async (productionId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('uploadAfficheProductionProductionsProductionIdAffichePost', 'productionId', productionId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadAfficheProductionProductionsProductionIdAffichePost', 'file', file)
            const localVarPath = `/productions/{production_id}/affiche`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductionsApi - functional programming interface
 * @export
 */
export const ProductionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Evenement
         * @param {string} productionId 
         * @param {EvenementFormCreate} evenementFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEvenementProductionsProductionIdEvenementsPost(productionId: string, evenementFormCreate: EvenementFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessEvenementSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEvenementProductionsProductionIdEvenementsPost(productionId, evenementFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.createEvenementProductionsProductionIdEvenementsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Production
         * @param {ProductionFormCreate} productionFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductionProductionsPost(productionFormCreate: ProductionFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessProductionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductionProductionsPost(productionFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.createProductionProductionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Regle Recurrence
         * @param {string} productionId 
         * @param {RegleRecurrenceFormCreate} regleRecurrenceFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRegleRecurrenceProductionsProductionIdReglesRecurrencePost(productionId: string, regleRecurrenceFormCreate: RegleRecurrenceFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessRegleRecurrenceSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRegleRecurrenceProductionsProductionIdReglesRecurrencePost(productionId, regleRecurrenceFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.createRegleRecurrenceProductionsProductionIdReglesRecurrencePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Affiche Production
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAfficheProductionProductionsProductionIdAfficheDelete(productionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessProductionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAfficheProductionProductionsProductionIdAfficheDelete(productionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.deleteAfficheProductionProductionsProductionIdAfficheDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Production
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProductionProductionsProductionIdDelete(productionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessProductionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProductionProductionsProductionIdDelete(productionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.deleteProductionProductionsProductionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Regle Recurrence
         * @param {string} productionId 
         * @param {string} regleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDelete(productionId: string, regleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessRegleRecurrenceSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDelete(productionId, regleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.deleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * La conduite du membre courant (ses notes et repères, privés) : réservée aux membres, 404 sinon.
         * @summary Export Conduite Pdf
         * @param {string} productionId 
         * @param {number} [fontSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportConduitePdfProductionsProductionIdConduiteExportPdfPost(productionId: string, fontSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportConduitePdfProductionsProductionIdConduiteExportPdfPost(productionId, fontSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.exportConduitePdfProductionsProductionIdConduiteExportPdfPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Production Pdf
         * @param {string} productionId 
         * @param {number} [fontSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportProductionPdfProductionsProductionIdExportPdfPost(productionId: string, fontSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportProductionPdfProductionsProductionIdExportPdfPost(productionId, fontSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.exportProductionPdfProductionsProductionIdExportPdfPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Production By Piece For Current Membre
         * @param {string} pieceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionByPieceForCurrentMembreProductionsPiecesPieceIdGet(pieceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessProductionSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionByPieceForCurrentMembreProductionsPiecesPieceIdGet(pieceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.getProductionByPieceForCurrentMembreProductionsPiecesPieceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Production
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductionProductionsProductionIdGet(productionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessProductionSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductionProductionsProductionIdGet(productionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.getProductionProductionsProductionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Regle Recurrence
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegleRecurrenceProductionsProductionIdReglesRecurrenceGet(productionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessUnionRegleRecurrenceSchemaLiteNoneType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegleRecurrenceProductionsProductionIdReglesRecurrenceGet(productionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.getRegleRecurrenceProductionsProductionIdReglesRecurrenceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Invite Members To Production
         * @param {string} productionId 
         * @param {Invitations} invitations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteMembersToProductionProductionsProductionIdMembersInvitePost(productionId: string, invitations: Invitations, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListMembreSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteMembersToProductionProductionsProductionIdMembersInvitePost(productionId, invitations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.inviteMembersToProductionProductionsProductionIdMembersInvitePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Adherents Invitables
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGet(productionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListAdherentInvitableSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGet(productionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.listAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Evenements
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEvenementsProductionsProductionIdEvenementsGet(productionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListEvenementSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEvenementsProductionsProductionIdEvenementsGet(productionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.listEvenementsProductionsProductionIdEvenementsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Membres
         * @param {string} productionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListMembresProductionsProductionIdMembresGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMembresProductionsProductionIdMembresGet(productionId: string, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListMembresProductionsProductionIdMembresGetSortOrderEnum, search?: string | null, searchFields?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListMembreSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMembresProductionsProductionIdMembresGet(productionId, page, pageSize, sortBy, sortOrder, search, searchFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.listMembresProductionsProductionIdMembresGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Productions By User
         * @param {Array<StatutProduction>} [statut] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListProductionsByUserProductionsGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProductionsByUserProductionsGet(statut?: Array<StatutProduction>, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListProductionsByUserProductionsGetSortOrderEnum, search?: string | null, searchFields?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListProductionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProductionsByUserProductionsGet(statut, page, pageSize, sortBy, sortOrder, search, searchFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.listProductionsByUserProductionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Informations
         * @param {string} productionId 
         * @param {ProductionFormUpdateInformations} productionFormUpdateInformations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInformationsProductionsProductionIdInformationsPatch(productionId: string, productionFormUpdateInformations: ProductionFormUpdateInformations, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessProductionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInformationsProductionsProductionIdInformationsPatch(productionId, productionFormUpdateInformations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.updateInformationsProductionsProductionIdInformationsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Regle Recurrence
         * @param {string} productionId 
         * @param {string} regleId 
         * @param {RegleRecurrenceFormUpdate} regleRecurrenceFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch(productionId: string, regleId: string, regleRecurrenceFormUpdate: RegleRecurrenceFormUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessRegleRecurrenceSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch(productionId, regleId, regleRecurrenceFormUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.updateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Affiche Production
         * @param {string} productionId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAfficheProductionProductionsProductionIdAffichePost(productionId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessProductionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAfficheProductionProductionsProductionIdAffichePost(productionId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductionsApi.uploadAfficheProductionProductionsProductionIdAffichePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductionsApi - factory interface
 * @export
 */
export const ProductionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Evenement
         * @param {ProductionsApiCreateEvenementProductionsProductionIdEvenementsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvenementProductionsProductionIdEvenementsPost(requestParameters: ProductionsApiCreateEvenementProductionsProductionIdEvenementsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessEvenementSchemaLite> {
            return localVarFp.createEvenementProductionsProductionIdEvenementsPost(requestParameters.productionId, requestParameters.evenementFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Production
         * @param {ProductionsApiCreateProductionProductionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductionProductionsPost(requestParameters: ProductionsApiCreateProductionProductionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessProductionSchemaLite> {
            return localVarFp.createProductionProductionsPost(requestParameters.productionFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Regle Recurrence
         * @param {ProductionsApiCreateRegleRecurrenceProductionsProductionIdReglesRecurrencePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegleRecurrenceProductionsProductionIdReglesRecurrencePost(requestParameters: ProductionsApiCreateRegleRecurrenceProductionsProductionIdReglesRecurrencePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessRegleRecurrenceSchemaLite> {
            return localVarFp.createRegleRecurrenceProductionsProductionIdReglesRecurrencePost(requestParameters.productionId, requestParameters.regleRecurrenceFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Affiche Production
         * @param {ProductionsApiDeleteAfficheProductionProductionsProductionIdAfficheDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAfficheProductionProductionsProductionIdAfficheDelete(requestParameters: ProductionsApiDeleteAfficheProductionProductionsProductionIdAfficheDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessProductionSchemaLite> {
            return localVarFp.deleteAfficheProductionProductionsProductionIdAfficheDelete(requestParameters.productionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Production
         * @param {ProductionsApiDeleteProductionProductionsProductionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductionProductionsProductionIdDelete(requestParameters: ProductionsApiDeleteProductionProductionsProductionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessProductionSchemaLite> {
            return localVarFp.deleteProductionProductionsProductionIdDelete(requestParameters.productionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Regle Recurrence
         * @param {ProductionsApiDeleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDelete(requestParameters: ProductionsApiDeleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessRegleRecurrenceSchemaLite> {
            return localVarFp.deleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDelete(requestParameters.productionId, requestParameters.regleId, options).then((request) => request(axios, basePath));
        },
        /**
         * La conduite du membre courant (ses notes et repères, privés) : réservée aux membres, 404 sinon.
         * @summary Export Conduite Pdf
         * @param {ProductionsApiExportConduitePdfProductionsProductionIdConduiteExportPdfPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportConduitePdfProductionsProductionIdConduiteExportPdfPost(requestParameters: ProductionsApiExportConduitePdfProductionsProductionIdConduiteExportPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportConduitePdfProductionsProductionIdConduiteExportPdfPost(requestParameters.productionId, requestParameters.fontSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Production Pdf
         * @param {ProductionsApiExportProductionPdfProductionsProductionIdExportPdfPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProductionPdfProductionsProductionIdExportPdfPost(requestParameters: ProductionsApiExportProductionPdfProductionsProductionIdExportPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportProductionPdfProductionsProductionIdExportPdfPost(requestParameters.productionId, requestParameters.fontSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Production By Piece For Current Membre
         * @param {ProductionsApiGetProductionByPieceForCurrentMembreProductionsPiecesPieceIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionByPieceForCurrentMembreProductionsPiecesPieceIdGet(requestParameters: ProductionsApiGetProductionByPieceForCurrentMembreProductionsPiecesPieceIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessProductionSchema> {
            return localVarFp.getProductionByPieceForCurrentMembreProductionsPiecesPieceIdGet(requestParameters.pieceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Production
         * @param {ProductionsApiGetProductionProductionsProductionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductionProductionsProductionIdGet(requestParameters: ProductionsApiGetProductionProductionsProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessProductionSchema> {
            return localVarFp.getProductionProductionsProductionIdGet(requestParameters.productionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Regle Recurrence
         * @param {ProductionsApiGetRegleRecurrenceProductionsProductionIdReglesRecurrenceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegleRecurrenceProductionsProductionIdReglesRecurrenceGet(requestParameters: ProductionsApiGetRegleRecurrenceProductionsProductionIdReglesRecurrenceGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessUnionRegleRecurrenceSchemaLiteNoneType> {
            return localVarFp.getRegleRecurrenceProductionsProductionIdReglesRecurrenceGet(requestParameters.productionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invite Members To Production
         * @param {ProductionsApiInviteMembersToProductionProductionsProductionIdMembersInvitePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteMembersToProductionProductionsProductionIdMembersInvitePost(requestParameters: ProductionsApiInviteMembersToProductionProductionsProductionIdMembersInvitePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListMembreSchemaLite> {
            return localVarFp.inviteMembersToProductionProductionsProductionIdMembersInvitePost(requestParameters.productionId, requestParameters.invitations, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Adherents Invitables
         * @param {ProductionsApiListAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGet(requestParameters: ProductionsApiListAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListAdherentInvitableSchema> {
            return localVarFp.listAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGet(requestParameters.productionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Evenements
         * @param {ProductionsApiListEvenementsProductionsProductionIdEvenementsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvenementsProductionsProductionIdEvenementsGet(requestParameters: ProductionsApiListEvenementsProductionsProductionIdEvenementsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListEvenementSchemaLite> {
            return localVarFp.listEvenementsProductionsProductionIdEvenementsGet(requestParameters.productionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Membres
         * @param {ProductionsApiListMembresProductionsProductionIdMembresGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembresProductionsProductionIdMembresGet(requestParameters: ProductionsApiListMembresProductionsProductionIdMembresGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListMembreSchemaLite> {
            return localVarFp.listMembresProductionsProductionIdMembresGet(requestParameters.productionId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Productions By User
         * @param {ProductionsApiListProductionsByUserProductionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProductionsByUserProductionsGet(requestParameters: ProductionsApiListProductionsByUserProductionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListProductionSchemaLite> {
            return localVarFp.listProductionsByUserProductionsGet(requestParameters.statut, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Informations
         * @param {ProductionsApiUpdateInformationsProductionsProductionIdInformationsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInformationsProductionsProductionIdInformationsPatch(requestParameters: ProductionsApiUpdateInformationsProductionsProductionIdInformationsPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessProductionSchemaLite> {
            return localVarFp.updateInformationsProductionsProductionIdInformationsPatch(requestParameters.productionId, requestParameters.productionFormUpdateInformations, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Regle Recurrence
         * @param {ProductionsApiUpdateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch(requestParameters: ProductionsApiUpdateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessRegleRecurrenceSchemaLite> {
            return localVarFp.updateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch(requestParameters.productionId, requestParameters.regleId, requestParameters.regleRecurrenceFormUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Affiche Production
         * @param {ProductionsApiUploadAfficheProductionProductionsProductionIdAffichePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAfficheProductionProductionsProductionIdAffichePost(requestParameters: ProductionsApiUploadAfficheProductionProductionsProductionIdAffichePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessProductionSchemaLite> {
            return localVarFp.uploadAfficheProductionProductionsProductionIdAffichePost(requestParameters.productionId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductionsApi - interface
 * @export
 * @interface ProductionsApi
 */
export interface ProductionsApiInterface {
    /**
     * 
     * @summary Create Evenement
     * @param {ProductionsApiCreateEvenementProductionsProductionIdEvenementsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    createEvenementProductionsProductionIdEvenementsPost(requestParameters: ProductionsApiCreateEvenementProductionsProductionIdEvenementsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessEvenementSchemaLite>;

    /**
     * 
     * @summary Create Production
     * @param {ProductionsApiCreateProductionProductionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    createProductionProductionsPost(requestParameters: ProductionsApiCreateProductionProductionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessProductionSchemaLite>;

    /**
     * 
     * @summary Create Regle Recurrence
     * @param {ProductionsApiCreateRegleRecurrenceProductionsProductionIdReglesRecurrencePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    createRegleRecurrenceProductionsProductionIdReglesRecurrencePost(requestParameters: ProductionsApiCreateRegleRecurrenceProductionsProductionIdReglesRecurrencePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessRegleRecurrenceSchemaLite>;

    /**
     * 
     * @summary Delete Affiche Production
     * @param {ProductionsApiDeleteAfficheProductionProductionsProductionIdAfficheDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    deleteAfficheProductionProductionsProductionIdAfficheDelete(requestParameters: ProductionsApiDeleteAfficheProductionProductionsProductionIdAfficheDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessProductionSchemaLite>;

    /**
     * 
     * @summary Delete Production
     * @param {ProductionsApiDeleteProductionProductionsProductionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    deleteProductionProductionsProductionIdDelete(requestParameters: ProductionsApiDeleteProductionProductionsProductionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessProductionSchemaLite>;

    /**
     * 
     * @summary Delete Regle Recurrence
     * @param {ProductionsApiDeleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    deleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDelete(requestParameters: ProductionsApiDeleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessRegleRecurrenceSchemaLite>;

    /**
     * La conduite du membre courant (ses notes et repères, privés) : réservée aux membres, 404 sinon.
     * @summary Export Conduite Pdf
     * @param {ProductionsApiExportConduitePdfProductionsProductionIdConduiteExportPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    exportConduitePdfProductionsProductionIdConduiteExportPdfPost(requestParameters: ProductionsApiExportConduitePdfProductionsProductionIdConduiteExportPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @summary Export Production Pdf
     * @param {ProductionsApiExportProductionPdfProductionsProductionIdExportPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    exportProductionPdfProductionsProductionIdExportPdfPost(requestParameters: ProductionsApiExportProductionPdfProductionsProductionIdExportPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @summary Get Production By Piece For Current Membre
     * @param {ProductionsApiGetProductionByPieceForCurrentMembreProductionsPiecesPieceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    getProductionByPieceForCurrentMembreProductionsPiecesPieceIdGet(requestParameters: ProductionsApiGetProductionByPieceForCurrentMembreProductionsPiecesPieceIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessProductionSchema>;

    /**
     * 
     * @summary Get Production
     * @param {ProductionsApiGetProductionProductionsProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    getProductionProductionsProductionIdGet(requestParameters: ProductionsApiGetProductionProductionsProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessProductionSchema>;

    /**
     * 
     * @summary Get Regle Recurrence
     * @param {ProductionsApiGetRegleRecurrenceProductionsProductionIdReglesRecurrenceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    getRegleRecurrenceProductionsProductionIdReglesRecurrenceGet(requestParameters: ProductionsApiGetRegleRecurrenceProductionsProductionIdReglesRecurrenceGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessUnionRegleRecurrenceSchemaLiteNoneType>;

    /**
     * 
     * @summary Invite Members To Production
     * @param {ProductionsApiInviteMembersToProductionProductionsProductionIdMembersInvitePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    inviteMembersToProductionProductionsProductionIdMembersInvitePost(requestParameters: ProductionsApiInviteMembersToProductionProductionsProductionIdMembersInvitePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListMembreSchemaLite>;

    /**
     * 
     * @summary List Adherents Invitables
     * @param {ProductionsApiListAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    listAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGet(requestParameters: ProductionsApiListAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListAdherentInvitableSchema>;

    /**
     * 
     * @summary List Evenements
     * @param {ProductionsApiListEvenementsProductionsProductionIdEvenementsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    listEvenementsProductionsProductionIdEvenementsGet(requestParameters: ProductionsApiListEvenementsProductionsProductionIdEvenementsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListEvenementSchemaLite>;

    /**
     * 
     * @summary List Membres
     * @param {ProductionsApiListMembresProductionsProductionIdMembresGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    listMembresProductionsProductionIdMembresGet(requestParameters: ProductionsApiListMembresProductionsProductionIdMembresGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListMembreSchemaLite>;

    /**
     * 
     * @summary List Productions By User
     * @param {ProductionsApiListProductionsByUserProductionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    listProductionsByUserProductionsGet(requestParameters?: ProductionsApiListProductionsByUserProductionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListProductionSchemaLite>;

    /**
     * 
     * @summary Update Informations
     * @param {ProductionsApiUpdateInformationsProductionsProductionIdInformationsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    updateInformationsProductionsProductionIdInformationsPatch(requestParameters: ProductionsApiUpdateInformationsProductionsProductionIdInformationsPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessProductionSchemaLite>;

    /**
     * 
     * @summary Update Regle Recurrence
     * @param {ProductionsApiUpdateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    updateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch(requestParameters: ProductionsApiUpdateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessRegleRecurrenceSchemaLite>;

    /**
     * 
     * @summary Upload Affiche Production
     * @param {ProductionsApiUploadAfficheProductionProductionsProductionIdAffichePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApiInterface
     */
    uploadAfficheProductionProductionsProductionIdAffichePost(requestParameters: ProductionsApiUploadAfficheProductionProductionsProductionIdAffichePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessProductionSchemaLite>;

}

/**
 * Request parameters for createEvenementProductionsProductionIdEvenementsPost operation in ProductionsApi.
 * @export
 * @interface ProductionsApiCreateEvenementProductionsProductionIdEvenementsPostRequest
 */
export interface ProductionsApiCreateEvenementProductionsProductionIdEvenementsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiCreateEvenementProductionsProductionIdEvenementsPost
     */
    readonly productionId: string

    /**
     * 
     * @type {EvenementFormCreate}
     * @memberof ProductionsApiCreateEvenementProductionsProductionIdEvenementsPost
     */
    readonly evenementFormCreate: EvenementFormCreate
}

/**
 * Request parameters for createProductionProductionsPost operation in ProductionsApi.
 * @export
 * @interface ProductionsApiCreateProductionProductionsPostRequest
 */
export interface ProductionsApiCreateProductionProductionsPostRequest {
    /**
     * 
     * @type {ProductionFormCreate}
     * @memberof ProductionsApiCreateProductionProductionsPost
     */
    readonly productionFormCreate: ProductionFormCreate
}

/**
 * Request parameters for createRegleRecurrenceProductionsProductionIdReglesRecurrencePost operation in ProductionsApi.
 * @export
 * @interface ProductionsApiCreateRegleRecurrenceProductionsProductionIdReglesRecurrencePostRequest
 */
export interface ProductionsApiCreateRegleRecurrenceProductionsProductionIdReglesRecurrencePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiCreateRegleRecurrenceProductionsProductionIdReglesRecurrencePost
     */
    readonly productionId: string

    /**
     * 
     * @type {RegleRecurrenceFormCreate}
     * @memberof ProductionsApiCreateRegleRecurrenceProductionsProductionIdReglesRecurrencePost
     */
    readonly regleRecurrenceFormCreate: RegleRecurrenceFormCreate
}

/**
 * Request parameters for deleteAfficheProductionProductionsProductionIdAfficheDelete operation in ProductionsApi.
 * @export
 * @interface ProductionsApiDeleteAfficheProductionProductionsProductionIdAfficheDeleteRequest
 */
export interface ProductionsApiDeleteAfficheProductionProductionsProductionIdAfficheDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiDeleteAfficheProductionProductionsProductionIdAfficheDelete
     */
    readonly productionId: string
}

/**
 * Request parameters for deleteProductionProductionsProductionIdDelete operation in ProductionsApi.
 * @export
 * @interface ProductionsApiDeleteProductionProductionsProductionIdDeleteRequest
 */
export interface ProductionsApiDeleteProductionProductionsProductionIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiDeleteProductionProductionsProductionIdDelete
     */
    readonly productionId: string
}

/**
 * Request parameters for deleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDelete operation in ProductionsApi.
 * @export
 * @interface ProductionsApiDeleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDeleteRequest
 */
export interface ProductionsApiDeleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiDeleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDelete
     */
    readonly productionId: string

    /**
     * 
     * @type {string}
     * @memberof ProductionsApiDeleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDelete
     */
    readonly regleId: string
}

/**
 * Request parameters for exportConduitePdfProductionsProductionIdConduiteExportPdfPost operation in ProductionsApi.
 * @export
 * @interface ProductionsApiExportConduitePdfProductionsProductionIdConduiteExportPdfPostRequest
 */
export interface ProductionsApiExportConduitePdfProductionsProductionIdConduiteExportPdfPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiExportConduitePdfProductionsProductionIdConduiteExportPdfPost
     */
    readonly productionId: string

    /**
     * 
     * @type {number}
     * @memberof ProductionsApiExportConduitePdfProductionsProductionIdConduiteExportPdfPost
     */
    readonly fontSize?: number
}

/**
 * Request parameters for exportProductionPdfProductionsProductionIdExportPdfPost operation in ProductionsApi.
 * @export
 * @interface ProductionsApiExportProductionPdfProductionsProductionIdExportPdfPostRequest
 */
export interface ProductionsApiExportProductionPdfProductionsProductionIdExportPdfPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiExportProductionPdfProductionsProductionIdExportPdfPost
     */
    readonly productionId: string

    /**
     * 
     * @type {number}
     * @memberof ProductionsApiExportProductionPdfProductionsProductionIdExportPdfPost
     */
    readonly fontSize?: number
}

/**
 * Request parameters for getProductionByPieceForCurrentMembreProductionsPiecesPieceIdGet operation in ProductionsApi.
 * @export
 * @interface ProductionsApiGetProductionByPieceForCurrentMembreProductionsPiecesPieceIdGetRequest
 */
export interface ProductionsApiGetProductionByPieceForCurrentMembreProductionsPiecesPieceIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiGetProductionByPieceForCurrentMembreProductionsPiecesPieceIdGet
     */
    readonly pieceId: string
}

/**
 * Request parameters for getProductionProductionsProductionIdGet operation in ProductionsApi.
 * @export
 * @interface ProductionsApiGetProductionProductionsProductionIdGetRequest
 */
export interface ProductionsApiGetProductionProductionsProductionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiGetProductionProductionsProductionIdGet
     */
    readonly productionId: string
}

/**
 * Request parameters for getRegleRecurrenceProductionsProductionIdReglesRecurrenceGet operation in ProductionsApi.
 * @export
 * @interface ProductionsApiGetRegleRecurrenceProductionsProductionIdReglesRecurrenceGetRequest
 */
export interface ProductionsApiGetRegleRecurrenceProductionsProductionIdReglesRecurrenceGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiGetRegleRecurrenceProductionsProductionIdReglesRecurrenceGet
     */
    readonly productionId: string
}

/**
 * Request parameters for inviteMembersToProductionProductionsProductionIdMembersInvitePost operation in ProductionsApi.
 * @export
 * @interface ProductionsApiInviteMembersToProductionProductionsProductionIdMembersInvitePostRequest
 */
export interface ProductionsApiInviteMembersToProductionProductionsProductionIdMembersInvitePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiInviteMembersToProductionProductionsProductionIdMembersInvitePost
     */
    readonly productionId: string

    /**
     * 
     * @type {Invitations}
     * @memberof ProductionsApiInviteMembersToProductionProductionsProductionIdMembersInvitePost
     */
    readonly invitations: Invitations
}

/**
 * Request parameters for listAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGet operation in ProductionsApi.
 * @export
 * @interface ProductionsApiListAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGetRequest
 */
export interface ProductionsApiListAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiListAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGet
     */
    readonly productionId: string
}

/**
 * Request parameters for listEvenementsProductionsProductionIdEvenementsGet operation in ProductionsApi.
 * @export
 * @interface ProductionsApiListEvenementsProductionsProductionIdEvenementsGetRequest
 */
export interface ProductionsApiListEvenementsProductionsProductionIdEvenementsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiListEvenementsProductionsProductionIdEvenementsGet
     */
    readonly productionId: string
}

/**
 * Request parameters for listMembresProductionsProductionIdMembresGet operation in ProductionsApi.
 * @export
 * @interface ProductionsApiListMembresProductionsProductionIdMembresGetRequest
 */
export interface ProductionsApiListMembresProductionsProductionIdMembresGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiListMembresProductionsProductionIdMembresGet
     */
    readonly productionId: string

    /**
     * 
     * @type {number}
     * @memberof ProductionsApiListMembresProductionsProductionIdMembresGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ProductionsApiListMembresProductionsProductionIdMembresGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof ProductionsApiListMembresProductionsProductionIdMembresGet
     */
    readonly sortBy?: string | null

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof ProductionsApiListMembresProductionsProductionIdMembresGet
     */
    readonly sortOrder?: ListMembresProductionsProductionIdMembresGetSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof ProductionsApiListMembresProductionsProductionIdMembresGet
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof ProductionsApiListMembresProductionsProductionIdMembresGet
     */
    readonly searchFields?: string | null
}

/**
 * Request parameters for listProductionsByUserProductionsGet operation in ProductionsApi.
 * @export
 * @interface ProductionsApiListProductionsByUserProductionsGetRequest
 */
export interface ProductionsApiListProductionsByUserProductionsGetRequest {
    /**
     * 
     * @type {Array<StatutProduction>}
     * @memberof ProductionsApiListProductionsByUserProductionsGet
     */
    readonly statut?: Array<StatutProduction>

    /**
     * 
     * @type {number}
     * @memberof ProductionsApiListProductionsByUserProductionsGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ProductionsApiListProductionsByUserProductionsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof ProductionsApiListProductionsByUserProductionsGet
     */
    readonly sortBy?: string | null

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof ProductionsApiListProductionsByUserProductionsGet
     */
    readonly sortOrder?: ListProductionsByUserProductionsGetSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof ProductionsApiListProductionsByUserProductionsGet
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof ProductionsApiListProductionsByUserProductionsGet
     */
    readonly searchFields?: string | null
}

/**
 * Request parameters for updateInformationsProductionsProductionIdInformationsPatch operation in ProductionsApi.
 * @export
 * @interface ProductionsApiUpdateInformationsProductionsProductionIdInformationsPatchRequest
 */
export interface ProductionsApiUpdateInformationsProductionsProductionIdInformationsPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiUpdateInformationsProductionsProductionIdInformationsPatch
     */
    readonly productionId: string

    /**
     * 
     * @type {ProductionFormUpdateInformations}
     * @memberof ProductionsApiUpdateInformationsProductionsProductionIdInformationsPatch
     */
    readonly productionFormUpdateInformations: ProductionFormUpdateInformations
}

/**
 * Request parameters for updateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch operation in ProductionsApi.
 * @export
 * @interface ProductionsApiUpdateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatchRequest
 */
export interface ProductionsApiUpdateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiUpdateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch
     */
    readonly productionId: string

    /**
     * 
     * @type {string}
     * @memberof ProductionsApiUpdateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch
     */
    readonly regleId: string

    /**
     * 
     * @type {RegleRecurrenceFormUpdate}
     * @memberof ProductionsApiUpdateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch
     */
    readonly regleRecurrenceFormUpdate: RegleRecurrenceFormUpdate
}

/**
 * Request parameters for uploadAfficheProductionProductionsProductionIdAffichePost operation in ProductionsApi.
 * @export
 * @interface ProductionsApiUploadAfficheProductionProductionsProductionIdAffichePostRequest
 */
export interface ProductionsApiUploadAfficheProductionProductionsProductionIdAffichePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductionsApiUploadAfficheProductionProductionsProductionIdAffichePost
     */
    readonly productionId: string

    /**
     * 
     * @type {File}
     * @memberof ProductionsApiUploadAfficheProductionProductionsProductionIdAffichePost
     */
    readonly file: File
}

/**
 * ProductionsApi - object-oriented interface
 * @export
 * @class ProductionsApi
 * @extends {BaseAPI}
 */
export class ProductionsApi extends BaseAPI implements ProductionsApiInterface {
    /**
     * 
     * @summary Create Evenement
     * @param {ProductionsApiCreateEvenementProductionsProductionIdEvenementsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public createEvenementProductionsProductionIdEvenementsPost(requestParameters: ProductionsApiCreateEvenementProductionsProductionIdEvenementsPostRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).createEvenementProductionsProductionIdEvenementsPost(requestParameters.productionId, requestParameters.evenementFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Production
     * @param {ProductionsApiCreateProductionProductionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public createProductionProductionsPost(requestParameters: ProductionsApiCreateProductionProductionsPostRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).createProductionProductionsPost(requestParameters.productionFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Regle Recurrence
     * @param {ProductionsApiCreateRegleRecurrenceProductionsProductionIdReglesRecurrencePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public createRegleRecurrenceProductionsProductionIdReglesRecurrencePost(requestParameters: ProductionsApiCreateRegleRecurrenceProductionsProductionIdReglesRecurrencePostRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).createRegleRecurrenceProductionsProductionIdReglesRecurrencePost(requestParameters.productionId, requestParameters.regleRecurrenceFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Affiche Production
     * @param {ProductionsApiDeleteAfficheProductionProductionsProductionIdAfficheDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public deleteAfficheProductionProductionsProductionIdAfficheDelete(requestParameters: ProductionsApiDeleteAfficheProductionProductionsProductionIdAfficheDeleteRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).deleteAfficheProductionProductionsProductionIdAfficheDelete(requestParameters.productionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Production
     * @param {ProductionsApiDeleteProductionProductionsProductionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public deleteProductionProductionsProductionIdDelete(requestParameters: ProductionsApiDeleteProductionProductionsProductionIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).deleteProductionProductionsProductionIdDelete(requestParameters.productionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Regle Recurrence
     * @param {ProductionsApiDeleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public deleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDelete(requestParameters: ProductionsApiDeleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).deleteRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdDelete(requestParameters.productionId, requestParameters.regleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * La conduite du membre courant (ses notes et repères, privés) : réservée aux membres, 404 sinon.
     * @summary Export Conduite Pdf
     * @param {ProductionsApiExportConduitePdfProductionsProductionIdConduiteExportPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public exportConduitePdfProductionsProductionIdConduiteExportPdfPost(requestParameters: ProductionsApiExportConduitePdfProductionsProductionIdConduiteExportPdfPostRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).exportConduitePdfProductionsProductionIdConduiteExportPdfPost(requestParameters.productionId, requestParameters.fontSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Production Pdf
     * @param {ProductionsApiExportProductionPdfProductionsProductionIdExportPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public exportProductionPdfProductionsProductionIdExportPdfPost(requestParameters: ProductionsApiExportProductionPdfProductionsProductionIdExportPdfPostRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).exportProductionPdfProductionsProductionIdExportPdfPost(requestParameters.productionId, requestParameters.fontSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Production By Piece For Current Membre
     * @param {ProductionsApiGetProductionByPieceForCurrentMembreProductionsPiecesPieceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public getProductionByPieceForCurrentMembreProductionsPiecesPieceIdGet(requestParameters: ProductionsApiGetProductionByPieceForCurrentMembreProductionsPiecesPieceIdGetRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).getProductionByPieceForCurrentMembreProductionsPiecesPieceIdGet(requestParameters.pieceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Production
     * @param {ProductionsApiGetProductionProductionsProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public getProductionProductionsProductionIdGet(requestParameters: ProductionsApiGetProductionProductionsProductionIdGetRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).getProductionProductionsProductionIdGet(requestParameters.productionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Regle Recurrence
     * @param {ProductionsApiGetRegleRecurrenceProductionsProductionIdReglesRecurrenceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public getRegleRecurrenceProductionsProductionIdReglesRecurrenceGet(requestParameters: ProductionsApiGetRegleRecurrenceProductionsProductionIdReglesRecurrenceGetRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).getRegleRecurrenceProductionsProductionIdReglesRecurrenceGet(requestParameters.productionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invite Members To Production
     * @param {ProductionsApiInviteMembersToProductionProductionsProductionIdMembersInvitePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public inviteMembersToProductionProductionsProductionIdMembersInvitePost(requestParameters: ProductionsApiInviteMembersToProductionProductionsProductionIdMembersInvitePostRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).inviteMembersToProductionProductionsProductionIdMembersInvitePost(requestParameters.productionId, requestParameters.invitations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Adherents Invitables
     * @param {ProductionsApiListAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public listAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGet(requestParameters: ProductionsApiListAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGetRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).listAdherentsInvitablesProductionsProductionIdAdherentsInvitablesGet(requestParameters.productionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Evenements
     * @param {ProductionsApiListEvenementsProductionsProductionIdEvenementsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public listEvenementsProductionsProductionIdEvenementsGet(requestParameters: ProductionsApiListEvenementsProductionsProductionIdEvenementsGetRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).listEvenementsProductionsProductionIdEvenementsGet(requestParameters.productionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Membres
     * @param {ProductionsApiListMembresProductionsProductionIdMembresGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public listMembresProductionsProductionIdMembresGet(requestParameters: ProductionsApiListMembresProductionsProductionIdMembresGetRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).listMembresProductionsProductionIdMembresGet(requestParameters.productionId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Productions By User
     * @param {ProductionsApiListProductionsByUserProductionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public listProductionsByUserProductionsGet(requestParameters: ProductionsApiListProductionsByUserProductionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).listProductionsByUserProductionsGet(requestParameters.statut, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Informations
     * @param {ProductionsApiUpdateInformationsProductionsProductionIdInformationsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public updateInformationsProductionsProductionIdInformationsPatch(requestParameters: ProductionsApiUpdateInformationsProductionsProductionIdInformationsPatchRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).updateInformationsProductionsProductionIdInformationsPatch(requestParameters.productionId, requestParameters.productionFormUpdateInformations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Regle Recurrence
     * @param {ProductionsApiUpdateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public updateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch(requestParameters: ProductionsApiUpdateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatchRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).updateRegleRecurrenceProductionsProductionIdReglesRecurrenceRegleIdPatch(requestParameters.productionId, requestParameters.regleId, requestParameters.regleRecurrenceFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Affiche Production
     * @param {ProductionsApiUploadAfficheProductionProductionsProductionIdAffichePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionsApi
     */
    public uploadAfficheProductionProductionsProductionIdAffichePost(requestParameters: ProductionsApiUploadAfficheProductionProductionsProductionIdAffichePostRequest, options?: RawAxiosRequestConfig) {
        return ProductionsApiFp(this.configuration).uploadAfficheProductionProductionsProductionIdAffichePost(requestParameters.productionId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListMembresProductionsProductionIdMembresGetSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListMembresProductionsProductionIdMembresGetSortOrderEnum = typeof ListMembresProductionsProductionIdMembresGetSortOrderEnum[keyof typeof ListMembresProductionsProductionIdMembresGetSortOrderEnum];
/**
 * @export
 */
export const ListProductionsByUserProductionsGetSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListProductionsByUserProductionsGetSortOrderEnum = typeof ListProductionsByUserProductionsGetSortOrderEnum[keyof typeof ListProductionsByUserProductionsGetSortOrderEnum];


/**
 * ReperesApi - axios parameter creator
 * @export
 */
export const ReperesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Les repères du membre courant, privés comme ses commentaires.
         * @summary List Reperes For Production
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReperesForProductionReperesProductionProductionIdGet: async (productionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('listReperesForProductionReperesProductionProductionIdGet', 'productionId', productionId)
            const localVarPath = `/reperes/production/{production_id}`
                .replace(`{${"production_id"}}`, encodeURIComponent(String(productionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remplace l\'entrée et la sortie du membre courant sur l\'action ; renvoie ses repères restants sur elle.
         * @summary Replace Reperes Of Action
         * @param {string} actionId 
         * @param {string} productionId 
         * @param {RepereFormUpdate} repereFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceReperesOfActionReperesActionActionIdPut: async (actionId: string, productionId: string, repereFormUpdate: RepereFormUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('replaceReperesOfActionReperesActionActionIdPut', 'actionId', actionId)
            // verify required parameter 'productionId' is not null or undefined
            assertParamExists('replaceReperesOfActionReperesActionActionIdPut', 'productionId', productionId)
            // verify required parameter 'repereFormUpdate' is not null or undefined
            assertParamExists('replaceReperesOfActionReperesActionActionIdPut', 'repereFormUpdate', repereFormUpdate)
            const localVarPath = `/reperes/action/{action_id}`
                .replace(`{${"action_id"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productionId !== undefined) {
                localVarQueryParameter['production_id'] = productionId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repereFormUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReperesApi - functional programming interface
 * @export
 */
export const ReperesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReperesApiAxiosParamCreator(configuration)
    return {
        /**
         * Les repères du membre courant, privés comme ses commentaires.
         * @summary List Reperes For Production
         * @param {string} productionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReperesForProductionReperesProductionProductionIdGet(productionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListRepereSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReperesForProductionReperesProductionProductionIdGet(productionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReperesApi.listReperesForProductionReperesProductionProductionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remplace l\'entrée et la sortie du membre courant sur l\'action ; renvoie ses repères restants sur elle.
         * @summary Replace Reperes Of Action
         * @param {string} actionId 
         * @param {string} productionId 
         * @param {RepereFormUpdate} repereFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceReperesOfActionReperesActionActionIdPut(actionId: string, productionId: string, repereFormUpdate: RepereFormUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListRepereSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceReperesOfActionReperesActionActionIdPut(actionId, productionId, repereFormUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReperesApi.replaceReperesOfActionReperesActionActionIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReperesApi - factory interface
 * @export
 */
export const ReperesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReperesApiFp(configuration)
    return {
        /**
         * Les repères du membre courant, privés comme ses commentaires.
         * @summary List Reperes For Production
         * @param {ReperesApiListReperesForProductionReperesProductionProductionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReperesForProductionReperesProductionProductionIdGet(requestParameters: ReperesApiListReperesForProductionReperesProductionProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListRepereSchemaLite> {
            return localVarFp.listReperesForProductionReperesProductionProductionIdGet(requestParameters.productionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remplace l\'entrée et la sortie du membre courant sur l\'action ; renvoie ses repères restants sur elle.
         * @summary Replace Reperes Of Action
         * @param {ReperesApiReplaceReperesOfActionReperesActionActionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceReperesOfActionReperesActionActionIdPut(requestParameters: ReperesApiReplaceReperesOfActionReperesActionActionIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListRepereSchemaLite> {
            return localVarFp.replaceReperesOfActionReperesActionActionIdPut(requestParameters.actionId, requestParameters.productionId, requestParameters.repereFormUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReperesApi - interface
 * @export
 * @interface ReperesApi
 */
export interface ReperesApiInterface {
    /**
     * Les repères du membre courant, privés comme ses commentaires.
     * @summary List Reperes For Production
     * @param {ReperesApiListReperesForProductionReperesProductionProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReperesApiInterface
     */
    listReperesForProductionReperesProductionProductionIdGet(requestParameters: ReperesApiListReperesForProductionReperesProductionProductionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListRepereSchemaLite>;

    /**
     * Remplace l\'entrée et la sortie du membre courant sur l\'action ; renvoie ses repères restants sur elle.
     * @summary Replace Reperes Of Action
     * @param {ReperesApiReplaceReperesOfActionReperesActionActionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReperesApiInterface
     */
    replaceReperesOfActionReperesActionActionIdPut(requestParameters: ReperesApiReplaceReperesOfActionReperesActionActionIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListRepereSchemaLite>;

}

/**
 * Request parameters for listReperesForProductionReperesProductionProductionIdGet operation in ReperesApi.
 * @export
 * @interface ReperesApiListReperesForProductionReperesProductionProductionIdGetRequest
 */
export interface ReperesApiListReperesForProductionReperesProductionProductionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReperesApiListReperesForProductionReperesProductionProductionIdGet
     */
    readonly productionId: string
}

/**
 * Request parameters for replaceReperesOfActionReperesActionActionIdPut operation in ReperesApi.
 * @export
 * @interface ReperesApiReplaceReperesOfActionReperesActionActionIdPutRequest
 */
export interface ReperesApiReplaceReperesOfActionReperesActionActionIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ReperesApiReplaceReperesOfActionReperesActionActionIdPut
     */
    readonly actionId: string

    /**
     * 
     * @type {string}
     * @memberof ReperesApiReplaceReperesOfActionReperesActionActionIdPut
     */
    readonly productionId: string

    /**
     * 
     * @type {RepereFormUpdate}
     * @memberof ReperesApiReplaceReperesOfActionReperesActionActionIdPut
     */
    readonly repereFormUpdate: RepereFormUpdate
}

/**
 * ReperesApi - object-oriented interface
 * @export
 * @class ReperesApi
 * @extends {BaseAPI}
 */
export class ReperesApi extends BaseAPI implements ReperesApiInterface {
    /**
     * Les repères du membre courant, privés comme ses commentaires.
     * @summary List Reperes For Production
     * @param {ReperesApiListReperesForProductionReperesProductionProductionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReperesApi
     */
    public listReperesForProductionReperesProductionProductionIdGet(requestParameters: ReperesApiListReperesForProductionReperesProductionProductionIdGetRequest, options?: RawAxiosRequestConfig) {
        return ReperesApiFp(this.configuration).listReperesForProductionReperesProductionProductionIdGet(requestParameters.productionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remplace l\'entrée et la sortie du membre courant sur l\'action ; renvoie ses repères restants sur elle.
     * @summary Replace Reperes Of Action
     * @param {ReperesApiReplaceReperesOfActionReperesActionActionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReperesApi
     */
    public replaceReperesOfActionReperesActionActionIdPut(requestParameters: ReperesApiReplaceReperesOfActionReperesActionActionIdPutRequest, options?: RawAxiosRequestConfig) {
        return ReperesApiFp(this.configuration).replaceReperesOfActionReperesActionActionIdPut(requestParameters.actionId, requestParameters.productionId, requestParameters.repereFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Role
         * @param {RoleFormCreate} roleFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoleRolesPost: async (roleFormCreate: RoleFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleFormCreate' is not null or undefined
            assertParamExists('createRoleRolesPost', 'roleFormCreate', roleFormCreate)
            const localVarPath = `/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roleFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Role
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoleRolesRoleIdDelete: async (roleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('deleteRoleRolesRoleIdDelete', 'roleId', roleId)
            const localVarPath = `/roles/{role_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Roles By Piece
         * @param {string} pieceId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListRolesByPieceRolesPiecePieceIdGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRolesByPieceRolesPiecePieceIdGet: async (pieceId: string, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListRolesByPieceRolesPiecePieceIdGetSortOrderEnum, search?: string | null, searchFields?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('listRolesByPieceRolesPiecePieceIdGet', 'pieceId', pieceId)
            const localVarPath = `/roles/piece/{piece_id}`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['search_fields'] = searchFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Role
         * @param {string} roleId 
         * @param {RoleFormUpdate} roleFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleRolesRoleIdPatch: async (roleId: string, roleFormUpdate: RoleFormUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('updateRoleRolesRoleIdPatch', 'roleId', roleId)
            // verify required parameter 'roleFormUpdate' is not null or undefined
            assertParamExists('updateRoleRolesRoleIdPatch', 'roleFormUpdate', roleFormUpdate)
            const localVarPath = `/roles/{role_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roleFormUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Role
         * @param {RoleFormCreate} roleFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoleRolesPost(roleFormCreate: RoleFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessRoleSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoleRolesPost(roleFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.createRoleRolesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Role
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRoleRolesRoleIdDelete(roleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessRoleSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoleRolesRoleIdDelete(roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.deleteRoleRolesRoleIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Roles By Piece
         * @param {string} pieceId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListRolesByPieceRolesPiecePieceIdGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRolesByPieceRolesPiecePieceIdGet(pieceId: string, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListRolesByPieceRolesPiecePieceIdGetSortOrderEnum, search?: string | null, searchFields?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListRoleSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRolesByPieceRolesPiecePieceIdGet(pieceId, page, pageSize, sortBy, sortOrder, search, searchFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.listRolesByPieceRolesPiecePieceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Role
         * @param {string} roleId 
         * @param {RoleFormUpdate} roleFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoleRolesRoleIdPatch(roleId: string, roleFormUpdate: RoleFormUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessRoleSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoleRolesRoleIdPatch(roleId, roleFormUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.updateRoleRolesRoleIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Role
         * @param {RolesApiCreateRoleRolesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoleRolesPost(requestParameters: RolesApiCreateRoleRolesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessRoleSchemaLite> {
            return localVarFp.createRoleRolesPost(requestParameters.roleFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Role
         * @param {RolesApiDeleteRoleRolesRoleIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoleRolesRoleIdDelete(requestParameters: RolesApiDeleteRoleRolesRoleIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessRoleSchemaLite> {
            return localVarFp.deleteRoleRolesRoleIdDelete(requestParameters.roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Roles By Piece
         * @param {RolesApiListRolesByPieceRolesPiecePieceIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRolesByPieceRolesPiecePieceIdGet(requestParameters: RolesApiListRolesByPieceRolesPiecePieceIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListRoleSchemaLite> {
            return localVarFp.listRolesByPieceRolesPiecePieceIdGet(requestParameters.pieceId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Role
         * @param {RolesApiUpdateRoleRolesRoleIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleRolesRoleIdPatch(requestParameters: RolesApiUpdateRoleRolesRoleIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessRoleSchemaLite> {
            return localVarFp.updateRoleRolesRoleIdPatch(requestParameters.roleId, requestParameters.roleFormUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolesApi - interface
 * @export
 * @interface RolesApi
 */
export interface RolesApiInterface {
    /**
     * 
     * @summary Create Role
     * @param {RolesApiCreateRoleRolesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApiInterface
     */
    createRoleRolesPost(requestParameters: RolesApiCreateRoleRolesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessRoleSchemaLite>;

    /**
     * 
     * @summary Delete Role
     * @param {RolesApiDeleteRoleRolesRoleIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApiInterface
     */
    deleteRoleRolesRoleIdDelete(requestParameters: RolesApiDeleteRoleRolesRoleIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessRoleSchemaLite>;

    /**
     * 
     * @summary List Roles By Piece
     * @param {RolesApiListRolesByPieceRolesPiecePieceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApiInterface
     */
    listRolesByPieceRolesPiecePieceIdGet(requestParameters: RolesApiListRolesByPieceRolesPiecePieceIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListRoleSchemaLite>;

    /**
     * 
     * @summary Update Role
     * @param {RolesApiUpdateRoleRolesRoleIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApiInterface
     */
    updateRoleRolesRoleIdPatch(requestParameters: RolesApiUpdateRoleRolesRoleIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessRoleSchemaLite>;

}

/**
 * Request parameters for createRoleRolesPost operation in RolesApi.
 * @export
 * @interface RolesApiCreateRoleRolesPostRequest
 */
export interface RolesApiCreateRoleRolesPostRequest {
    /**
     * 
     * @type {RoleFormCreate}
     * @memberof RolesApiCreateRoleRolesPost
     */
    readonly roleFormCreate: RoleFormCreate
}

/**
 * Request parameters for deleteRoleRolesRoleIdDelete operation in RolesApi.
 * @export
 * @interface RolesApiDeleteRoleRolesRoleIdDeleteRequest
 */
export interface RolesApiDeleteRoleRolesRoleIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof RolesApiDeleteRoleRolesRoleIdDelete
     */
    readonly roleId: string
}

/**
 * Request parameters for listRolesByPieceRolesPiecePieceIdGet operation in RolesApi.
 * @export
 * @interface RolesApiListRolesByPieceRolesPiecePieceIdGetRequest
 */
export interface RolesApiListRolesByPieceRolesPiecePieceIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RolesApiListRolesByPieceRolesPiecePieceIdGet
     */
    readonly pieceId: string

    /**
     * 
     * @type {number}
     * @memberof RolesApiListRolesByPieceRolesPiecePieceIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof RolesApiListRolesByPieceRolesPiecePieceIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof RolesApiListRolesByPieceRolesPiecePieceIdGet
     */
    readonly sortBy?: string | null

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof RolesApiListRolesByPieceRolesPiecePieceIdGet
     */
    readonly sortOrder?: ListRolesByPieceRolesPiecePieceIdGetSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof RolesApiListRolesByPieceRolesPiecePieceIdGet
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof RolesApiListRolesByPieceRolesPiecePieceIdGet
     */
    readonly searchFields?: string | null
}

/**
 * Request parameters for updateRoleRolesRoleIdPatch operation in RolesApi.
 * @export
 * @interface RolesApiUpdateRoleRolesRoleIdPatchRequest
 */
export interface RolesApiUpdateRoleRolesRoleIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof RolesApiUpdateRoleRolesRoleIdPatch
     */
    readonly roleId: string

    /**
     * 
     * @type {RoleFormUpdate}
     * @memberof RolesApiUpdateRoleRolesRoleIdPatch
     */
    readonly roleFormUpdate: RoleFormUpdate
}

/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI implements RolesApiInterface {
    /**
     * 
     * @summary Create Role
     * @param {RolesApiCreateRoleRolesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public createRoleRolesPost(requestParameters: RolesApiCreateRoleRolesPostRequest, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).createRoleRolesPost(requestParameters.roleFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Role
     * @param {RolesApiDeleteRoleRolesRoleIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public deleteRoleRolesRoleIdDelete(requestParameters: RolesApiDeleteRoleRolesRoleIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).deleteRoleRolesRoleIdDelete(requestParameters.roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Roles By Piece
     * @param {RolesApiListRolesByPieceRolesPiecePieceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public listRolesByPieceRolesPiecePieceIdGet(requestParameters: RolesApiListRolesByPieceRolesPiecePieceIdGetRequest, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).listRolesByPieceRolesPiecePieceIdGet(requestParameters.pieceId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Role
     * @param {RolesApiUpdateRoleRolesRoleIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public updateRoleRolesRoleIdPatch(requestParameters: RolesApiUpdateRoleRolesRoleIdPatchRequest, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).updateRoleRolesRoleIdPatch(requestParameters.roleId, requestParameters.roleFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListRolesByPieceRolesPiecePieceIdGetSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListRolesByPieceRolesPiecePieceIdGetSortOrderEnum = typeof ListRolesByPieceRolesPiecePieceIdGetSortOrderEnum[keyof typeof ListRolesByPieceRolesPiecePieceIdGetSortOrderEnum];


/**
 * ScenesApi - axios parameter creator
 * @export
 */
export const ScenesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Scene
         * @param {SceneFormCreate} sceneFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSceneScenesPost: async (sceneFormCreate: SceneFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sceneFormCreate' is not null or undefined
            assertParamExists('createSceneScenesPost', 'sceneFormCreate', sceneFormCreate)
            const localVarPath = `/scenes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sceneFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Scene
         * @param {string} sceneId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSceneScenesSceneIdDelete: async (sceneId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sceneId' is not null or undefined
            assertParamExists('deleteSceneScenesSceneIdDelete', 'sceneId', sceneId)
            const localVarPath = `/scenes/{scene_id}`
                .replace(`{${"scene_id"}}`, encodeURIComponent(String(sceneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Scenes By Piece
         * @param {string} pieceId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListScenesByPieceScenesPiecePieceIdGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScenesByPieceScenesPiecePieceIdGet: async (pieceId: string, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListScenesByPieceScenesPiecePieceIdGetSortOrderEnum, search?: string | null, searchFields?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pieceId' is not null or undefined
            assertParamExists('listScenesByPieceScenesPiecePieceIdGet', 'pieceId', pieceId)
            const localVarPath = `/scenes/piece/{piece_id}`
                .replace(`{${"piece_id"}}`, encodeURIComponent(String(pieceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['search_fields'] = searchFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reordonner Actions
         * @param {string} sceneId 
         * @param {SceneOrdreForm} sceneOrdreForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reordonnerActionsScenesSceneIdOrdrePut: async (sceneId: string, sceneOrdreForm: SceneOrdreForm, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sceneId' is not null or undefined
            assertParamExists('reordonnerActionsScenesSceneIdOrdrePut', 'sceneId', sceneId)
            // verify required parameter 'sceneOrdreForm' is not null or undefined
            assertParamExists('reordonnerActionsScenesSceneIdOrdrePut', 'sceneOrdreForm', sceneOrdreForm)
            const localVarPath = `/scenes/{scene_id}/ordre`
                .replace(`{${"scene_id"}}`, encodeURIComponent(String(sceneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sceneOrdreForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Scene
         * @param {string} sceneId 
         * @param {SceneFormUpdate} sceneFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSceneScenesSceneIdPatch: async (sceneId: string, sceneFormUpdate: SceneFormUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sceneId' is not null or undefined
            assertParamExists('updateSceneScenesSceneIdPatch', 'sceneId', sceneId)
            // verify required parameter 'sceneFormUpdate' is not null or undefined
            assertParamExists('updateSceneScenesSceneIdPatch', 'sceneFormUpdate', sceneFormUpdate)
            const localVarPath = `/scenes/{scene_id}`
                .replace(`{${"scene_id"}}`, encodeURIComponent(String(sceneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sceneFormUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScenesApi - functional programming interface
 * @export
 */
export const ScenesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScenesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Scene
         * @param {SceneFormCreate} sceneFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSceneScenesPost(sceneFormCreate: SceneFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessSceneSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSceneScenesPost(sceneFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScenesApi.createSceneScenesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Scene
         * @param {string} sceneId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSceneScenesSceneIdDelete(sceneId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessSceneSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSceneScenesSceneIdDelete(sceneId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScenesApi.deleteSceneScenesSceneIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Scenes By Piece
         * @param {string} pieceId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListScenesByPieceScenesPiecePieceIdGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listScenesByPieceScenesPiecePieceIdGet(pieceId: string, page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListScenesByPieceScenesPiecePieceIdGetSortOrderEnum, search?: string | null, searchFields?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListSceneSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listScenesByPieceScenesPiecePieceIdGet(pieceId, page, pageSize, sortBy, sortOrder, search, searchFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScenesApi.listScenesByPieceScenesPiecePieceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reordonner Actions
         * @param {string} sceneId 
         * @param {SceneOrdreForm} sceneOrdreForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reordonnerActionsScenesSceneIdOrdrePut(sceneId: string, sceneOrdreForm: SceneOrdreForm, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListActionSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reordonnerActionsScenesSceneIdOrdrePut(sceneId, sceneOrdreForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScenesApi.reordonnerActionsScenesSceneIdOrdrePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Scene
         * @param {string} sceneId 
         * @param {SceneFormUpdate} sceneFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSceneScenesSceneIdPatch(sceneId: string, sceneFormUpdate: SceneFormUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessSceneSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSceneScenesSceneIdPatch(sceneId, sceneFormUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScenesApi.updateSceneScenesSceneIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScenesApi - factory interface
 * @export
 */
export const ScenesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScenesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Scene
         * @param {ScenesApiCreateSceneScenesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSceneScenesPost(requestParameters: ScenesApiCreateSceneScenesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessSceneSchemaLite> {
            return localVarFp.createSceneScenesPost(requestParameters.sceneFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Scene
         * @param {ScenesApiDeleteSceneScenesSceneIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSceneScenesSceneIdDelete(requestParameters: ScenesApiDeleteSceneScenesSceneIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessSceneSchemaLite> {
            return localVarFp.deleteSceneScenesSceneIdDelete(requestParameters.sceneId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Scenes By Piece
         * @param {ScenesApiListScenesByPieceScenesPiecePieceIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScenesByPieceScenesPiecePieceIdGet(requestParameters: ScenesApiListScenesByPieceScenesPiecePieceIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListSceneSchemaLite> {
            return localVarFp.listScenesByPieceScenesPiecePieceIdGet(requestParameters.pieceId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reordonner Actions
         * @param {ScenesApiReordonnerActionsScenesSceneIdOrdrePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reordonnerActionsScenesSceneIdOrdrePut(requestParameters: ScenesApiReordonnerActionsScenesSceneIdOrdrePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListActionSchemaLite> {
            return localVarFp.reordonnerActionsScenesSceneIdOrdrePut(requestParameters.sceneId, requestParameters.sceneOrdreForm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Scene
         * @param {ScenesApiUpdateSceneScenesSceneIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSceneScenesSceneIdPatch(requestParameters: ScenesApiUpdateSceneScenesSceneIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessSceneSchemaLite> {
            return localVarFp.updateSceneScenesSceneIdPatch(requestParameters.sceneId, requestParameters.sceneFormUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScenesApi - interface
 * @export
 * @interface ScenesApi
 */
export interface ScenesApiInterface {
    /**
     * 
     * @summary Create Scene
     * @param {ScenesApiCreateSceneScenesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenesApiInterface
     */
    createSceneScenesPost(requestParameters: ScenesApiCreateSceneScenesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessSceneSchemaLite>;

    /**
     * 
     * @summary Delete Scene
     * @param {ScenesApiDeleteSceneScenesSceneIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenesApiInterface
     */
    deleteSceneScenesSceneIdDelete(requestParameters: ScenesApiDeleteSceneScenesSceneIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessSceneSchemaLite>;

    /**
     * 
     * @summary List Scenes By Piece
     * @param {ScenesApiListScenesByPieceScenesPiecePieceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenesApiInterface
     */
    listScenesByPieceScenesPiecePieceIdGet(requestParameters: ScenesApiListScenesByPieceScenesPiecePieceIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListSceneSchemaLite>;

    /**
     * 
     * @summary Reordonner Actions
     * @param {ScenesApiReordonnerActionsScenesSceneIdOrdrePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenesApiInterface
     */
    reordonnerActionsScenesSceneIdOrdrePut(requestParameters: ScenesApiReordonnerActionsScenesSceneIdOrdrePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListActionSchemaLite>;

    /**
     * 
     * @summary Update Scene
     * @param {ScenesApiUpdateSceneScenesSceneIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenesApiInterface
     */
    updateSceneScenesSceneIdPatch(requestParameters: ScenesApiUpdateSceneScenesSceneIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessSceneSchemaLite>;

}

/**
 * Request parameters for createSceneScenesPost operation in ScenesApi.
 * @export
 * @interface ScenesApiCreateSceneScenesPostRequest
 */
export interface ScenesApiCreateSceneScenesPostRequest {
    /**
     * 
     * @type {SceneFormCreate}
     * @memberof ScenesApiCreateSceneScenesPost
     */
    readonly sceneFormCreate: SceneFormCreate
}

/**
 * Request parameters for deleteSceneScenesSceneIdDelete operation in ScenesApi.
 * @export
 * @interface ScenesApiDeleteSceneScenesSceneIdDeleteRequest
 */
export interface ScenesApiDeleteSceneScenesSceneIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ScenesApiDeleteSceneScenesSceneIdDelete
     */
    readonly sceneId: string
}

/**
 * Request parameters for listScenesByPieceScenesPiecePieceIdGet operation in ScenesApi.
 * @export
 * @interface ScenesApiListScenesByPieceScenesPiecePieceIdGetRequest
 */
export interface ScenesApiListScenesByPieceScenesPiecePieceIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ScenesApiListScenesByPieceScenesPiecePieceIdGet
     */
    readonly pieceId: string

    /**
     * 
     * @type {number}
     * @memberof ScenesApiListScenesByPieceScenesPiecePieceIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ScenesApiListScenesByPieceScenesPiecePieceIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof ScenesApiListScenesByPieceScenesPiecePieceIdGet
     */
    readonly sortBy?: string | null

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof ScenesApiListScenesByPieceScenesPiecePieceIdGet
     */
    readonly sortOrder?: ListScenesByPieceScenesPiecePieceIdGetSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof ScenesApiListScenesByPieceScenesPiecePieceIdGet
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof ScenesApiListScenesByPieceScenesPiecePieceIdGet
     */
    readonly searchFields?: string | null
}

/**
 * Request parameters for reordonnerActionsScenesSceneIdOrdrePut operation in ScenesApi.
 * @export
 * @interface ScenesApiReordonnerActionsScenesSceneIdOrdrePutRequest
 */
export interface ScenesApiReordonnerActionsScenesSceneIdOrdrePutRequest {
    /**
     * 
     * @type {string}
     * @memberof ScenesApiReordonnerActionsScenesSceneIdOrdrePut
     */
    readonly sceneId: string

    /**
     * 
     * @type {SceneOrdreForm}
     * @memberof ScenesApiReordonnerActionsScenesSceneIdOrdrePut
     */
    readonly sceneOrdreForm: SceneOrdreForm
}

/**
 * Request parameters for updateSceneScenesSceneIdPatch operation in ScenesApi.
 * @export
 * @interface ScenesApiUpdateSceneScenesSceneIdPatchRequest
 */
export interface ScenesApiUpdateSceneScenesSceneIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof ScenesApiUpdateSceneScenesSceneIdPatch
     */
    readonly sceneId: string

    /**
     * 
     * @type {SceneFormUpdate}
     * @memberof ScenesApiUpdateSceneScenesSceneIdPatch
     */
    readonly sceneFormUpdate: SceneFormUpdate
}

/**
 * ScenesApi - object-oriented interface
 * @export
 * @class ScenesApi
 * @extends {BaseAPI}
 */
export class ScenesApi extends BaseAPI implements ScenesApiInterface {
    /**
     * 
     * @summary Create Scene
     * @param {ScenesApiCreateSceneScenesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenesApi
     */
    public createSceneScenesPost(requestParameters: ScenesApiCreateSceneScenesPostRequest, options?: RawAxiosRequestConfig) {
        return ScenesApiFp(this.configuration).createSceneScenesPost(requestParameters.sceneFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Scene
     * @param {ScenesApiDeleteSceneScenesSceneIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenesApi
     */
    public deleteSceneScenesSceneIdDelete(requestParameters: ScenesApiDeleteSceneScenesSceneIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ScenesApiFp(this.configuration).deleteSceneScenesSceneIdDelete(requestParameters.sceneId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Scenes By Piece
     * @param {ScenesApiListScenesByPieceScenesPiecePieceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenesApi
     */
    public listScenesByPieceScenesPiecePieceIdGet(requestParameters: ScenesApiListScenesByPieceScenesPiecePieceIdGetRequest, options?: RawAxiosRequestConfig) {
        return ScenesApiFp(this.configuration).listScenesByPieceScenesPiecePieceIdGet(requestParameters.pieceId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reordonner Actions
     * @param {ScenesApiReordonnerActionsScenesSceneIdOrdrePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenesApi
     */
    public reordonnerActionsScenesSceneIdOrdrePut(requestParameters: ScenesApiReordonnerActionsScenesSceneIdOrdrePutRequest, options?: RawAxiosRequestConfig) {
        return ScenesApiFp(this.configuration).reordonnerActionsScenesSceneIdOrdrePut(requestParameters.sceneId, requestParameters.sceneOrdreForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Scene
     * @param {ScenesApiUpdateSceneScenesSceneIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenesApi
     */
    public updateSceneScenesSceneIdPatch(requestParameters: ScenesApiUpdateSceneScenesSceneIdPatchRequest, options?: RawAxiosRequestConfig) {
        return ScenesApiFp(this.configuration).updateSceneScenesSceneIdPatch(requestParameters.sceneId, requestParameters.sceneFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListScenesByPieceScenesPiecePieceIdGetSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListScenesByPieceScenesPiecePieceIdGetSortOrderEnum = typeof ListScenesByPieceScenesPiecePieceIdGetSortOrderEnum[keyof typeof ListScenesByPieceScenesPiecePieceIdGetSortOrderEnum];


/**
 * TroupesApi - axios parameter creator
 * @export
 */
export const TroupesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Troupe
         * @param {TroupeFormCreate} troupeFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTroupeTroupesPost: async (troupeFormCreate: TroupeFormCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'troupeFormCreate' is not null or undefined
            assertParamExists('createTroupeTroupesPost', 'troupeFormCreate', troupeFormCreate)
            const localVarPath = `/troupes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(troupeFormCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Troupe
         * @param {string} troupeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTroupeTroupesTroupeIdDelete: async (troupeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'troupeId' is not null or undefined
            assertParamExists('deleteTroupeTroupesTroupeIdDelete', 'troupeId', troupeId)
            const localVarPath = `/troupes/{troupe_id}`
                .replace(`{${"troupe_id"}}`, encodeURIComponent(String(troupeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Troupe
         * @param {string} troupeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTroupeTroupesTroupeIdGet: async (troupeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'troupeId' is not null or undefined
            assertParamExists('getTroupeTroupesTroupeIdGet', 'troupeId', troupeId)
            const localVarPath = `/troupes/{troupe_id}`
                .replace(`{${"troupe_id"}}`, encodeURIComponent(String(troupeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Troupes By User
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListTroupesByUserTroupesGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTroupesByUserTroupesGet: async (page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListTroupesByUserTroupesGetSortOrderEnum, search?: string | null, searchFields?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/troupes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['search_fields'] = searchFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Troupe
         * @param {string} troupeId 
         * @param {TroupeFormUpdate} troupeFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTroupeTroupesTroupeIdPatch: async (troupeId: string, troupeFormUpdate: TroupeFormUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'troupeId' is not null or undefined
            assertParamExists('updateTroupeTroupesTroupeIdPatch', 'troupeId', troupeId)
            // verify required parameter 'troupeFormUpdate' is not null or undefined
            assertParamExists('updateTroupeTroupesTroupeIdPatch', 'troupeFormUpdate', troupeFormUpdate)
            const localVarPath = `/troupes/{troupe_id}`
                .replace(`{${"troupe_id"}}`, encodeURIComponent(String(troupeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(troupeFormUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TroupesApi - functional programming interface
 * @export
 */
export const TroupesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TroupesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Troupe
         * @param {TroupeFormCreate} troupeFormCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTroupeTroupesPost(troupeFormCreate: TroupeFormCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessTroupeSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTroupeTroupesPost(troupeFormCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TroupesApi.createTroupeTroupesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Troupe
         * @param {string} troupeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTroupeTroupesTroupeIdDelete(troupeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessTroupeSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTroupeTroupesTroupeIdDelete(troupeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TroupesApi.deleteTroupeTroupesTroupeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Troupe
         * @param {string} troupeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTroupeTroupesTroupeIdGet(troupeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessTroupeSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTroupeTroupesTroupeIdGet(troupeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TroupesApi.getTroupeTroupesTroupeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Troupes By User
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {ListTroupesByUserTroupesGetSortOrderEnum} [sortOrder] 
         * @param {string | null} [search] 
         * @param {string | null} [searchFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTroupesByUserTroupesGet(page?: number, pageSize?: number, sortBy?: string | null, sortOrder?: ListTroupesByUserTroupesGetSortOrderEnum, search?: string | null, searchFields?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessListTroupeSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTroupesByUserTroupesGet(page, pageSize, sortBy, sortOrder, search, searchFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TroupesApi.listTroupesByUserTroupesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Troupe
         * @param {string} troupeId 
         * @param {TroupeFormUpdate} troupeFormUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTroupeTroupesTroupeIdPatch(troupeId: string, troupeFormUpdate: TroupeFormUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessTroupeSchemaLite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTroupeTroupesTroupeIdPatch(troupeId, troupeFormUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TroupesApi.updateTroupeTroupesTroupeIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TroupesApi - factory interface
 * @export
 */
export const TroupesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TroupesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Troupe
         * @param {TroupesApiCreateTroupeTroupesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTroupeTroupesPost(requestParameters: TroupesApiCreateTroupeTroupesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessTroupeSchemaLite> {
            return localVarFp.createTroupeTroupesPost(requestParameters.troupeFormCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Troupe
         * @param {TroupesApiDeleteTroupeTroupesTroupeIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTroupeTroupesTroupeIdDelete(requestParameters: TroupesApiDeleteTroupeTroupesTroupeIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessTroupeSchemaLite> {
            return localVarFp.deleteTroupeTroupesTroupeIdDelete(requestParameters.troupeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Troupe
         * @param {TroupesApiGetTroupeTroupesTroupeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTroupeTroupesTroupeIdGet(requestParameters: TroupesApiGetTroupeTroupesTroupeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessTroupeSchema> {
            return localVarFp.getTroupeTroupesTroupeIdGet(requestParameters.troupeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Troupes By User
         * @param {TroupesApiListTroupesByUserTroupesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTroupesByUserTroupesGet(requestParameters: TroupesApiListTroupesByUserTroupesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListTroupeSchemaLite> {
            return localVarFp.listTroupesByUserTroupesGet(requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Troupe
         * @param {TroupesApiUpdateTroupeTroupesTroupeIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTroupeTroupesTroupeIdPatch(requestParameters: TroupesApiUpdateTroupeTroupesTroupeIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessTroupeSchemaLite> {
            return localVarFp.updateTroupeTroupesTroupeIdPatch(requestParameters.troupeId, requestParameters.troupeFormUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TroupesApi - interface
 * @export
 * @interface TroupesApi
 */
export interface TroupesApiInterface {
    /**
     * 
     * @summary Create Troupe
     * @param {TroupesApiCreateTroupeTroupesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TroupesApiInterface
     */
    createTroupeTroupesPost(requestParameters: TroupesApiCreateTroupeTroupesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessTroupeSchemaLite>;

    /**
     * 
     * @summary Delete Troupe
     * @param {TroupesApiDeleteTroupeTroupesTroupeIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TroupesApiInterface
     */
    deleteTroupeTroupesTroupeIdDelete(requestParameters: TroupesApiDeleteTroupeTroupesTroupeIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessTroupeSchemaLite>;

    /**
     * 
     * @summary Get Troupe
     * @param {TroupesApiGetTroupeTroupesTroupeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TroupesApiInterface
     */
    getTroupeTroupesTroupeIdGet(requestParameters: TroupesApiGetTroupeTroupesTroupeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessTroupeSchema>;

    /**
     * 
     * @summary List Troupes By User
     * @param {TroupesApiListTroupesByUserTroupesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TroupesApiInterface
     */
    listTroupesByUserTroupesGet(requestParameters?: TroupesApiListTroupesByUserTroupesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessListTroupeSchemaLite>;

    /**
     * 
     * @summary Update Troupe
     * @param {TroupesApiUpdateTroupeTroupesTroupeIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TroupesApiInterface
     */
    updateTroupeTroupesTroupeIdPatch(requestParameters: TroupesApiUpdateTroupeTroupesTroupeIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<APISuccessTroupeSchemaLite>;

}

/**
 * Request parameters for createTroupeTroupesPost operation in TroupesApi.
 * @export
 * @interface TroupesApiCreateTroupeTroupesPostRequest
 */
export interface TroupesApiCreateTroupeTroupesPostRequest {
    /**
     * 
     * @type {TroupeFormCreate}
     * @memberof TroupesApiCreateTroupeTroupesPost
     */
    readonly troupeFormCreate: TroupeFormCreate
}

/**
 * Request parameters for deleteTroupeTroupesTroupeIdDelete operation in TroupesApi.
 * @export
 * @interface TroupesApiDeleteTroupeTroupesTroupeIdDeleteRequest
 */
export interface TroupesApiDeleteTroupeTroupesTroupeIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof TroupesApiDeleteTroupeTroupesTroupeIdDelete
     */
    readonly troupeId: string
}

/**
 * Request parameters for getTroupeTroupesTroupeIdGet operation in TroupesApi.
 * @export
 * @interface TroupesApiGetTroupeTroupesTroupeIdGetRequest
 */
export interface TroupesApiGetTroupeTroupesTroupeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TroupesApiGetTroupeTroupesTroupeIdGet
     */
    readonly troupeId: string
}

/**
 * Request parameters for listTroupesByUserTroupesGet operation in TroupesApi.
 * @export
 * @interface TroupesApiListTroupesByUserTroupesGetRequest
 */
export interface TroupesApiListTroupesByUserTroupesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof TroupesApiListTroupesByUserTroupesGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof TroupesApiListTroupesByUserTroupesGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof TroupesApiListTroupesByUserTroupesGet
     */
    readonly sortBy?: string | null

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof TroupesApiListTroupesByUserTroupesGet
     */
    readonly sortOrder?: ListTroupesByUserTroupesGetSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof TroupesApiListTroupesByUserTroupesGet
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof TroupesApiListTroupesByUserTroupesGet
     */
    readonly searchFields?: string | null
}

/**
 * Request parameters for updateTroupeTroupesTroupeIdPatch operation in TroupesApi.
 * @export
 * @interface TroupesApiUpdateTroupeTroupesTroupeIdPatchRequest
 */
export interface TroupesApiUpdateTroupeTroupesTroupeIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof TroupesApiUpdateTroupeTroupesTroupeIdPatch
     */
    readonly troupeId: string

    /**
     * 
     * @type {TroupeFormUpdate}
     * @memberof TroupesApiUpdateTroupeTroupesTroupeIdPatch
     */
    readonly troupeFormUpdate: TroupeFormUpdate
}

/**
 * TroupesApi - object-oriented interface
 * @export
 * @class TroupesApi
 * @extends {BaseAPI}
 */
export class TroupesApi extends BaseAPI implements TroupesApiInterface {
    /**
     * 
     * @summary Create Troupe
     * @param {TroupesApiCreateTroupeTroupesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TroupesApi
     */
    public createTroupeTroupesPost(requestParameters: TroupesApiCreateTroupeTroupesPostRequest, options?: RawAxiosRequestConfig) {
        return TroupesApiFp(this.configuration).createTroupeTroupesPost(requestParameters.troupeFormCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Troupe
     * @param {TroupesApiDeleteTroupeTroupesTroupeIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TroupesApi
     */
    public deleteTroupeTroupesTroupeIdDelete(requestParameters: TroupesApiDeleteTroupeTroupesTroupeIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TroupesApiFp(this.configuration).deleteTroupeTroupesTroupeIdDelete(requestParameters.troupeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Troupe
     * @param {TroupesApiGetTroupeTroupesTroupeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TroupesApi
     */
    public getTroupeTroupesTroupeIdGet(requestParameters: TroupesApiGetTroupeTroupesTroupeIdGetRequest, options?: RawAxiosRequestConfig) {
        return TroupesApiFp(this.configuration).getTroupeTroupesTroupeIdGet(requestParameters.troupeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Troupes By User
     * @param {TroupesApiListTroupesByUserTroupesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TroupesApi
     */
    public listTroupesByUserTroupesGet(requestParameters: TroupesApiListTroupesByUserTroupesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return TroupesApiFp(this.configuration).listTroupesByUserTroupesGet(requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.searchFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Troupe
     * @param {TroupesApiUpdateTroupeTroupesTroupeIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TroupesApi
     */
    public updateTroupeTroupesTroupeIdPatch(requestParameters: TroupesApiUpdateTroupeTroupesTroupeIdPatchRequest, options?: RawAxiosRequestConfig) {
        return TroupesApiFp(this.configuration).updateTroupeTroupesTroupeIdPatch(requestParameters.troupeId, requestParameters.troupeFormUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListTroupesByUserTroupesGetSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListTroupesByUserTroupesGetSortOrderEnum = typeof ListTroupesByUserTroupesGetSortOrderEnum[keyof typeof ListTroupesByUserTroupesGetSortOrderEnum];


